import * as React from "react";
import React__default, { forwardRef, createContext as createContext$1, useContext, useMemo, createElement as createElement$1, useCallback, Children, isValidElement, cloneElement, Fragment as Fragment$1, useEffect, useLayoutEffect as useLayoutEffect$1, useRef, useState, useReducer } from "react";
import * as $7SXl2$reactdom from "react-dom";
import $7SXl2$reactdom__default, { flushSync, createPortal } from "react-dom";
import TextareaAutosize from "react-textarea-autosize";
var e = "colors",
  t$1 = "sizes",
  r$1 = "space",
  n$2 = {
    gap: r$1,
    gridGap: r$1,
    columnGap: r$1,
    gridColumnGap: r$1,
    rowGap: r$1,
    gridRowGap: r$1,
    inset: r$1,
    insetBlock: r$1,
    insetBlockEnd: r$1,
    insetBlockStart: r$1,
    insetInline: r$1,
    insetInlineEnd: r$1,
    insetInlineStart: r$1,
    margin: r$1,
    marginTop: r$1,
    marginRight: r$1,
    marginBottom: r$1,
    marginLeft: r$1,
    marginBlock: r$1,
    marginBlockEnd: r$1,
    marginBlockStart: r$1,
    marginInline: r$1,
    marginInlineEnd: r$1,
    marginInlineStart: r$1,
    padding: r$1,
    paddingTop: r$1,
    paddingRight: r$1,
    paddingBottom: r$1,
    paddingLeft: r$1,
    paddingBlock: r$1,
    paddingBlockEnd: r$1,
    paddingBlockStart: r$1,
    paddingInline: r$1,
    paddingInlineEnd: r$1,
    paddingInlineStart: r$1,
    top: r$1,
    right: r$1,
    bottom: r$1,
    left: r$1,
    scrollMargin: r$1,
    scrollMarginTop: r$1,
    scrollMarginRight: r$1,
    scrollMarginBottom: r$1,
    scrollMarginLeft: r$1,
    scrollMarginX: r$1,
    scrollMarginY: r$1,
    scrollMarginBlock: r$1,
    scrollMarginBlockEnd: r$1,
    scrollMarginBlockStart: r$1,
    scrollMarginInline: r$1,
    scrollMarginInlineEnd: r$1,
    scrollMarginInlineStart: r$1,
    scrollPadding: r$1,
    scrollPaddingTop: r$1,
    scrollPaddingRight: r$1,
    scrollPaddingBottom: r$1,
    scrollPaddingLeft: r$1,
    scrollPaddingX: r$1,
    scrollPaddingY: r$1,
    scrollPaddingBlock: r$1,
    scrollPaddingBlockEnd: r$1,
    scrollPaddingBlockStart: r$1,
    scrollPaddingInline: r$1,
    scrollPaddingInlineEnd: r$1,
    scrollPaddingInlineStart: r$1,
    fontSize: "fontSizes",
    background: e,
    backgroundColor: e,
    backgroundImage: e,
    borderImage: e,
    border: e,
    borderBlock: e,
    borderBlockEnd: e,
    borderBlockStart: e,
    borderBottom: e,
    borderBottomColor: e,
    borderColor: e,
    borderInline: e,
    borderInlineEnd: e,
    borderInlineStart: e,
    borderLeft: e,
    borderLeftColor: e,
    borderRight: e,
    borderRightColor: e,
    borderTop: e,
    borderTopColor: e,
    caretColor: e,
    color: e,
    columnRuleColor: e,
    fill: e,
    outline: e,
    outlineColor: e,
    stroke: e,
    textDecorationColor: e,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: t$1,
    minBlockSize: t$1,
    maxBlockSize: t$1,
    inlineSize: t$1,
    minInlineSize: t$1,
    maxInlineSize: t$1,
    width: t$1,
    minWidth: t$1,
    maxWidth: t$1,
    height: t$1,
    minHeight: t$1,
    maxHeight: t$1,
    flexBasis: t$1,
    gridTemplateColumns: t$1,
    gridTemplateRows: t$1,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
  },
  i$1 = (e2, t2) => typeof t2 == "function" ? {
    "()": Function.prototype.toString.call(t2)
  } : t2,
  o$1 = () => {
    const e2 = /* @__PURE__ */Object.create(null);
    return function (t2, r2) {
      const o2 = (e3 => JSON.stringify(e3, i$1))(t2);
      for (var _len3 = arguments.length, n2 = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        n2[_key3 - 2] = arguments[_key3];
      }
      return o2 in e2 ? e2[o2] : e2[o2] = r2(t2, ...n2);
    };
  },
  l$1 = Symbol.for("sxs.internal"),
  s = (e2, t2) => Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)),
  a$1 = e2 => {
    for (const t2 in e2) return true;
    return false;
  },
  {
    hasOwnProperty: c
  } = Object.prototype,
  d$1 = e2 => e2.includes("-") ? e2 : e2.replace(/[A-Z]/g, e3 => "-" + e3.toLowerCase()),
  g$1 = /\s+(?![^()]*\))/,
  p$3 = e2 => t2 => e2(...(typeof t2 == "string" ? String(t2).split(g$1) : [t2])),
  u$1 = {
    appearance: e2 => ({
      WebkitAppearance: e2,
      appearance: e2
    }),
    backfaceVisibility: e2 => ({
      WebkitBackfaceVisibility: e2,
      backfaceVisibility: e2
    }),
    backdropFilter: e2 => ({
      WebkitBackdropFilter: e2,
      backdropFilter: e2
    }),
    backgroundClip: e2 => ({
      WebkitBackgroundClip: e2,
      backgroundClip: e2
    }),
    boxDecorationBreak: e2 => ({
      WebkitBoxDecorationBreak: e2,
      boxDecorationBreak: e2
    }),
    clipPath: e2 => ({
      WebkitClipPath: e2,
      clipPath: e2
    }),
    content: e2 => ({
      content: e2.includes('"') || e2.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e2) ? e2 : `"${e2}"`
    }),
    hyphens: e2 => ({
      WebkitHyphens: e2,
      hyphens: e2
    }),
    maskImage: e2 => ({
      WebkitMaskImage: e2,
      maskImage: e2
    }),
    maskSize: e2 => ({
      WebkitMaskSize: e2,
      maskSize: e2
    }),
    tabSize: e2 => ({
      MozTabSize: e2,
      tabSize: e2
    }),
    textSizeAdjust: e2 => ({
      WebkitTextSizeAdjust: e2,
      textSizeAdjust: e2
    }),
    userSelect: e2 => ({
      WebkitUserSelect: e2,
      userSelect: e2
    }),
    marginBlock: p$3((e2, t2) => ({
      marginBlockStart: e2,
      marginBlockEnd: t2 || e2
    })),
    marginInline: p$3((e2, t2) => ({
      marginInlineStart: e2,
      marginInlineEnd: t2 || e2
    })),
    maxSize: p$3((e2, t2) => ({
      maxBlockSize: e2,
      maxInlineSize: t2 || e2
    })),
    minSize: p$3((e2, t2) => ({
      minBlockSize: e2,
      minInlineSize: t2 || e2
    })),
    paddingBlock: p$3((e2, t2) => ({
      paddingBlockStart: e2,
      paddingBlockEnd: t2 || e2
    })),
    paddingInline: p$3((e2, t2) => ({
      paddingInlineStart: e2,
      paddingInlineEnd: t2 || e2
    }))
  },
  h$2 = /([\d.]+)([^]*)/,
  f$2 = (e2, t2) => e2.length ? e2.reduce((e3, r2) => (e3.push(...t2.map(e4 => e4.includes("&") ? e4.replace(/&/g, /[ +>|~]/.test(r2) && /&.*&/.test(e4) ? `:is(${r2})` : r2) : r2 + " " + e4)), e3), []) : t2,
  m$2 = (e2, t2) => e2 in b$1 && typeof t2 == "string" ? t2.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t3, r2, n2, i2) => r2 + (n2 === "stretch" ? `-moz-available${i2};${d$1(e2)}:${r2}-webkit-fill-available` : `-moz-fit-content${i2};${d$1(e2)}:${r2}fit-content`) + i2) : String(t2),
  b$1 = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
  },
  S = e2 => e2 ? e2 + "-" : "",
  k = (e2, t2, r2) => e2.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e3, n2, i2, o2, l2) => o2 == "$" == !!i2 ? e3 : (n2 || o2 == "--" ? "calc(" : "") + "var(--" + (o2 === "$" ? S(t2) + (l2.includes("$") ? "" : S(r2)) + l2.replace(/\$/g, "-") : l2) + ")" + (n2 || o2 == "--" ? "*" + (n2 || "") + (i2 || "1") + ")" : "")),
  y = /\s*,\s*(?![^()]*\))/,
  B = Object.prototype.toString,
  $ = (e2, t2, r2, n2, i2) => {
    let o2, l2, s2;
    const a2 = (e3, t3, r3) => {
      let c2, g2;
      const p2 = e4 => {
        for (c2 in e4) {
          const R2 = c2.charCodeAt(0) === 64,
            z2 = R2 && Array.isArray(e4[c2]) ? e4[c2] : [e4[c2]];
          for (g2 of z2) {
            const e5 = /[A-Z]/.test($2 = c2) ? $2 : $2.replace(/-[^]/g, e6 => e6[1].toUpperCase()),
              z3 = typeof g2 == "object" && g2 && g2.toString === B && (!n2.utils[e5] || !t3.length);
            if (e5 in n2.utils && !z3) {
              const t4 = n2.utils[e5];
              if (t4 !== l2) {
                l2 = t4, p2(t4(g2)), l2 = null;
                continue;
              }
            } else if (e5 in u$1) {
              const t4 = u$1[e5];
              if (t4 !== s2) {
                s2 = t4, p2(t4(g2)), s2 = null;
                continue;
              }
            }
            if (R2 && (b2 = c2.slice(1) in n2.media ? "@media " + n2.media[c2.slice(1)] : c2, c2 = b2.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e6, t4, r4, n3, i3, o3) => {
              const l3 = h$2.test(t4),
                s3 = 0.0625 * (l3 ? -1 : 1),
                [a3, c3] = l3 ? [n3, t4] : [t4, n3];
              return "(" + (r4[0] === "=" ? "" : r4[0] === ">" === l3 ? "max-" : "min-") + a3 + ":" + (r4[0] !== "=" && r4.length === 1 ? c3.replace(h$2, (e7, t5, n4) => Number(t5) + s3 * (r4 === ">" ? 1 : -1) + n4) : c3) + (i3 ? ") and (" + (i3[0] === ">" ? "min-" : "max-") + a3 + ":" + (i3.length === 1 ? o3.replace(h$2, (e7, t5, r5) => Number(t5) + s3 * (i3 === ">" ? -1 : 1) + r5) : o3) : "") + ")";
            })), z3) {
              const e6 = R2 ? r3.concat(c2) : [...r3],
                n3 = R2 ? [...t3] : f$2(t3, c2.split(y));
              o2 !== void 0 && i2(x$1(...o2)), o2 = void 0, a2(g2, n3, e6);
            } else o2 === void 0 && (o2 = [[], t3, r3]), c2 = R2 || c2.charCodeAt(0) !== 36 ? c2 : `--${S(n2.prefix)}${c2.slice(1).replace(/\$/g, "-")}`, g2 = z3 ? g2 : typeof g2 == "number" ? g2 && e5 in I ? String(g2) + "px" : String(g2) : k(m$2(e5, g2 == null ? "" : g2), n2.prefix, n2.themeMap[e5]), o2[0].push(`${R2 ? `${c2} ` : `${d$1(c2)}:`}${g2}`);
          }
        }
        var b2, $2;
      };
      p2(e3), o2 !== void 0 && i2(x$1(...o2)), o2 = void 0;
    };
    a2(e2, t2, r2);
  },
  x$1 = (e2, t2, r2) => `${r2.map(e3 => `${e3}{`).join("")}${t2.length ? `${t2.join(",")}{` : ""}${e2.join(";")}${t2.length ? "}" : ""}${Array(r2.length ? r2.length + 1 : 0).join("}")}`,
  I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
  },
  R = e2 => String.fromCharCode(e2 + (e2 > 25 ? 39 : 97)),
  z = e2 => (e3 => {
    let t2,
      r2 = "";
    for (t2 = Math.abs(e3); t2 > 52; t2 = t2 / 52 | 0) r2 = R(t2 % 52) + r2;
    return R(t2 % 52) + r2;
  })(((e3, t2) => {
    let r2 = t2.length;
    for (; r2;) e3 = 33 * e3 ^ t2.charCodeAt(--r2);
    return e3;
  })(5381, JSON.stringify(e2)) >>> 0),
  W = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"],
  j = e2 => {
    if (e2.href && !e2.href.startsWith(location.origin)) return false;
    try {
      return !!e2.cssRules;
    } catch (e3) {
      return false;
    }
  },
  E = e2 => {
    let t2;
    const r2 = () => {
        const {
          cssRules: e3
        } = t2.sheet;
        return [].map.call(e3, (r3, n3) => {
          const {
            cssText: i2
          } = r3;
          let o2 = "";
          if (i2.startsWith("--sxs")) return "";
          if (e3[n3 - 1] && (o2 = e3[n3 - 1].cssText).startsWith("--sxs")) {
            if (!r3.cssRules.length) return "";
            for (const e4 in t2.rules) if (t2.rules[e4].group === r3) return `--sxs{--sxs:${[...t2.rules[e4].cache].join(" ")}}${i2}`;
            return r3.cssRules.length ? `${o2}${i2}` : "";
          }
          return i2;
        }).join("");
      },
      n2 = () => {
        if (t2) {
          const {
            rules: e3,
            sheet: r3
          } = t2;
          if (!r3.deleteRule) {
            for (; Object(Object(r3.cssRules)[0]).type === 3;) r3.cssRules.splice(0, 1);
            r3.cssRules = [];
          }
          for (const t3 in e3) delete e3[t3];
        }
        const i2 = Object(e2).styleSheets || [];
        for (const e3 of i2) if (j(e3)) {
          for (let i3 = 0, o3 = e3.cssRules; o3[i3]; ++i3) {
            const l3 = Object(o3[i3]);
            if (l3.type !== 1) continue;
            const s2 = Object(o3[i3 + 1]);
            if (s2.type !== 4) continue;
            ++i3;
            const {
              cssText: a2
            } = l3;
            if (!a2.startsWith("--sxs")) continue;
            const c2 = a2.slice(14, -3).trim().split(/\s+/),
              d2 = W[c2[0]];
            d2 && (t2 || (t2 = {
              sheet: e3,
              reset: n2,
              rules: {},
              toString: r2
            }), t2.rules[d2] = {
              group: s2,
              index: i3,
              cache: new Set(c2)
            });
          }
          if (t2) break;
        }
        if (!t2) {
          const i3 = (e3, t3) => ({
            type: t3,
            cssRules: [],
            insertRule(e4, t4) {
              this.cssRules.splice(t4, 0, i3(e4, {
                import: 3,
                undefined: 1
              }[(e4.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
            },
            get cssText() {
              return e3 === "@media{}" ? `@media{${[].map.call(this.cssRules, e4 => e4.cssText).join("")}}` : e3;
            }
          });
          t2 = {
            sheet: e2 ? (e2.head || e2).appendChild(document.createElement("style")).sheet : i3("", "text/css"),
            rules: {},
            reset: n2,
            toString: r2
          };
        }
        const {
          sheet: o2,
          rules: l2
        } = t2;
        for (let e3 = W.length - 1; e3 >= 0; --e3) {
          const t3 = W[e3];
          if (!l2[t3]) {
            const r3 = W[e3 + 1],
              n3 = l2[r3] ? l2[r3].index : o2.cssRules.length;
            o2.insertRule("@media{}", n3), o2.insertRule(`--sxs{--sxs:${e3}}`, n3), l2[t3] = {
              group: o2.cssRules[n3 + 1],
              index: n3,
              cache: /* @__PURE__ */new Set([e3])
            };
          }
          v(l2[t3]);
        }
      };
    return n2(), t2;
  },
  v = e2 => {
    const t2 = e2.group;
    let r2 = t2.cssRules.length;
    e2.apply = e3 => {
      try {
        t2.insertRule(e3, r2), ++r2;
      } catch (e4) {}
    };
  },
  T = Symbol(),
  w$1 = o$1(),
  M = (e2, t2) => w$1(e2, () => function () {
    let n2 = {
      type: null,
      composers: /* @__PURE__ */new Set()
    };
    for (var _len4 = arguments.length, r2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      r2[_key4] = arguments[_key4];
    }
    for (const t3 of r2) if (t3 != null) if (t3[l$1]) {
      n2.type == null && (n2.type = t3[l$1].type);
      for (const e3 of t3[l$1].composers) n2.composers.add(e3);
    } else t3.constructor !== Object || t3.$$typeof ? n2.type == null && (n2.type = t3) : n2.composers.add(C(t3, e2));
    return n2.type == null && (n2.type = "span"), n2.composers.size || n2.composers.add(["PJLV", {}, [], [], {}, []]), P(e2, n2, t2);
  }),
  C = (_ref4, i2) => {
    let {
      variants: e2,
      compoundVariants: t2,
      defaultVariants: r2,
      ...n2
    } = _ref4;
    const o2 = `${S(i2.prefix)}c-${z(n2)}`,
      l2 = [],
      s2 = [],
      d2 = /* @__PURE__ */Object.create(null),
      g2 = [];
    for (const e3 in r2) d2[e3] = String(r2[e3]);
    if (typeof e2 == "object" && e2) for (const t3 in e2) {
      p2 = d2, u2 = t3, c.call(p2, u2) || (d2[t3] = "undefined");
      const r3 = e2[t3];
      for (const e3 in r3) {
        const n3 = {
          [t3]: String(e3)
        };
        String(e3) === "undefined" && g2.push(t3);
        const i3 = r3[e3],
          o3 = [n3, i3, !a$1(i3)];
        l2.push(o3);
      }
    }
    var p2, u2;
    if (typeof t2 == "object" && t2) for (const e3 of t2) {
      let {
        css: t3,
        ...r3
      } = e3;
      t3 = typeof t3 == "object" && t3 || {};
      for (const e4 in r3) r3[e4] = String(r3[e4]);
      const n3 = [r3, t3, !a$1(t3)];
      s2.push(n3);
    }
    return [o2, n2, l2, s2, d2, g2];
  },
  P = (e2, t2, r2) => {
    const [n2, i2, o2, a2] = L(t2.composers),
      c2 = typeof t2.type == "function" || t2.type.$$typeof ? (e3 => {
        function t3() {
          for (let r3 = 0; r3 < t3[T].length; r3++) {
            const [n3, i3] = t3[T][r3];
            e3.rules[n3].apply(i3);
          }
          return t3[T] = [], null;
        }
        return t3[T] = [], t3.rules = {}, W.forEach(e4 => t3.rules[e4] = {
          apply: r3 => t3[T].push([e4, r3])
        }), t3;
      })(r2) : null,
      d2 = (c2 || r2).rules,
      g2 = `.${n2}${i2.length > 1 ? `:where(.${i2.slice(1).join(".")})` : ""}`,
      p2 = l2 => {
        l2 = typeof l2 == "object" && l2 || A;
        const {
            css: s2,
            ...p3
          } = l2,
          u2 = {};
        for (const e3 in o2) if (delete p3[e3], e3 in l2) {
          let t3 = l2[e3];
          typeof t3 == "object" && t3 ? u2[e3] = {
            "@initial": o2[e3],
            ...t3
          } : (t3 = String(t3), u2[e3] = t3 !== "undefined" || a2.has(e3) ? t3 : o2[e3]);
        } else u2[e3] = o2[e3];
        const h2 = /* @__PURE__ */new Set([...i2]);
        for (const [n3, i3, o3, l3] of t2.composers) {
          r2.rules.styled.cache.has(n3) || (r2.rules.styled.cache.add(n3), $(i3, [`.${n3}`], [], e2, e3 => {
            d2.styled.apply(e3);
          }));
          const t3 = O(o3, u2, e2.media),
            s3 = O(l3, u2, e2.media, true);
          for (const i4 of t3) if (i4 !== void 0) for (const [t4, o4, l4] of i4) {
            const i5 = `${n3}-${z(o4)}-${t4}`;
            h2.add(i5);
            const s4 = (l4 ? r2.rules.resonevar : r2.rules.onevar).cache,
              a3 = l4 ? d2.resonevar : d2.onevar;
            s4.has(i5) || (s4.add(i5), $(o4, [`.${i5}`], [], e2, e3 => {
              a3.apply(e3);
            }));
          }
          for (const t4 of s3) if (t4 !== void 0) for (const [i4, o4] of t4) {
            const t5 = `${n3}-${z(o4)}-${i4}`;
            h2.add(t5), r2.rules.allvar.cache.has(t5) || (r2.rules.allvar.cache.add(t5), $(o4, [`.${t5}`], [], e2, e3 => {
              d2.allvar.apply(e3);
            }));
          }
        }
        if (typeof s2 == "object" && s2) {
          const t3 = `${n2}-i${z(s2)}-css`;
          h2.add(t3), r2.rules.inline.cache.has(t3) || (r2.rules.inline.cache.add(t3), $(s2, [`.${t3}`], [], e2, e3 => {
            d2.inline.apply(e3);
          }));
        }
        for (const e3 of String(l2.className || "").trim().split(/\s+/)) e3 && h2.add(e3);
        const f2 = p3.className = [...h2].join(" ");
        return {
          type: t2.type,
          className: f2,
          selector: g2,
          props: p3,
          toString: () => f2,
          deferredInjector: c2
        };
      };
    return s(p2, {
      className: n2,
      selector: g2,
      [l$1]: t2,
      toString: () => (r2.rules.styled.cache.has(n2) || p2(), n2)
    });
  },
  L = e2 => {
    let t2 = "";
    const r2 = [],
      n2 = {},
      i2 = [];
    for (const [o2,,,, l2, s2] of e2) {
      t2 === "" && (t2 = o2), r2.push(o2), i2.push(...s2);
      for (const e3 in l2) {
        const t3 = l2[e3];
        (n2[e3] === void 0 || t3 !== "undefined" || s2.includes(t3)) && (n2[e3] = t3);
      }
    }
    return [t2, r2, n2, new Set(i2)];
  },
  O = (e2, t2, r2, n2) => {
    const i2 = [];
    e: for (let [o2, l2, s2] of e2) {
      if (s2) continue;
      let e3,
        a2 = 0,
        c2 = false;
      for (e3 in o2) {
        const n3 = o2[e3];
        let i3 = t2[e3];
        if (i3 !== n3) {
          if (typeof i3 != "object" || !i3) continue e;
          {
            let e4,
              t3,
              o3 = 0;
            for (const l3 in i3) {
              if (n3 === String(i3[l3])) {
                if (l3 !== "@initial") {
                  const e5 = l3.slice(1);
                  (t3 = t3 || []).push(e5 in r2 ? r2[e5] : l3.replace(/^@media ?/, "")), c2 = true;
                }
                a2 += o3, e4 = true;
              }
              ++o3;
            }
            if (t3 && t3.length && (l2 = {
              ["@media " + t3.join(", ")]: l2
            }), !e4) continue e;
          }
        }
      }
      (i2[a2] = i2[a2] || []).push([n2 ? "cv" : `${e3}-${o2[e3]}`, l2, c2]);
    }
    return i2;
  },
  A = {},
  N = o$1(),
  D = (e2, t2) => N(e2, () => function () {
    for (var _len5 = arguments.length, r2 = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      r2[_key5] = arguments[_key5];
    }
    const n2 = () => {
      for (let n3 of r2) {
        n3 = typeof n3 == "object" && n3 || {};
        let r3 = z(n3);
        if (!t2.rules.global.cache.has(r3)) {
          if (t2.rules.global.cache.add(r3), "@import" in n3) {
            let e3 = [].indexOf.call(t2.sheet.cssRules, t2.rules.themed.group) - 1;
            for (let r4 of [].concat(n3["@import"])) r4 = r4.includes('"') || r4.includes("'") ? r4 : `"${r4}"`, t2.sheet.insertRule(`@import ${r4};`, e3++);
            delete n3["@import"];
          }
          $(n3, [], [], e2, e3 => {
            t2.rules.global.apply(e3);
          });
        }
      }
      return "";
    };
    return s(n2, {
      toString: n2
    });
  }),
  H = o$1(),
  V = (e2, t2) => H(e2, () => r2 => {
    const n2 = `${S(e2.prefix)}k-${z(r2)}`,
      i2 = () => {
        if (!t2.rules.global.cache.has(n2)) {
          t2.rules.global.cache.add(n2);
          const i3 = [];
          $(r2, [], [], e2, e3 => i3.push(e3));
          const o2 = `@keyframes ${n2}{${i3.join("")}}`;
          t2.rules.global.apply(o2);
        }
        return n2;
      };
    return s(i2, {
      get name() {
        return i2();
      },
      toString: i2
    });
  }),
  G = class {
    constructor(e2, t2, r2, n2) {
      this.token = e2 == null ? "" : String(e2), this.value = t2 == null ? "" : String(t2), this.scale = r2 == null ? "" : String(r2), this.prefix = n2 == null ? "" : String(n2);
    }
    get computedValue() {
      return "var(" + this.variable + ")";
    }
    get variable() {
      return "--" + S(this.prefix) + S(this.scale) + this.token;
    }
    toString() {
      return this.computedValue;
    }
  },
  F = o$1(),
  J = (e2, t2) => F(e2, () => (r2, n2) => {
    n2 = typeof r2 == "object" && r2 || Object(n2);
    const i2 = `.${r2 = (r2 = typeof r2 == "string" ? r2 : "") || `${S(e2.prefix)}t-${z(n2)}`}`,
      o2 = {},
      l2 = [];
    for (const t3 in n2) {
      o2[t3] = {};
      for (const r3 in n2[t3]) {
        const i3 = `--${S(e2.prefix)}${t3}-${r3}`,
          s3 = k(String(n2[t3][r3]), e2.prefix, t3);
        o2[t3][r3] = new G(r3, s3, t3, e2.prefix), l2.push(`${i3}:${s3}`);
      }
    }
    const s2 = () => {
      if (l2.length && !t2.rules.themed.cache.has(r2)) {
        t2.rules.themed.cache.add(r2);
        const i3 = `${n2 === e2.theme ? ":root," : ""}.${r2}{${l2.join(";")}}`;
        t2.rules.themed.apply(i3);
      }
      return r2;
    };
    return {
      ...o2,
      get className() {
        return s2();
      },
      selector: i2,
      toString: s2
    };
  }),
  U = o$1();
var Y = o$1(),
  q$1 = e2 => {
    const t2 = (e3 => {
      let t3 = false;
      const r2 = U(e3, e4 => {
        t3 = true;
        const r3 = "prefix" in (e4 = typeof e4 == "object" && e4 || {}) ? String(e4.prefix) : "",
          i2 = typeof e4.media == "object" && e4.media || {},
          o2 = typeof e4.root == "object" ? e4.root || null : globalThis.document || null,
          l2 = typeof e4.theme == "object" && e4.theme || {},
          s2 = {
            prefix: r3,
            media: i2,
            theme: l2,
            themeMap: typeof e4.themeMap == "object" && e4.themeMap || {
              ...n$2
            },
            utils: typeof e4.utils == "object" && e4.utils || {}
          },
          a2 = E(o2),
          c2 = {
            css: M(s2, a2),
            globalCss: D(s2, a2),
            keyframes: V(s2, a2),
            createTheme: J(s2, a2),
            reset() {
              a2.reset(), c2.theme.toString();
            },
            theme: {},
            sheet: a2,
            config: s2,
            prefix: r3,
            getCssText: a2.toString,
            toString: a2.toString
          };
        return String(c2.theme = c2.createTheme(l2)), c2;
      });
      return t3 || r2.reset(), r2;
    })(e2);
    return t2.styled = (_ref5 => {
      let {
        config: e3,
        sheet: t3
      } = _ref5;
      return Y(e3, () => {
        const r2 = M(e3, t3);
        return function () {
          const t4 = r2(...arguments),
            n2 = t4[l$1].type,
            i2 = React__default.forwardRef((e5, r3) => {
              const i3 = e5 && e5.as || n2,
                {
                  props: o2,
                  deferredInjector: l2
                } = t4(e5);
              return delete o2.as, o2.ref = r3, l2 ? React__default.createElement(React__default.Fragment, null, React__default.createElement(i3, o2), React__default.createElement(l2, null)) : React__default.createElement(i3, o2);
            });
          return i2.className = t4.className, i2.displayName = `Styled.${n2.displayName || n2.name || n2}`, i2.selector = t4.selector, i2.toString = () => t4.selector, i2[l$1] = t4[l$1], i2;
        };
      });
    })(t2), t2;
  };
const globalStyles = {
  html: {
    fontFamily: "$primary",
    fontSize: "$base",
    letterSpacing: "normal",
    lineHeight: "$base",
    overflowX: "hidden",
    textRendering: "optimizeLegibility",
    textSizeAdjust: "100%",
    boxSizing: "border-box"
  },
  "*": {
    boxSizing: "inherit"
  },
  "*::before": {
    boxSizing: "inherit"
  },
  "*::after": {
    boxSizing: "inherit"
  },
  body: {
    margin: 0,
    padding: 0,
    fontFamily: "$primary",
    textStyles: "body",
    color: "$body"
  },
  "@font-face": [{
    fontFamily: "proxima",
    fontStyle: "normal",
    fontWeight: "400",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "italic",
    fontWeight: "400",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular-italic.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular-italic.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "normal",
    fontWeight: "700",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "italic",
    fontWeight: "700",
    src: "url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold-italic.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold-italic.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "normal",
    fontWeight: "600",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-semibold.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-semibold.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "italic",
    fontWeight: "600",
    src: "url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-condensed-semibold-italic.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-condensed-semibold-italic.woff2') format('woff2')"
  }]
};
const gray = {
  gray1: "#FEFEFE",
  gray2: "#F3F6F8",
  gray3: "#DFE4E8",
  gray4: "#BDC6CB",
  gray5: "#A3AEB5",
  gray6: "#939FA6",
  gray7: "#788790",
  gray8: "#606E78",
  gray9: "#505D67",
  gray10: "#424D54",
  gray11: "#353E43",
  gray12: "#1D2226"
};
const blue = {
  blue1: "#F3F8FE",
  blue2: "#DCECFE",
  blue3: "#BBDBFE",
  blue4: "#92C6FE",
  blue5: "#72AEF4",
  blue6: "#5196ED",
  blue7: "#2A7EEA",
  blue8: "#086BD5",
  blue9: "#105CAE",
  blue10: "#0E4D92",
  blue11: "#083F79",
  blue12: "#092A4F"
};
const red = {
  red1: "#FEEAEA",
  red2: "#FEDCD8",
  red3: "#FEBFB9",
  red4: "#FD9F97",
  red5: "#FB7C71",
  red6: "#F05B4D",
  red7: "#E5352A",
  red8: "#C7291B",
  red9: "#A32D22",
  red10: "#862A22",
  red11: "#6D231C",
  red12: "#431A16"
};
const green = {
  green1: "#F5FBF4",
  green2: "#E5F8E2",
  green3: "#B6F1AC",
  green4: "#78EB69",
  green5: "#4CC949",
  green6: "#24B232",
  green7: "#0F9C28",
  green8: "#0C8228",
  green9: "#0C7331",
  green10: "#0B6135",
  green11: "#184F32",
  green12: "#193726"
};
const yellow = {
  yellow1: "#FEFAED",
  yellow2: "#FEF3D2",
  yellow3: "#FEDF83",
  yellow4: "#FECC3A",
  yellow5: "#EAAD07",
  yellow6: "#D89708",
  yellow7: "#B2801D",
  yellow8: "#8E6923",
  yellow9: "#765923",
  yellow10: "#644D22",
  yellow11: "#52401F",
  yellow12: "#3C2F1A"
};
const teal = {
  teal1: "#F0FDFE",
  teal2: "#D4F2F6",
  teal3: "#AAE4EA",
  teal4: "#7AD1D9",
  teal5: "#5BB9C2",
  teal6: "#4BA1A9",
  teal7: "#448A90",
  teal8: "#3B767B",
  teal9: "#326368",
  teal10: "#2B5256",
  teal11: "#244345",
  teal12: "#1A2B2D"
};
const indigo = {
  indigo1: "#F9F9FC",
  indigo2: "#E9EBF8",
  indigo3: "#D6D9F6",
  indigo4: "#BEC1F9",
  indigo5: "#A5A8F6",
  indigo6: "#8C92E7",
  indigo7: "#757CD9",
  indigo8: "#6066CE",
  indigo9: "#4F54C6",
  indigo10: "#4441B7",
  indigo11: "#3C2FA6",
  indigo12: "#1F1C85"
};
const purple = {
  purple1: "#FBF9FC",
  purple2: "#F3E9F9",
  purple3: "#ECD3F9",
  purple4: "#E5B5FC",
  purple5: "#CF9EEA",
  purple6: "#B987D9",
  purple7: "#A471C9",
  purple8: "#8F59B8",
  purple9: "#8248AE",
  purple10: "#6F3C96",
  purple11: "#5A3577",
  purple12: "#3C284D"
};
const pink = {
  pink1: "#FBF6F9",
  pink2: "#F8E5F2",
  pink3: "#F7D1EA",
  pink4: "#EFB4D9",
  pink5: "#E199C4",
  pink6: "#D47EAF",
  pink7: "#C7649C",
  pink8: "#B94687",
  pink9: "#AE2F79",
  pink10: "#A00C69",
  pink11: "#801C56",
  pink12: "#541D3A"
};
const orange = {
  orange1: "#FAF7EC",
  orange2: "#F8ECCE",
  orange3: "#F7DFA9",
  orange4: "#F0BD6B",
  orange5: "#E6A152",
  orange6: "#D8863D",
  orange7: "#C66F2F",
  orange8: "#B25722",
  orange9: "#9D4C20",
  orange10: "#834320",
  orange11: "#6B391F",
  orange12: "#482A19"
};
const lime = {
  lime1: "#F5FDE8",
  lime2: "#E8FBB8",
  lime3: "#C6FD03",
  lime4: "#B4E324",
  lime5: "#99BE32",
  lime6: "#829F36",
  lime7: "#6D8435",
  lime8: "#617332",
  lime9: "#4F5E2E",
  lime10: "#47532B",
  lime11: "#394224",
  lime12: "#282E1C"
};
const cyan = {
  cyan1: "#D5FDFA",
  cyan2: "#80FEF9",
  cyan3: "#03F0F0",
  cyan4: "#04D8DD",
  cyan5: "#01BFCB",
  cyan6: "#12A6BF",
  cyan7: "#2A90A5",
  cyan8: "#317A8A",
  cyan9: "#326976",
  cyan10: "#2F5963",
  cyan11: "#2B4951",
  cyan12: "#223338"
};
var systemColors = {
  blue,
  gray,
  red,
  yellow,
  green,
  teal,
  pink,
  indigo,
  purple,
  orange,
  lime,
  cyan
};
var defaultTheme = {
  prefix: "drift-dds",
  theme: {
    colors: {
      ...systemColors.gray,
      ...systemColors.blue,
      ...systemColors.red,
      ...systemColors.yellow,
      ...systemColors.green,
      ...systemColors.teal,
      ...systemColors.indigo,
      ...systemColors.orange,
      ...systemColors.purple,
      ...systemColors.pink,
      ...systemColors.lime,
      ...systemColors.cyan,
      black: "#000000",
      white: "#FFFFFF",
      success: "$green8",
      successHover: "$green9",
      successActive: "$green10",
      danger: "$red8",
      dangerHover: "$red9",
      dangerActive: "$red10",
      education: "$purple8",
      educationHover: "$purple9",
      educationActive: "$purple10",
      warning: "$yellow8",
      warningHover: "$yellow9",
      warningActive: "$yellow10",
      subtleLink: "$gray8",
      subtleLinkHover: "$gray9",
      subtleLinkActive: "$gray10",
      inlineLink: "$blue8",
      inlineLinkHover: "$blue9",
      inlineLinkActive: "$blue10",
      primaryButtonText: "$white",
      secondaryButtonText: "$gray12",
      tertiaryButtonText: "$gray12",
      navItem: "$gray12",
      navItemActive: "$blue8",
      h1: "$gray12",
      h2: "$gray12",
      h3: "$gray12",
      h4: "$gray10",
      metric: "$gray12",
      subtitle1: "$gray10",
      subtitle2: "$gray10",
      metadata: "$gray10",
      body: "$gray12",
      bodyBold: "$gray12"
    },
    fonts: {
      primary: "'proxima', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif"
    },
    sizes: {
      base: "8px",
      0: 0,
      half: "calc($base / 2)",
      1: "$base",
      2: "calc($base * 2)",
      3: "calc($base * 3)",
      4: "calc($base * 4)",
      5: "calc($base * 5)",
      6: "calc($base * 6)",
      7: "calc($base * 7)",
      8: "calc($base * 8)"
    },
    space: {
      base: "8px",
      0: 0,
      half: "calc($base / 2)",
      1: "$base",
      2: "calc($base * 2)",
      3: "calc($base * 3)",
      4: "calc($base * 4)",
      5: "calc($base * 5)",
      6: "calc($base * 6)",
      7: "calc($base * 7)",
      8: "calc($base * 8)"
    },
    fontSizes: {
      base: "14px",
      1: "0.857rem",
      2: "1rem",
      3: "1.143rem",
      4: "1.429rem",
      5: "1.714rem",
      6: "2.286rem",
      h1: "1.714rem",
      h2: "1.429rem",
      h3: "1.143rem",
      h4: "0.857rem",
      subtitle1: "1.143rem",
      subtitle2: "1rem",
      bodyBold: "1rem",
      body: "1rem",
      button1: "1rem",
      button2: "0.857rem",
      metadata: "0.857rem",
      metric: "2.857rem"
    },
    fontWeights: {
      lightest: 400,
      light: 400,
      normal: 400,
      semibold: 600,
      bold: 700,
      boldest: 700,
      h1: "$semibold",
      h2: "$normal",
      h3: "$semibold",
      h4: "$semibold",
      subtitle1: "$normal",
      subtitle2: "$normal",
      bodyBold: "$semibold",
      body: "$normal",
      button1: "$semibold",
      button2: "$semibold",
      metadata: "$normal",
      metric: "$semibold"
    },
    lineHeights: {
      base: "14px",
      h1: "2.571rem",
      h2: "2rem",
      h3: "1.714rem",
      h4: "1.143rem",
      subtitle1: "1.714rem",
      subtitle2: "1.429rem",
      bodyBold: "1.429rem",
      body: "1.429rem",
      button1: "1rem",
      button2: "1rem",
      metadata: "1.143rem",
      metric: "3.714rem"
    },
    letterSpacings: {
      base: "14px",
      h1: "-0.011rem",
      h2: "-0.011rem",
      h3: "-0.011rem",
      h4: "0.023rem",
      subtitle1: "-0.011rem",
      subtitle2: "-0.011rem",
      bodyBold: "-0.011rem",
      body: "-0.011rem",
      button1: "-0.011rem",
      button2: "-0.011rem",
      metadata: "-0.011rem",
      metric: "-0.011rem"
    },
    radii: {
      1: "3px",
      2: "6px",
      3: "8px",
      4: "12px",
      round: "50%"
    },
    shadows: {
      none: "none",
      1: "0px 2px 4px rgba(96, 110, 120, 0.12), 0px 0px 8px rgba(96, 110, 120, 0.12)",
      2: "0px 0px 16px rgba(96, 110, 120, 0.12)",
      3: "0px 2px 4px rgba(96, 110, 120, 0.24), 0px 0px 24px rgba(96, 110, 120, 0.24)",
      raised08: "$1",
      container16: "$2",
      inflate24: "$3"
    },
    transitions: {
      transitionEaseInOut: "150ms cubic-bezier(0.4, 0, 0.2, 1) forwards",
      transitionEaseOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      transitionEaseIn: "cubic-bezier(0.4, 0, 1, 1)",
      transitionSharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    },
    zIndices: {
      default: 800,
      nav: 1e3,
      appBar: 1050,
      drawer: 1100,
      modal: 1200,
      snackbar: 1300,
      tooltip: 1400,
      max: 5e3
    }
  },
  media: {
    sm: "(min-width: 576px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 992px)",
    xl: "(min-width: 1200px)",
    motion: "(prefers-reduced-motion)",
    hover: "(any-hover: hover)",
    dark: "(prefers-color-scheme: dark)",
    light: "(prefers-color-scheme: light)"
  },
  utils: {
    marginX: value => ({
      marginLeft: value,
      marginRight: value
    }),
    marginY: value => ({
      marginTop: value,
      marginBottom: value
    }),
    paddingY: value => ({
      paddingTop: value,
      paddingBottom: value
    }),
    paddingX: value => ({
      paddingLeft: value,
      paddingRight: value
    }),
    size: value => ({
      width: value,
      height: value
    }),
    textStyles: variant => ({
      fontFamily: "$primary",
      margin: 0,
      fontSize: `$${variant}`,
      fontWeight: `$${variant}`,
      lineHeight: `$${variant}`,
      letterSpacing: `$${variant}`
    }),
    textColor: variant => ({
      color: `$${variant}`
    })
  }
};
const {
  css: css$1,
  theme,
  config: config$1,
  styled,
  globalCss,
  getCssText,
  keyframes
} = q$1(defaultTheme);
const applyGlobalStyles = globalCss(globalStyles);
var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i2 = 0; i2 < 10; i2++) {
      test2["_" + String.fromCharCode(i2)] = i2;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s2 = 1; s2 < arguments.length; s2++) {
    from = Object(arguments[s2]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i2 = 0; i2 < symbols.length; i2++) {
        if (propIsEnumerable.call(from, symbols[i2])) {
          to[symbols[i2]] = from[symbols[i2]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default,
  g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h$1 = Symbol.for;
  g = h$1("react.element");
  reactJsxRuntime_production_min.Fragment = h$1("react.fragment");
}
var m$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  n$1 = Object.prototype.hasOwnProperty,
  p$2 = {
    key: true,
    ref: true,
    __self: true,
    __source: true
  };
function q(c2, a2, k2) {
  var b2,
    d2 = {},
    e2 = null,
    l2 = null;
  k2 !== void 0 && (e2 = "" + k2);
  a2.key !== void 0 && (e2 = "" + a2.key);
  a2.ref !== void 0 && (l2 = a2.ref);
  for (b2 in a2) n$1.call(a2, b2) && !p$2.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
  if (c2 && c2.defaultProps) for (b2 in a2 = c2.defaultProps, a2) d2[b2] === void 0 && (d2[b2] = a2[b2]);
  return {
    $$typeof: g,
    type: c2,
    key: e2,
    ref: l2,
    props: d2,
    _owner: m$1.current
  };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const ThemeProvider = _ref6 => {
  let {
    children
  } = _ref6;
  applyGlobalStyles();
  return /* @__PURE__ */jsx(Fragment, {
    children
  });
};
const ServerThemeProvider = () => /* @__PURE__ */jsx("style", {
  id: "drift-dds",
  dangerouslySetInnerHTML: {
    __html: getCssText()
  }
});
const FullWidthVariant = {
  true: {
    width: "100%"
  }
};
const FullHeightVariant = {
  true: {
    height: "100%"
  }
};
const StyledBase$5 = styled("div", {
  variants: {
    fullWidth: FullWidthVariant,
    fullHeight: FullHeightVariant
  }
});
const Box = forwardRef((_ref7, forwardedRef) => {
  let {
    as = "div",
    ...props
  } = _ref7;
  return /* @__PURE__ */jsx(StyledBase$5, {
    as,
    ref: forwardedRef,
    ...props
  });
});
Box.displayName = "Box";
const FlexStyles = {
  display: "flex"
};
var FlexDirectionVariantEnum = /* @__PURE__ */(FlexDirectionVariantEnum2 => {
  FlexDirectionVariantEnum2["ROW"] = "row";
  FlexDirectionVariantEnum2["COLUMN"] = "column";
  FlexDirectionVariantEnum2["ROW_REVERSE"] = "row-reverse";
  FlexDirectionVariantEnum2["COLUMN_REVERSE"] = "column-reverse";
  return FlexDirectionVariantEnum2;
})(FlexDirectionVariantEnum || {});
const FlexDirectionVariant = {
  row: {
    flexDirection: "row"
  },
  "row-reverse": {
    flexDirection: "row-reverse"
  },
  column: {
    flexDirection: "column"
  },
  "column-reverse": {
    flexDirection: "column-reverse"
  }
};
var FlexJustifyContentVariantEnum = /* @__PURE__ */(FlexJustifyContentVariantEnum2 => {
  FlexJustifyContentVariantEnum2["FLEX_START"] = "flex-start";
  FlexJustifyContentVariantEnum2["FLEX_END"] = "flex-end";
  FlexJustifyContentVariantEnum2["CENTER"] = "center";
  FlexJustifyContentVariantEnum2["SPACE_BETWEEN"] = "space-between";
  FlexJustifyContentVariantEnum2["SPACE_AROUND"] = "space-around";
  FlexJustifyContentVariantEnum2["SPACE_EVENLY"] = "space-evenly";
  return FlexJustifyContentVariantEnum2;
})(FlexJustifyContentVariantEnum || {});
const FlexJustifyContentVariant = {
  "flex-start": {
    justifyContent: "flex-start"
  },
  "flex-end": {
    justifyContent: "flex-end"
  },
  center: {
    justifyContent: "center"
  },
  "space-between": {
    justifyContent: "space-between"
  },
  "space-around": {
    justifyContent: "space-around"
  },
  "space-evenly": {
    justifyContent: "space-evenly"
  }
};
var FlexAlignItemsVariantEnum = /* @__PURE__ */(FlexAlignItemsVariantEnum2 => {
  FlexAlignItemsVariantEnum2["FLEX_START"] = "flex-start";
  FlexAlignItemsVariantEnum2["FLEX_END"] = "flex-end";
  FlexAlignItemsVariantEnum2["CENTER"] = "center";
  FlexAlignItemsVariantEnum2["BASELINE"] = "baseline";
  FlexAlignItemsVariantEnum2["STRETCH"] = "stretch";
  return FlexAlignItemsVariantEnum2;
})(FlexAlignItemsVariantEnum || {});
const FlexAlignItemsVariant = {
  "flex-start": {
    alignItems: "flex-start"
  },
  "flex-end": {
    alignItems: "flex-end"
  },
  center: {
    alignItems: "center"
  },
  baseline: {
    alignItems: "baseline"
  },
  stretch: {
    alignItems: "stretch"
  }
};
var FlexWrapVariantEnum = /* @__PURE__ */(FlexWrapVariantEnum2 => {
  FlexWrapVariantEnum2["NOWRAP"] = "nowrap";
  FlexWrapVariantEnum2["WRAP"] = "wrap";
  FlexWrapVariantEnum2["WRAP_REVERSE"] = "wrap-reverse";
  return FlexWrapVariantEnum2;
})(FlexWrapVariantEnum || {});
const FlexWrapVariant = {
  wrap: {
    flexWrap: "wrap"
  },
  nowrap: {
    flexWrap: "nowrap"
  },
  "wrap-reverse": {
    flexWrap: "wrap-reverse"
  }
};
const FlexGapVariant = {
  half: {
    gap: "$half"
  },
  0: {
    gap: "$0"
  },
  1: {
    gap: "$1"
  },
  2: {
    gap: "$2"
  },
  3: {
    gap: "$3"
  },
  4: {
    gap: "$4"
  },
  5: {
    gap: "$5"
  },
  6: {
    gap: "$6"
  },
  7: {
    gap: "$7"
  },
  8: {
    gap: "$8"
  }
};
const StyledBase$4 = styled(Box, {
  ...FlexStyles,
  variants: {
    direction: FlexDirectionVariant,
    justifyContent: FlexJustifyContentVariant,
    alignItems: FlexAlignItemsVariant,
    gap: FlexGapVariant,
    wrap: FlexWrapVariant,
    fullWidth: FullWidthVariant,
    fullHeight: FullHeightVariant
  },
  defaultVariants: {
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    wrap: "nowrap",
    gap: 1
  }
});
const Flex = forwardRef((_ref8, forwardedRef) => {
  let {
    direction,
    alignItems,
    justifyContent,
    gap,
    wrap,
    grow = "inherit",
    children,
    css: css2,
    ...props
  } = _ref8;
  return /* @__PURE__ */jsx(StyledBase$4, {
    ref: forwardedRef,
    direction,
    alignItems,
    justifyContent,
    gap,
    wrap,
    css: {
      flexGrow: grow,
      ...css2
    },
    ...props,
    children
  });
});
Flex.displayName = "Flex";
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys$1(object, enumerableOnly) {
  var keys4 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), true).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (obj2) {
    return typeof obj2;
  } : function (obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray$1(arr, i2) || _nonIterableRest();
}
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) arr2[i2] = arr[i2];
  return arr2;
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var noop = function noop2() {};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};
try {
  if (typeof window !== "undefined") _WINDOW = window;
  if (typeof document !== "undefined") _DOCUMENT = document;
  if (typeof MutationObserver !== "undefined") _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== "undefined") _PERFORMANCE = performance;
} catch (e2) {}
var _ref = _WINDOW.navigator || {},
  _ref$userAgent = _ref.userAgent,
  userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = "fa";
var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var DATA_FA_I2SVG = "data-fa-i2svg";
var DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var DATA_PREFIX = "data-prefix";
var DATA_ICON = "data-icon";
var HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var MUTATION_APPROACH_ASYNC = "async";
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"];
var PRODUCTION$1 = function () {
  try {
    return true;
  } catch (e2) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  "fas": "solid",
  "fa-solid": "solid",
  "far": "regular",
  "fa-regular": "regular",
  "fal": "light",
  "fa-light": "light",
  "fat": "thin",
  "fa-thin": "thin",
  "fad": "duotone",
  "fa-duotone": "duotone",
  "fab": "brands",
  "fa-brands": "brands",
  "fak": "kit",
  "fa-kit": "kit",
  "fa": "solid"
};
var STYLE_TO_PREFIX = {
  "solid": "fas",
  "regular": "far",
  "light": "fal",
  "thin": "fat",
  "duotone": "fad",
  "brands": "fab",
  "kit": "fak"
};
var PREFIX_TO_LONG_STYLE = {
  "fab": "fa-brands",
  "fad": "fa-duotone",
  "fak": "fa-kit",
  "fal": "fa-light",
  "far": "fa-regular",
  "fas": "fa-solid",
  "fat": "fa-thin"
};
var LONG_STYLE_TO_PREFIX = {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/;
var LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = {
  "900": "fas",
  "400": "far",
  "normal": "far",
  "300": "fal",
  "100": "fat"
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"];
var DUOTONE_CLASSES = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
};
var RESERVED_CLASSES = [].concat(_toConsumableArray$1(Object.keys(STYLE_TO_PREFIX)), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n2) {
  return "".concat(n2, "x");
})).concat(oneToTwenty.map(function (n2) {
  return "w-".concat(n2);
}));
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector("script[" + attr + "]");
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  if (val === "") return true;
  if (val === "false") return false;
  if (val === "true") return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
  var attrs = [["data-family-prefix", "familyPrefix"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  attrs.forEach(function (_ref2) {
    var _ref22 = _slicedToArray(_ref2, 2),
      attr = _ref22[0],
      key = _ref22[1];
    var val = coerce(getAttrConfig(attr));
    if (val !== void 0 && val !== null) {
      initial[key] = val;
    }
  });
}
var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: "solid",
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: "async",
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};
var _config = _objectSpread2$1(_objectSpread2$1({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;
      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);
  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}
var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css2) {
  if (!css2 || !IS_DOM) {
    return;
  }
  var style = DOCUMENT.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML = css2;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;
  for (var i2 = headChildren.length - 1; i2 > -1; i2--) {
    var child = headChildren[i2];
    var tagName = (child.tagName || "").toUpperCase();
    if (["STYLE", "LINK"].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css2;
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
  var size = 12;
  var id = "";
  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }
  return id;
}
function toArray(obj) {
  var array = [];
  for (var i2 = (obj || []).length >>> 0; i2--;) {
    array[i2] = obj[i2];
  }
  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute("class") || "").split(" ").filter(function (i2) {
      return i2;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
  }, "").trim();
}
function joinStyles(styles2) {
  return Object.keys(styles2 || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles2[styleName].trim(), ";");
  }, "");
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref2) {
  var transform = _ref2.transform,
    containerWidth = _ref2.containerWidth,
    iconWidth = _ref2.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path3 = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer,
    inner,
    path: path3
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
    _ref2$startCentered = _ref2.startCentered,
    startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = "";
  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }
  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}
var baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s2 = baseStyles;
  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
    var rPatt = new RegExp("\\.".concat(drc), "g");
    s2 = s2.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }
  return s2;
}
var _cssInserted = false;
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}
var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener2() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener2);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};
var loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener("DOMContentLoaded", listener);
}
function domready(fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}
function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
    _abstractNodes$attrib = abstractNodes.attributes,
    attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
    _abstractNodes$childr = abstractNodes.children,
    children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
  if (typeof abstractNodes === "string") {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
  }
}
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix,
      iconName,
      icon: mapping[prefix][iconName]
    };
  }
}
var bindInternal4 = function bindInternal42(func, thisContext) {
  return function (a2, b2, c2, d2) {
    return func.call(thisContext, a2, b2, c2, d2);
  };
};
var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys4 = Object.keys(subject),
    length = keys4.length,
    iterator = thisContext !== void 0 ? bindInternal4(fn, thisContext) : fn,
    i2,
    key,
    result;
  if (initialValue === void 0) {
    i2 = 1;
    result = subject[keys4[0]];
  } else {
    i2 = 0;
    result = initialValue;
  }
  for (; i2 < length; i2++) {
    key = keys4[i2];
    result = iterator(result, subject[key], key, subject);
  }
  return result;
};
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 55296 && value <= 56319 && counter < length) {
      var extra = string.charCodeAt(counter++);
      if ((extra & 64512) == 56320) {
        output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index2) {
  var size = string.length;
  var first = string.charCodeAt(index2);
  var second;
  if (first >= 55296 && first <= 56319 && size > index2 + 1) {
    second = string.charCodeAt(index2 + 1);
    if (second >= 56320 && second <= 57343) {
      return (first - 55296) * 1024 + second - 56320 + 65536;
    }
  }
  return first;
}
function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon3 = icons[iconName];
    var expanded = !!icon3.icon;
    if (expanded) {
      acc[icon3.iconName] = icon3.icon;
    } else {
      acc[iconName] = icon3;
    }
    return acc;
  }, {});
}
function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
    skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);
  if (typeof namespace.hooks.addPack === "function" && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2$1(_objectSpread2$1({}, namespace.styles[prefix] || {}), normalized);
  }
  if (prefix === "fas") {
    defineIcons("fa", icons);
  }
}
var styles = namespace.styles,
  shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);
function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(familyPrefix, cls) {
  var parts = cls.split("-");
  var prefix = parts[0];
  var iconName = parts.slice(1).join("-");
  if (prefix === familyPrefix && iconName !== "" && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build2() {
  var lookup = function lookup2(reducer) {
    return reduce(styles, function (o2, style, prefix) {
      o2[prefix] = reduce(style, reducer, {});
      return o2;
    }, {});
  };
  _byUnicode = lookup(function (acc, icon3, iconName) {
    if (icon3[3]) {
      acc[icon3[3]] = iconName;
    }
    if (icon3[2]) {
      var aliases = icon3[2].filter(function (a2) {
        return typeof a2 === "number";
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }
    return acc;
  });
  _byLigature = lookup(function (acc, icon3, iconName) {
    acc[iconName] = iconName;
    if (icon3[2]) {
      var aliases = icon3[2].filter(function (a2) {
        return typeof a2 === "string";
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }
    return acc;
  });
  _byAlias = lookup(function (acc, icon3, iconName) {
    var aliases = icon3[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  });
  var hasRegular = "far" in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];
    if (prefix === "far" && !hasRegular) {
      prefix = "fas";
    }
    if (typeof maybeNameMaybeUnicode === "string") {
      acc.names[maybeNameMaybeUnicode] = {
        prefix,
        iconName
      };
    }
    if (typeof maybeNameMaybeUnicode === "number") {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix,
        iconName
      };
    }
    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c2) {
  _defaultUsablePrefix = getCanonicalPrefix(c2.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode("fas", unicode);
  return oldUnicode || (newUnicode ? {
    prefix: "fas",
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon2() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
    skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);
    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }
    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === "fa" ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);
      if (shim.prefix) {
        givenPrefix = null;
      }
      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;
      if (acc.prefix === "far" && !styles["far"] && styles["fas"] && !config.autoFetchSvg) {
        acc.prefix = "fas";
      }
    }
    return acc;
  }, emptyCanonicalIcon());
  if (canonical.prefix === "fa" || givenPrefix === "fa") {
    canonical.prefix = getDefaultUsablePrefix() || "fas";
  }
  return canonical;
}
var Library = /* @__PURE__ */function () {
  function Library2() {
    _classCallCheck(this, Library2);
    this.definitions = {};
  }
  _createClass(Library2, [{
    key: "add",
    value: function add() {
      var _this = this;
      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }
      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2$1(_objectSpread2$1({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
          prefix = _normalized$key.prefix,
          iconName = _normalized$key.iconName,
          icon3 = _normalized$key.icon;
        var aliases = icon3[2];
        if (!additions[prefix]) additions[prefix] = {};
        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === "string") {
              additions[prefix][alias] = icon3;
            }
          });
        }
        additions[prefix][iconName] = icon3;
      });
      return additions;
    }
  }]);
  return Library2;
}();
var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref2) {
  var obj = _ref2.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k2) {
    if (defaultProviderKeys.indexOf(k2) === -1) {
      delete providers[k2];
    }
  });
  _plugins.forEach(function (plugin) {
    var mixout8 = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout8).forEach(function (tk) {
      if (typeof mixout8[tk] === "function") {
        obj[tk] = mixout8[tk];
      }
      if (_typeof$1(mixout8[tk]) === "object") {
        Object.keys(mixout8[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }
          obj[tk][sk] = mixout8[tk][sk];
        });
      }
    });
    if (plugin.hooks) {
      var hooks8 = plugin.hooks();
      Object.keys(hooks8).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }
        _hooks[hook].push(hooks8[hook]);
      });
    }
    if (plugin.provides) {
      plugin.provides(providers);
    }
  });
  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args));
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return void 0;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : void 0;
}
function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === "fa") {
    iconLookup.prefix = "fas";
  }
  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto2() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks("noAuto");
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (IS_DOM) {
      callHooks("beforeI2svg", params);
      callProvided("pseudoElements2svg", params);
      return callProvided("i2svg", params);
    } else {
      return Promise.reject("Operation requires a DOM of some kind.");
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }
    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot
      });
      callHooks("watch", params);
    });
  }
};
var parse$1 = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }
    if (_typeof$1(_icon) === "object" && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }
    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }
    if (typeof _icon === "string" && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(" "), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }
    if (typeof _icon === "string") {
      var _prefix = getDefaultUsablePrefix();
      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto,
  config,
  dom,
  parse: parse$1,
  library,
  findIconDefinition,
  toHtml
};
var autoReplace = function autoReplace2() {
  var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
    autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};
function domVariants(val, abstractCreator) {
  Object.defineProperty(val, "abstract", {
    get: abstractCreator
  });
  Object.defineProperty(val, "html", {
    get: function get() {
      return val.abstract.map(function (a2) {
        return toHtml(a2);
      });
    }
  });
  Object.defineProperty(val, "node", {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement("div");
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}
function asIcon(_ref2) {
  var children = _ref2.children,
    main = _ref2.main,
    mask = _ref2.mask,
    attributes = _ref2.attributes,
    styles2 = _ref2.styles,
    transform = _ref2.transform;
  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
      height = main.height;
    var offset2 = {
      x: width / height / 2,
      y: 0.5
    };
    attributes["style"] = joinStyles(_objectSpread2$1(_objectSpread2$1({}, styles2), {}, {
      "transform-origin": "".concat(offset2.x + transform.x / 16, "em ").concat(offset2.y + transform.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes,
    children
  }];
}
function asSymbol(_ref2) {
  var prefix = _ref2.prefix,
    iconName = _ref2.iconName,
    children = _ref2.children,
    attributes = _ref2.attributes,
    symbol = _ref2.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$1(_objectSpread2$1({}, attributes), {}, {
        id
      }),
      children
    }]
  }];
}
function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
    main = _params$icons.main,
    mask = _params$icons.mask,
    prefix = params.prefix,
    iconName = params.iconName,
    transform = params.transform,
    symbol = params.symbol,
    title = params.title,
    maskId = params.maskId,
    titleId = params.titleId,
    extra = params.extra,
    _params$watchable = params.watchable,
    watchable = _params$watchable === void 0 ? false : _params$watchable;
  var _ref2 = mask.found ? mask : main,
    width = _ref2.width,
    height = _ref2.height;
  var isUploadedIcon = prefix === "fak";
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ""].filter(function (c2) {
    return extra.classes.indexOf(c2) === -1;
  }).filter(function (c2) {
    return c2 !== "" || !!c2;
  }).concat(extra.classes).join(" ");
  var content = {
    children: [],
    attributes: _objectSpread2$1(_objectSpread2$1({}, extra.attributes), {}, {
      "data-prefix": prefix,
      "data-icon": iconName,
      "class": attrClass,
      "role": extra.attributes.role || "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};
  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = "";
  }
  if (title) {
    content.children.push({
      tag: "title",
      attributes: {
        id: content.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }
  var args = _objectSpread2$1(_objectSpread2$1({}, content), {}, {
    prefix,
    iconName,
    main,
    mask,
    maskId,
    transform,
    symbol,
    styles: _objectSpread2$1(_objectSpread2$1({}, uploadedIconWidthStyle), extra.styles)
  });
  var _ref22 = mask.found && main.found ? callProvided("generateAbstractMask", args) || {
      children: [],
      attributes: {}
    } : callProvided("generateAbstractIcon", args) || {
      children: [],
      attributes: {}
    },
    children = _ref22.children,
    attributes = _ref22.attributes;
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
    width = params.width,
    height = params.height,
    transform = params.transform,
    title = params.title,
    extra = params.extra,
    _params$watchable2 = params.watchable,
    watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title ? {
    "title": title
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  if (watchable) {
    attributes[DATA_FA_I2SVG] = "";
  }
  var styles2 = _objectSpread2$1({}, extra.styles);
  if (transformIsMeaningful(transform)) {
    styles2["transform"] = transformForCss({
      transform,
      startCentered: true,
      width,
      height
    });
    styles2["-webkit-transform"] = styles2["transform"];
  }
  var styleString = joinStyles(styles2);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title]
    });
  }
  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
    title = params.title,
    extra = params.extra;
  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title ? {
    "title": title
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  var styleString = joinStyles(extra.styles);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title]
    });
  }
  return val;
}
var styles$1 = namespace.styles;
function asFoundIcon(icon3) {
  var width = icon3[0];
  var height = icon3[1];
  var _icon$slice = icon3.slice(4),
    _icon$slice2 = _slicedToArray(_icon$slice, 1),
    vectorData = _icon$slice2[0];
  var element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: "g",
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: "currentColor",
          d: vectorData[0]
        }
      }, {
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: "currentColor",
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: "path",
      attributes: {
        fill: "currentColor",
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width,
    height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};
function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION$1 && !config.showMissingIcons && iconName) {
    console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
  }
}
function findIcon(iconName, prefix) {
  var givenPrefix = prefix;
  if (prefix === "fa" && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }
  return new Promise(function (resolve, reject3) {
    ({
      found: false,
      width: 512,
      height: 512,
      icon: callProvided("missingIconAbstract") || {}
    });
    if (givenPrefix === "fa") {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }
    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon3 = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon3));
    }
    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2$1(_objectSpread2$1({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
var noop$1 = function noop3() {};
var p$1 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = 'FA "6.1.1"';
var begin = function begin2(name) {
  p$1.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};
var end = function end2(name) {
  p$1.mark("".concat(preamble, " ").concat(name, " ends"));
  p$1.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
  begin,
  end
};
var noop$2 = function noop4() {};
function isWatched(node) {
  var i2svg2 = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg2 === "string";
}
function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon3 = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon3;
}
function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }
  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}
function createElementNS(tag) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function createElement(tag) {
  return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
    ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? createElementNS : createElement : _params$ceFn;
  if (typeof abstractObj === "string") {
    return DOCUMENT.createTextNode(abstractObj);
  }
  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn
    }));
  });
  return tag;
}
function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  return comment;
}
var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];
    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });
      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];
    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }
    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;
    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(" ").reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }
        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(" ");
      if (splitClasses.toNode.length === 0) {
        node.removeAttribute("class");
      } else {
        node.setAttribute("class", splitClasses.toNode.join(" "));
      }
    }
    var newInnerHTML = abstract.map(function (a2) {
      return toHtml(a2);
    }).join("\n");
    node.setAttribute(DATA_FA_I2SVG, "");
    node.innerHTML = newInnerHTML;
  }
};
function performOperationSync(op) {
  op();
}
function perform(mutations, callback) {
  var callbackFunction = typeof callback === "function" ? callback : noop$2;
  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;
    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }
    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin("mutate");
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }
  if (!config.observeMutations) {
    return;
  }
  var _options$treeCallback = options.treeCallback,
    treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
    _options$nodeCallback = options.nodeCallback,
    nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
    _options$pseudoElemen = options.pseudoElementsCallback,
    pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
    _options$observeMutat = options.observeMutationsRoot,
    observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }
        treeCallback(mutationRecord.target);
      }
      if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }
      if (mutationRecord.type === "attributes" && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === "class" && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
            prefix = _getCanonicalIcon.prefix,
            iconName = _getCanonicalIcon.iconName;
          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}
function styleParser(node) {
  var style = node.getAttribute("style");
  var val = [];
  if (style) {
    val = style.split(";").reduce(function (acc, style2) {
      var styles2 = style2.split(":");
      var prop3 = styles2[0];
      var value = styles2.slice(1);
      if (prop3 && value.length > 0) {
        acc[prop3] = value.join(":").trim();
      }
      return acc;
    }, {});
  }
  return val;
}
function classParser(node) {
  var existingPrefix = node.getAttribute("data-prefix");
  var existingIconName = node.getAttribute("data-icon");
  var innerText = node.innerText !== void 0 ? node.innerText.trim() : "";
  var val = getCanonicalIcon(classArray(node));
  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }
  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }
  if (val.iconName && val.prefix) {
    return val;
  }
  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }
  return val;
}
function attributesParser(node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== "class" && acc.name !== "style") {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});
  var title = node.getAttribute("title");
  var titleId = node.getAttribute("data-fa-title-id");
  if (config.autoA11y) {
    if (title) {
      extraAttributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes["aria-hidden"] = "true";
      extraAttributes["focusable"] = "false";
    }
  }
  return extraAttributes;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: true
  };
  var _classParser = classParser(node),
    iconName = _classParser.iconName,
    prefix = _classParser.prefix,
    extraClasses = _classParser.rest;
  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks("parseNodeAttributes", {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2$1({
    iconName,
    title: node.getAttribute("title"),
    titleId: node.getAttribute("data-fa-title-id"),
    prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}
var styles$2 = namespace.styles;
function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === "nest" ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);
  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided("generateLayersText", node, nodeMeta);
  } else {
    return callProvided("generateSvgReplacementMutation", node, nodeMeta);
  }
}
function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;
  var hclAdd = function hclAdd2(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var hclRemove = function hclRemove2(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p2) {
    return ".".concat(p2, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(", ");
  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }
  var candidates = [];
  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e2) {}
  if (candidates.length > 0) {
    hclAdd("pending");
    hclRemove("complete");
  } else {
    return Promise.resolve();
  }
  var mark = perf.begin("onTree");
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);
      if (mutation) {
        acc.push(mutation);
      }
    } catch (e2) {
      if (!PRODUCTION$1) {
        if (e2.name === "MissingIcon") {
          console.error(e2);
        }
      }
    }
    return acc;
  }, []);
  return new Promise(function (resolve, reject3) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd("active");
        hclAdd("complete");
        hclRemove("pending");
        if (typeof callback === "function") callback();
        mark();
        resolve();
      });
    }).catch(function (e2) {
      mark();
      reject3(e2);
    });
  });
}
function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}
function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next(iconDefinition, _objectSpread2$1(_objectSpread2$1({}, params), {}, {
      mask
    }));
  };
}
var render = function render2(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$transform = params.transform,
    transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
    _params$symbol = params.symbol,
    symbol = _params$symbol === void 0 ? false : _params$symbol,
    _params$mask = params.mask,
    mask = _params$mask === void 0 ? null : _params$mask,
    _params$maskId = params.maskId,
    maskId = _params$maskId === void 0 ? null : _params$maskId,
    _params$title = params.title,
    title = _params$title === void 0 ? null : _params$title,
    _params$titleId = params.titleId,
    titleId = _params$titleId === void 0 ? null : _params$titleId,
    _params$classes = params.classes,
    classes = _params$classes === void 0 ? [] : _params$classes,
    _params$attributes = params.attributes,
    attributes = _params$attributes === void 0 ? {} : _params$attributes,
    _params$styles = params.styles,
    styles2 = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
    iconName = iconDefinition.iconName,
    icon3 = iconDefinition.icon;
  return domVariants(_objectSpread2$1({
    type: "icon"
  }, iconDefinition), function () {
    callHooks("beforeDOMElementCreation", {
      iconDefinition,
      params
    });
    if (config.autoA11y) {
      if (title) {
        attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes["aria-hidden"] = "true";
        attributes["focusable"] = "false";
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon3),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix,
      iconName,
      transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform),
      symbol,
      title,
      maskId,
      titleId,
      extra: {
        attributes,
        styles: styles2,
        classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout2() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks2() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
        node = _params$node === void 0 ? DOCUMENT : _params$node,
        _params$callback = params.callback,
        callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };
    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
        title = nodeMeta.title,
        titleId = nodeMeta.titleId,
        prefix = nodeMeta.prefix,
        transform = nodeMeta.transform,
        symbol = nodeMeta.symbol,
        mask = nodeMeta.mask,
        maskId = nodeMeta.maskId,
        extra = nodeMeta.extra;
      return new Promise(function (resolve, reject3) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref2) {
          var _ref22 = _slicedToArray(_ref2, 2),
            main = _ref22[0],
            mask2 = _ref22[1];
          resolve([node, makeInlineSvgAbstract({
            icons: {
              main,
              mask: mask2
            },
            prefix,
            iconName,
            transform,
            symbol,
            maskId,
            title,
            titleId,
            extra,
            watchable: true
          })]);
        }).catch(reject3);
      });
    };
    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
        attributes = _ref3.attributes,
        main = _ref3.main,
        transform = _ref3.transform,
        styles2 = _ref3.styles;
      var styleString = joinStyles(styles2);
      if (styleString.length > 0) {
        attributes["style"] = styleString;
      }
      var nextChild;
      if (transformIsMeaningful(transform)) {
        nextChild = callProvided("generateAbstractTransformGrouping", {
          main,
          transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }
      children.push(nextChild || main.icon);
      return {
        children,
        attributes
      };
    };
  }
};
var Layers = {
  mixout: function mixout3() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$classes = params.classes,
          classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: "layer"
        }, function () {
          callHooks("beforeDOMElementCreation", {
            assembler,
            params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a2) {
              children = children.concat(a2.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: "span",
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray$1(classes)).join(" ")
            },
            children
          }];
        });
      }
    };
  }
};
var LayersCounter = {
  mixout: function mixout4() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$title = params.title,
          title = _params$title === void 0 ? null : _params$title,
          _params$classes = params.classes,
          classes = _params$classes === void 0 ? [] : _params$classes,
          _params$attributes = params.attributes,
          attributes = _params$attributes === void 0 ? {} : _params$attributes,
          _params$styles = params.styles,
          styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "counter",
          content
        }, function () {
          callHooks("beforeDOMElementCreation", {
            content,
            params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  }
};
var LayersText = {
  mixout: function mixout5() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$transform = params.transform,
          transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
          _params$title = params.title,
          title = _params$title === void 0 ? null : _params$title,
          _params$classes = params.classes,
          classes = _params$classes === void 0 ? [] : _params$classes,
          _params$attributes = params.attributes,
          attributes = _params$attributes === void 0 ? {} : _params$attributes,
          _params$styles = params.styles,
          styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "text",
          content
        }, function () {
          callHooks("beforeDOMElementCreation", {
            content,
            params
          });
          return makeLayersTextAbstract({
            content,
            transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform),
            title,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides2(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
        transform = nodeMeta.transform,
        extra = nodeMeta.extra;
      var width = null;
      var height = null;
      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }
      if (config.autoA11y && !title) {
        extra.attributes["aria-hidden"] = "true";
      }
      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width,
        height,
        transform,
        title,
        extra,
        watchable: true
      })]);
    };
  }
};
var CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, "");
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}
function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
  return new Promise(function (resolve, reject3) {
    if (node.getAttribute(pendingAttribute) !== null) {
      return resolve();
    }
    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c2) {
      return c2.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles2 = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles2.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN);
    var fontWeight = styles2.getPropertyValue("font-weight");
    var content = styles2.getPropertyValue("content");
    if (alreadyProcessedPseudoElement && !fontFamily) {
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== "none" && content !== "") {
      var _content = styles2.getPropertyValue("content");
      var prefix = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
      var _hexValueFromContent = hexValueFromContent(_content),
        hexValue = _hexValueFromContent.value,
        isSecondary = _hexValueFromContent.isSecondary;
      var isV4 = fontFamily[0].startsWith("FontAwesome");
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;
      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);
        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      }
      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);
        if (alreadyProcessedPseudoElement) {
          node.removeChild(alreadyProcessedPseudoElement);
        }
        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2$1(_objectSpread2$1({}, meta), {}, {
            icons: {
              main,
              mask: emptyCanonicalIcon()
            },
            prefix,
            iconName: iconIdentifier,
            extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement("svg");
          if (position === "::before") {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }
          element.outerHTML = abstract.map(function (a2) {
            return toHtml(a2);
          }).join("\n");
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject3);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}
function replace2(node) {
  return Promise.all([replaceForPosition(node, "::before"), replaceForPosition(node, "::after")]);
}
function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject3) {
    var operations = toArray(root.querySelectorAll("*")).filter(processable).map(replace2);
    var end3 = perf.begin("searchPseudoElements");
    disableObservation();
    Promise.all(operations).then(function () {
      end3();
      enableObservation();
      resolve();
    }).catch(function () {
      end3();
      enableObservation();
      reject3();
    });
  });
}
var PseudoElements = {
  hooks: function hooks3() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides3(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
        node = _params$node === void 0 ? DOCUMENT : _params$node;
      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};
var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout6() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks4() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto: function noAuto3() {
        disconnect();
      },
      watch: function watch2(params) {
        var observeMutationsRoot = params.observeMutationsRoot;
        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks("mutationObserverCallbacks", {
            observeMutationsRoot
          }));
        }
      }
    };
  }
};
var parseTransformString = function parseTransformString2(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(" ").reduce(function (acc, n2) {
    var parts = n2.toLowerCase().split("-");
    var first = parts[0];
    var rest = parts.slice(1).join("-");
    if (first && rest === "h") {
      acc.flipX = true;
      return acc;
    }
    if (first && rest === "v") {
      acc.flipY = true;
      return acc;
    }
    rest = parseFloat(rest);
    if (isNaN(rest)) {
      return acc;
    }
    switch (first) {
      case "grow":
        acc.size = acc.size + rest;
        break;
      case "shrink":
        acc.size = acc.size - rest;
        break;
      case "left":
        acc.x = acc.x - rest;
        break;
      case "right":
        acc.x = acc.x + rest;
        break;
      case "up":
        acc.y = acc.y - rest;
        break;
      case "down":
        acc.y = acc.y + rest;
        break;
      case "rotate":
        acc.rotate = acc.rotate + rest;
        break;
    }
    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout7() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks5() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute("data-fa-transform");
        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }
        return accumulator;
      }
    };
  },
  provides: function provides4(providers2) {
    providers2.generateAbstractTransformGrouping = function (_ref2) {
      var main = _ref2.main,
        transform = _ref2.transform,
        containerWidth = _ref2.containerWidth,
        iconWidth = _ref2.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path3 = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer,
        inner,
        path: path3
      };
      return {
        tag: "g",
        attributes: _objectSpread2$1({}, operations.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$1({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2$1(_objectSpread2$1({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};
var ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = "black";
  }
  return abstract;
}
function deGroup(abstract) {
  if (abstract.tag === "g") {
    return abstract.children;
  } else {
    return [abstract];
  }
}
var Masks = {
  hooks: function hooks6() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute("data-fa-mask");
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(" ").map(function (i2) {
          return i2.trim();
        }));
        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }
        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute("data-fa-mask-id");
        return accumulator;
      }
    };
  },
  provides: function provides5(providers2) {
    providers2.generateAbstractMask = function (_ref2) {
      var children = _ref2.children,
        attributes = _ref2.attributes,
        main = _ref2.main,
        mask = _ref2.mask,
        explicitMaskId = _ref2.maskId,
        transform = _ref2.transform;
      var mainWidth = main.width,
        mainPath = main.icon;
      var maskWidth = mask.width,
        maskPath = mask.icon;
      var trans = transformForSvg({
        transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: "rect",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          fill: "white"
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: "g",
        attributes: _objectSpread2$1({}, trans.inner),
        children: [fillBlack(_objectSpread2$1({
          tag: mainPath.tag,
          attributes: _objectSpread2$1(_objectSpread2$1({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: "g",
        attributes: _objectSpread2$1({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: "mask",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: "rect",
        attributes: _objectSpread2$1({
          fill: "currentColor",
          "clip-path": "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children,
        attributes
      };
    };
  }
};
var MissingIconIndicator = {
  provides: function provides6(providers2) {
    var reduceMotion = false;
    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    providers2.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: "currentColor"
      };
      var ANIMATION_BASE = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var OPACITY_ANIMATE = _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
        attributeName: "opacity"
      });
      var dot = {
        tag: "circle",
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      if (!reduceMotion) {
        dot.children.push({
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: "1;0;1;1;0;1;"
          })
        });
      }
      gChildren.push(dot);
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: reduceMotion ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      });
      if (!reduceMotion) {
        gChildren.push({
          tag: "path",
          attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
              values: "0;0;1;1;0;0;"
            })
          }]
        });
      }
      return {
        tag: "g",
        attributes: {
          "class": "missing"
        },
        children: gChildren
      };
    };
  }
};
var SvgSymbols = {
  hooks: function hooks7() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute("data-fa-symbol");
        var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
        accumulator["symbol"] = symbol;
        return accumulator;
      }
    };
  }
};
var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
var parse$1$1 = api.parse;
api.findIconDefinition;
api.toHtml;
var icon2 = api.icon;
api.layer;
api.text;
api.counter;
var propTypes = {
  exports: {}
};
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location2, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
function ownKeys(object, enumerableOnly) {
  var keys4 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), true).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (obj2) {
    return typeof obj2;
  } : function (obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) arr2[i2] = arr[i2];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function classList(props) {
  var _classes;
  var beat = props.beat,
    fade = props.fade,
    beatFade = props.beatFade,
    bounce = props.bounce,
    shake = props.shake,
    flash = props.flash,
    spin = props.spin,
    spinPulse = props.spinPulse,
    spinReverse = props.spinReverse,
    pulse = props.pulse,
    fixedWidth = props.fixedWidth,
    inverse = props.inverse,
    border = props.border,
    listItem = props.listItem,
    flip2 = props.flip,
    size = props.size,
    rotation = props.rotation,
    pull = props.pull;
  var classes = (_classes = {
    "fa-beat": beat,
    "fa-fade": fade,
    "fa-beat-fade": beatFade,
    "fa-bounce": bounce,
    "fa-shake": shake,
    "fa-flash": flash,
    "fa-spin": spin,
    "fa-spin-reverse": spinReverse,
    "fa-spin-pulse": spinPulse,
    "fa-pulse": pulse,
    "fa-fw": fixedWidth,
    "fa-inverse": inverse,
    "fa-border": border,
    "fa-li": listItem,
    "fa-flip": flip2 === true,
    "fa-flip-horizontal": flip2 === "horizontal" || flip2 === "both",
    "fa-flip-vertical": flip2 === "vertical" || flip2 === "both"
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), _defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes);
  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}
function _isNumerical(obj) {
  obj = obj - 0;
  return obj === obj;
}
function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  }
  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : "";
  });
  return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var _excluded$1 = ["style"];
function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
  return style.split(";").map(function (s2) {
    return s2.trim();
  }).filter(function (s2) {
    return s2;
  }).reduce(function (acc, pair) {
    var i2 = pair.indexOf(":");
    var prop3 = camelize(pair.slice(0, i2));
    var value = pair.slice(i2 + 1).trim();
    prop3.startsWith("webkit") ? acc[capitalize(prop3)] = value : acc[prop3] = value;
    return acc;
  }, {});
}
function convert(createElement2, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof element === "string") {
    return element;
  }
  var children = (element.children || []).map(function (child) {
    return convert(createElement2, child);
  });
  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];
    switch (key) {
      case "class":
        acc.attrs["className"] = val;
        delete element.attributes["class"];
        break;
      case "style":
        acc.attrs["style"] = styleToObject(val);
        break;
      default:
        if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }
    }
    return acc;
  }, {
    attrs: {}
  });
  var _extraProps$style = extraProps.style,
    existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
    remaining = _objectWithoutProperties(extraProps, _excluded$1);
  mixins.attrs["style"] = _objectSpread2(_objectSpread2({}, mixins.attrs["style"]), existingStyle);
  return createElement2.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}
var PRODUCTION = false;
try {
  PRODUCTION = true;
} catch (e2) {}
function log() {
  if (!PRODUCTION && console && typeof console.error === "function") {
    var _console;
    (_console = console).error.apply(_console, arguments);
  }
}
function normalizeIconArgs(icon3) {
  if (icon3 && _typeof(icon3) === "object" && icon3.prefix && icon3.iconName && icon3.icon) {
    return icon3;
  }
  if (parse$1$1.icon) {
    return parse$1$1.icon(icon3);
  }
  if (icon3 === null) {
    return null;
  }
  if (icon3 && _typeof(icon3) === "object" && icon3.prefix && icon3.iconName) {
    return icon3;
  }
  if (Array.isArray(icon3) && icon3.length === 2) {
    return {
      prefix: icon3[0],
      iconName: icon3[1]
    };
  }
  if (typeof icon3 === "string") {
    return {
      prefix: "fas",
      iconName: icon3
    };
  }
}
function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}
var _excluded = ["forwardedRef"];
function FontAwesomeIcon(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
    props = _objectWithoutProperties(_ref2, _excluded);
  var iconArgs = props.icon,
    maskArgs = props.mask,
    symbol = props.symbol,
    className = props.className,
    title = props.title,
    titleId = props.titleId,
    maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey("classes", [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(" "))));
  var transform = objectWithKey("transform", typeof props.transform === "string" ? parse$1$1.transform(props.transform) : props.transform);
  var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
  var renderedIcon = icon2(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol,
    title,
    titleId,
    maskId
  }));
  if (!renderedIcon) {
    log("Could not find icon", iconLookup);
    return null;
  }
  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  beatFade: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf([true, false, "horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React__default.createElement);
var IconSizeVariantEnum = /* @__PURE__ */(IconSizeVariantEnum2 => {
  IconSizeVariantEnum2["INHERIT"] = "inherit";
  IconSizeVariantEnum2["EXTRA_SMALL"] = "extra-small";
  IconSizeVariantEnum2["SMALL"] = "small";
  IconSizeVariantEnum2["MEDIUM"] = "medium";
  IconSizeVariantEnum2["LARGE"] = "large";
  IconSizeVariantEnum2["EXTRA_LARGE"] = "extra-large";
  return IconSizeVariantEnum2;
})(IconSizeVariantEnum || {});
var IconColorVariantEnum = /* @__PURE__ */(IconColorVariantEnum2 => {
  IconColorVariantEnum2["LIGHT"] = "light";
  IconColorVariantEnum2["GRAY"] = "gray";
  IconColorVariantEnum2["DARK"] = "dark";
  IconColorVariantEnum2["DISABLED"] = "disabled";
  return IconColorVariantEnum2;
})(IconColorVariantEnum || {});
const IconSizeVariant = {
  inherit: {
    size: "1em"
  },
  "extra-small": {
    size: "0.714rem"
  },
  small: {
    size: "$fontSizes$1"
  },
  medium: {
    size: "$fontSizes$2"
  },
  large: {
    size: "$fontSizes$3"
  },
  "extra-large": {
    size: "$fontSizes$5"
  }
};
const IconColorVariant = {
  light: {
    color: "$white"
  },
  gray: {
    color: "$gray8"
  },
  dark: {
    color: "$gray12"
  },
  disabled: {
    color: "$gray5"
  }
};
const StyledIconBase = styled(FontAwesomeIcon, {
  variants: {
    size: IconSizeVariant,
    variant: IconColorVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const Icon = forwardRef((_ref9, forwardedRef) => {
  let {
    variant,
    size,
    color,
    icon: icon3,
    rootProps,
    ...props
  } = _ref9;
  return /* @__PURE__ */jsx(StyledIconBase, {
    size,
    variant,
    color,
    forwardedRef,
    icon: icon3,
    ...props,
    ...rootProps
  });
});
Icon.displayName = "Icon";
var LoaderStyleVariantEnum = /* @__PURE__ */(LoaderStyleVariantEnum2 => {
  LoaderStyleVariantEnum2["DARK"] = "dark";
  LoaderStyleVariantEnum2["LIGHT"] = "light";
  LoaderStyleVariantEnum2["INHERIT"] = "inherit";
  return LoaderStyleVariantEnum2;
})(LoaderStyleVariantEnum || {});
const LoaderStyleVariant = {
  dark: {
    stroke: "$gray12"
  },
  light: {
    stroke: "$white"
  },
  inherit: {
    stroke: "currentColor"
  }
};
const rotate = keyframes({
  "100%": {
    transform: "rotate(360deg)"
  }
});
const animateCircleLoader = keyframes({
  "0%": {
    strokeDasharray: "1, 200",
    strokeDashoffset: 0
  },
  "50%": {
    strokeDasharray: "89, 200",
    strokeDashoffset: "-35px"
  },
  "100%": {
    strokeDasharray: "89, 200",
    strokeDashoffset: "-124px"
  }
});
const BaseBox = styled("div", {
  position: "relative",
  variants: {
    size: IconSizeVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const BaseStyles = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  animation: `${rotate} 2s linear infinite`,
  transformOrigin: "center center",
  position: "absolute",
  margin: "auto"
};
const StyledCircle = styled("circle", {
  strokeWidth: "10%",
  strokeDasharray: "1, 200",
  strokeDashoffset: 0,
  animation: `${animateCircleLoader} 1.5s ease-in-out infinite`,
  strokeLinecap: "round"
});
const StyledCircleLoaderBase = styled("svg", {
  ...BaseStyles,
  variants: {
    size: IconSizeVariant,
    variant: LoaderStyleVariant
  },
  defaultVariants: {
    size: "medium",
    variant: "dark"
  }
});
const CircleLoader = forwardRef((_ref10, forwardedRef) => {
  let {
    variant,
    size,
    css: css2,
    ...props
  } = _ref10;
  return /* @__PURE__ */jsx(BaseBox, {
    ref: forwardedRef,
    css: css2,
    children: /* @__PURE__ */jsx(StyledCircleLoaderBase, {
      viewBox: "25 25 50 50",
      variant,
      size,
      ...props,
      children: /* @__PURE__ */jsx(StyledCircle, {
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none"
      })
    })
  });
});
CircleLoader.displayName = "CircleLoader";
const ButtonIcon = _ref11 => {
  let {
    icon: icon3
  } = _ref11;
  return /* @__PURE__ */jsx(Icon, {
    icon: icon3,
    size: "inherit"
  });
};
const ButtonBaseStyles = {
  display: "flex",
  width: "max-content",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  borderStyle: "solid",
  borderWidth: 1,
  margin: 0,
  borderRadius: "$1",
  cursor: "pointer",
  outline: 0,
  textDecoration: "none",
  transitionProperty: "background-color, box-shadow, color, border-color",
  transition: "$transitionEaseInOut",
  paddingRight: "$2",
  paddingLeft: "$2",
  position: "relative",
  textStyles: "button1",
  fontFamily: "$primary",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  }
};
var ButtonBaseColorVariantEnum = /* @__PURE__ */(ButtonBaseColorVariantEnum2 => {
  ButtonBaseColorVariantEnum2["PRIMARY"] = "primary";
  ButtonBaseColorVariantEnum2["SECONDARY"] = "secondary";
  ButtonBaseColorVariantEnum2["TERTIARY"] = "tertiary";
  ButtonBaseColorVariantEnum2["ERROR"] = "error";
  ButtonBaseColorVariantEnum2["EDUCATION"] = "education";
  return ButtonBaseColorVariantEnum2;
})(ButtonBaseColorVariantEnum || {});
const ButtonBaseColorVariant = {
  primary: {
    backgroundColor: "$blue8",
    borderColor: "$blue8",
    color: "$white",
    "&:hover": {
      backgroundColor: "$blue9",
      borderColor: "$blue9"
    },
    "&:active": {
      backgroundColor: "$blue10",
      borderColor: "$blue10"
    },
    "&:disabled": {
      backgroundColor: "$gray3",
      borderColor: "$gray3",
      cursor: "not-allowed"
    }
  },
  secondary: {
    backgroundColor: "$white",
    borderColor: "$gray3",
    color: "$gray12",
    "&:hover": {
      backgroundColor: "$gray2",
      borderColor: "$gray4"
    },
    "&:active": {
      backgroundColor: "$gray3",
      borderColor: "$gray5"
    },
    "&:disabled": {
      color: "$gray5",
      borderColor: "$gray3",
      backgroundColor: "$white",
      cursor: "not-allowed"
    }
  },
  tertiary: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    boxShadow: "none",
    color: "$gray12",
    "&:hover": {
      backgroundColor: "$gray2",
      borderColor: "$gray2"
    },
    "&:active": {
      backgroundColor: "$gray3",
      borderColor: "$gray3"
    },
    "&:disabled": {
      color: "$gray5",
      backgroundColor: "transparent",
      borderColor: "transparent",
      cursor: "not-allowed"
    }
  },
  error: {
    backgroundColor: "$red8",
    borderColor: "$red8",
    color: "$white",
    "&:hover": {
      backgroundColor: "$red9",
      borderColor: "$red9"
    },
    "&:active": {
      backgroundColor: "$red10",
      borderColor: "$red10"
    },
    "&:disabled": {
      backgroundColor: "$gray3",
      borderColor: "$gray3",
      cursor: "not-allowed"
    }
  },
  education: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    boxShadow: "none",
    color: "$purple8",
    "&:hover": {
      backgroundColor: "$purple1"
    },
    "&:active": {
      backgroundColor: "$purple2"
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: "$gray5",
      cursor: "not-allowed"
    }
  }
};
const StyledButtonBase$2 = styled("button", {
  ...ButtonBaseStyles,
  variants: {
    variant: ButtonBaseColorVariant
  },
  defaultVariants: {
    variant: "primary"
  }
});
const ButtonBase = forwardRef((_ref12, forwardedRef) => {
  let {
    css: css2,
    variant = "primary",
    children,
    onClick,
    type: type3 = "button",
    rootProps,
    ...props
  } = _ref12;
  return /* @__PURE__ */jsx(StyledButtonBase$2, {
    ref: forwardedRef,
    css: css2,
    variant,
    onClick,
    type: type3,
    ...props,
    ...rootProps,
    children
  });
});
ButtonBase.displayName = "ButtonBase";
var ButtonSizeVariantEnum = /* @__PURE__ */(ButtonSizeVariantEnum2 => {
  ButtonSizeVariantEnum2["SMALL"] = "small";
  ButtonSizeVariantEnum2["MEDIUM"] = "medium";
  return ButtonSizeVariantEnum2;
})(ButtonSizeVariantEnum || {});
const ButtonSizeVariant = {
  small: {
    paddingTop: "$half",
    paddingBottom: "$half",
    textStyles: "button2"
  },
  medium: {
    paddingTop: "$1",
    paddingBottom: "$1",
    textStyles: "button1"
  }
};
const StyledButtonBase$1 = styled(ButtonBase, {
  variants: {
    size: ButtonSizeVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const StyledButtonContentBase = styled("span", {
  display: "flex",
  gap: "$1",
  variants: {
    hidden: {
      true: {
        visibility: "hidden"
      }
    }
  }
});
const LoaderStyleMap = {
  primary: "light",
  secondary: "dark",
  tertiary: "dark",
  education: "inherit",
  error: "light"
};
const LoaderStyle = {
  position: "absolute"
};
const ButtonComponent = forwardRef((_ref13, forwardedRef) => {
  let {
    size = "medium",
    variant = "primary",
    children,
    loading,
    ...props
  } = _ref13;
  const loaderVariant = LoaderStyleMap[variant] || "dark";
  return /* @__PURE__ */jsxs(StyledButtonBase$1, {
    ref: forwardedRef,
    size,
    variant,
    "aria-busy": loading,
    ...props,
    children: [loading && /* @__PURE__ */jsx(CircleLoader, {
      "aria-label": "loading",
      variant: loaderVariant,
      css: LoaderStyle
    }), /* @__PURE__ */jsx(StyledButtonContentBase, {
      "aria-hidden": loading,
      hidden: loading,
      children
    })]
  });
});
ButtonComponent.displayName = "Button";
const Button = {
  ...ButtonComponent,
  Icon: ButtonIcon
};
var IconButtonSizeVariantEnum = /* @__PURE__ */(IconButtonSizeVariantEnum2 => {
  IconButtonSizeVariantEnum2["SMALL"] = "small";
  IconButtonSizeVariantEnum2["DEFAULT"] = "default";
  return IconButtonSizeVariantEnum2;
})(IconButtonSizeVariantEnum || {});
const IconButtonSizeVariant = {
  small: {
    width: "$3",
    height: "$3"
  },
  default: {
    width: "$4",
    height: "$4"
  }
};
const StyledButtonBase = styled(ButtonBase, {
  paddingLeft: "0",
  paddingRight: "0",
  minWidth: "auto",
  variants: {
    size: IconButtonSizeVariant
  },
  defaultVariants: {
    size: "default"
  }
});
const IconButton = forwardRef((_ref14, forwardedRef) => {
  let {
    size = "default",
    variant = "tertiary",
    icon: icon3,
    iconVariant = "dark",
    css: css2,
    title,
    children,
    disabled: disabled2,
    ...props
  } = _ref14;
  const iconSize = size === IconButtonSizeVariantEnum.DEFAULT ? IconSizeVariantEnum.MEDIUM : IconSizeVariantEnum.SMALL;
  const calculatedIconVariant = disabled2 ? "disabled" : iconVariant;
  return /* @__PURE__ */jsxs(StyledButtonBase, {
    ref: forwardedRef,
    size,
    variant,
    css: css2,
    disabled: disabled2,
    ...props,
    children: [/* @__PURE__ */jsx(Icon, {
      title,
      icon: icon3,
      size: iconSize,
      variant: calculatedIconVariant
    }), children]
  });
});
IconButton.displayName = "IconButton";
const TextTruncateVariant$1 = {
  true: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowWrap: "break-word",
    wordBreak: "break-all",
    maxWidth: "100%"
  }
};
const TextGutterBottomVariant$1 = {
  half: {
    marginBottom: "$half"
  },
  0: {
    marginBottom: "$0"
  },
  1: {
    marginBottom: "$1"
  },
  2: {
    marginBottom: "$2"
  },
  3: {
    marginBottom: "$3"
  },
  4: {
    marginBottom: "$4"
  },
  5: {
    marginBottom: "$5"
  },
  6: {
    marginBottom: "$6"
  },
  7: {
    marginBottom: "$7"
  },
  8: {
    marginBottom: "$8"
  }
};
const TextTransformVariants = {
  truncate: TextTruncateVariant$1,
  gutterBottom: TextGutterBottomVariant$1
};
var HeaderVariantEnum = /* @__PURE__ */(HeaderVariantEnum2 => {
  HeaderVariantEnum2["H1"] = "h1";
  HeaderVariantEnum2["H2"] = "h2";
  HeaderVariantEnum2["H3"] = "h3";
  HeaderVariantEnum2["H4"] = "h4";
  HeaderVariantEnum2["METRIC"] = "metric";
  return HeaderVariantEnum2;
})(HeaderVariantEnum || {});
const HeaderVariant = {
  h1: {
    textStyles: "h1",
    textColor: "h1"
  },
  h2: {
    textStyles: "h2",
    textColor: "h2"
  },
  h3: {
    textStyles: "h3",
    textColor: "h3"
  },
  h4: {
    textStyles: "h4",
    textColor: "h4",
    textTransform: "uppercase"
  },
  metric: {
    textStyles: "metric",
    textColor: "metric"
  }
};
const StyledBase$3 = styled("h1", {
  margin: 0,
  variants: {
    variant: HeaderVariant,
    ...TextTransformVariants
  },
  defaultVariants: {
    variant: "h1"
  }
});
const HeaderTypeToElementMap = {
  metric: "h1",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4"
};
const Header = forwardRef((_ref15, forwardedRef) => {
  let {
    variant = "h1",
    as,
    children,
    ...props
  } = _ref15;
  return /* @__PURE__ */jsx(StyledBase$3, {
    ref: forwardedRef,
    variant,
    as: as || HeaderTypeToElementMap[variant],
    ...props,
    children
  });
});
Header.displayName = "Header";
var TextVariantEnum = /* @__PURE__ */(TextVariantEnum2 => {
  TextVariantEnum2["SUBTITLE1"] = "subtitle1";
  TextVariantEnum2["SUBTITLE2"] = "subtitle2";
  TextVariantEnum2["BODY_BOLD"] = "bodyBold";
  TextVariantEnum2["BODY"] = "body";
  TextVariantEnum2["METADATA"] = "metadata";
  return TextVariantEnum2;
})(TextVariantEnum || {});
const TextVariant = {
  subtitle1: {
    textStyles: "subtitle1",
    textColor: "subtitle1"
  },
  subtitle2: {
    textStyles: "subtitle2",
    textColor: "subtitle2"
  },
  bodyBold: {
    textStyles: "bodyBold",
    textColor: "bodyBold"
  },
  body: {
    textStyles: "body",
    textColor: "body"
  },
  metadata: {
    textStyles: "metadata",
    textColor: "metadata"
  }
};
const TextTruncateVariant = {
  true: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowWrap: "break-word",
    wordBreak: "break-all",
    maxWidth: "100%"
  }
};
const TextGutterBottomVariant = {
  half: {
    marginBottom: "$half"
  },
  0: {
    marginBottom: "$0"
  },
  1: {
    marginBottom: "$1"
  },
  2: {
    marginBottom: "$2"
  },
  3: {
    marginBottom: "$3"
  },
  4: {
    marginBottom: "$4"
  },
  5: {
    marginBottom: "$5"
  },
  6: {
    marginBottom: "$6"
  },
  7: {
    marginBottom: "$7"
  },
  8: {
    marginBottom: "$8"
  }
};
const StyledBase$2 = styled("p", {
  margin: 0,
  variants: {
    variant: TextVariant,
    ...TextTransformVariants
  },
  defaultVariants: {
    variant: "body",
    truncate: false
  }
});
const TextTypeToElementMap = {
  bodyBold: "p",
  body: "p",
  subtitle1: "p",
  subtitle2: "p",
  metadata: "span"
};
const Text = forwardRef((_ref16, forwardedRef) => {
  let {
    variant = "body",
    as,
    children,
    ...props
  } = _ref16;
  return /* @__PURE__ */jsx(StyledBase$2, {
    ref: forwardedRef,
    variant,
    as: as || TextTypeToElementMap[variant],
    ...props,
    children
  });
});
Text.displayName = "Text";
var StatusMessageVariantTypeEnum = /* @__PURE__ */(StatusMessageVariantTypeEnum2 => {
  StatusMessageVariantTypeEnum2["INFO"] = "info";
  StatusMessageVariantTypeEnum2["SUCCESS"] = "success";
  StatusMessageVariantTypeEnum2["ERROR"] = "error";
  StatusMessageVariantTypeEnum2["WARNING"] = "warning";
  StatusMessageVariantTypeEnum2["ARCHIVED"] = "archived";
  return StatusMessageVariantTypeEnum2;
})(StatusMessageVariantTypeEnum || {});
const StatusMessageLabelColorVariant = {
  info: {
    color: "$blue8"
  },
  success: {
    color: "$green8"
  },
  error: {
    color: "$red8"
  },
  warning: {
    color: "$yellow8"
  },
  archived: {
    color: "$gray8"
  }
};
const StatusMessageText = styled(Text, {
  variants: {
    color: StatusMessageLabelColorVariant
  }
});
const StatusMessage = forwardRef((_ref17, forwardedRef) => {
  let {
    variant = "info",
    children,
    textId
  } = _ref17;
  const ariaLive = variant === "error" ? "assertive" : "polite";
  return /* @__PURE__ */jsxs(Flex, {
    ref: forwardedRef,
    gap: "half",
    alignItems: "center",
    children: [/* @__PURE__ */jsx(StatusIcon, {
      variant
    }), /* @__PURE__ */jsx(StatusMessageText, {
      id: textId,
      "aria-live": ariaLive,
      variant: "metadata",
      color: variant,
      children
    })]
  });
});
StatusMessage.displayName = "StatusMessage";
var InputSizeVariantEnum = /* @__PURE__ */(InputSizeVariantEnum2 => {
  InputSizeVariantEnum2["SMALL"] = "small";
  InputSizeVariantEnum2["MEDIUM"] = "medium";
  InputSizeVariantEnum2["LARGE"] = "large";
  InputSizeVariantEnum2["X_LARGE"] = "x-large";
  InputSizeVariantEnum2["FULL_WIDTH"] = "full-width";
  return InputSizeVariantEnum2;
})(InputSizeVariantEnum || {});
const InputContainerSizeVariant = {
  small: {
    width: "240px"
  },
  medium: {
    width: "280px"
  },
  large: {
    width: "372px"
  },
  "x-large": {
    width: "550px"
  },
  "full-width": {
    width: "100%"
  }
};
const InputSizeVariant = {
  small: {
    width: "120px"
  },
  medium: {
    width: "280px"
  },
  large: {
    width: "372px"
  },
  "x-large": {
    width: "550px"
  },
  "full-width": {
    width: "100%"
  }
};
const InputRoot = styled(Flex, {
  variants: {
    size: InputContainerSizeVariant
  },
  defaultVariants: {
    size: InputSizeVariantEnum.MEDIUM
  }
});
const StyledLabel$2 = styled("label", {
  display: "flex",
  gap: "$half",
  alignItems: "center"
});
const InputField = styled("input", {
  padding: 0,
  backgroundColor: "transparent",
  height: "100%",
  width: "100%",
  border: "none",
  display: "block",
  maxWidth: "744px",
  textStyles: "body",
  fontFamily: "$primary",
  boxSizing: "border-box",
  color: "$body",
  "&::placeholder": {
    color: "$gray8"
  },
  "&:focus": {
    outline: "none"
  },
  "&:disabled": {
    color: "inherit",
    cursor: "not-allowed"
  }
});
const InputContent = styled(Flex, {
  height: "$4",
  border: "1px solid $blue3",
  borderRadius: "$1",
  textStyles: "body",
  padding: "$1",
  boxSizing: "border-box",
  "&:hover": {
    borderColor: "$blue4"
  },
  "&:focus-visible": {
    outline: "1px solid $blue6"
  },
  "&:focus-within": {
    border: "1px solid $blue5",
    outlineOffset: 1
  },
  variants: {
    size: InputSizeVariant,
    isInvalid: {
      true: {
        borderColor: "$red6"
      }
    },
    isSuccessful: {
      true: {
        borderColor: "$green6"
      }
    },
    isDisabled: {
      true: {
        backgroundColor: "$gray2",
        borderColor: "$gray3",
        cursor: "not-allowed",
        "&:hover": {
          borderColor: "$gray3"
        },
        "& + label": {
          cursor: "not-allowed"
        }
      }
    }
  },
  defaultVariants: {
    size: InputSizeVariantEnum.MEDIUM
  }
});
const InputLabel = _ref18 => {
  let {
    id,
    label,
    htmlFor,
    showOptionalLabel
  } = _ref18;
  return /* @__PURE__ */jsxs(StyledLabel$2, {
    id,
    htmlFor,
    children: [/* @__PURE__ */jsx(Text, {
      children: label
    }), showOptionalLabel && /* @__PURE__ */jsx(Text, {
      variant: "metadata",
      children: "(optional)"
    })]
  });
};
const InputDescription = _ref19 => {
  let {
    id,
    children
  } = _ref19;
  if (!children) {
    return null;
  }
  return /* @__PURE__ */jsx(Text, {
    id,
    variant: "metadata",
    children
  });
};
const InputErrorState = _ref20 => {
  let {
    id,
    errorMessage
  } = _ref20;
  if (!errorMessage) {
    return null;
  }
  return /* @__PURE__ */jsx(StatusMessage, {
    textId: id,
    variant: "error",
    children: errorMessage
  });
};
const InputSuccessState = _ref21 => {
  let {
    id,
    successMessage
  } = _ref21;
  if (!successMessage) {
    return null;
  }
  return /* @__PURE__ */jsx(StatusMessage, {
    textId: id,
    variant: "success",
    children: successMessage
  });
};
const InputBase = {
  Root: InputRoot,
  Label: InputLabel,
  Content: InputContent,
  Field: InputField,
  Description: InputDescription,
  ErrorState: InputErrorState,
  SuccessState: InputSuccessState
};
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs$1() {
  for (var _len6 = arguments.length, refs = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    refs[_key6] = arguments[_key6];
  }
  return node => refs.forEach(ref => setRef(ref, node));
}
function useComposedRefs$1() {
  for (var _len7 = arguments.length, refs = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    refs[_key7] = arguments[_key7];
  }
  return React.useCallback(composeRefs$1(...refs), refs);
}
const INVALID_CHARACTER_REGEX = /[^\p{L}\p{Z}^$\n]/gu;
const toHyphenCase = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return str.replace(INVALID_CHARACTER_REGEX, "").replaceAll(" ", "-").toLowerCase();
};
var faAngleDown$1 = {};
Object.defineProperty(faAngleDown$1, "__esModule", {
  value: true
});
var faAngleDown_2 = faAngleDown$1.faAngleDown = void 0;
const faAngleDown = {
  prefix: "fat",
  iconName: "faAngleDown",
  icon: [384, 512, [], "", "M191.1 352c-1.1 0-3.969-.7344-5.531-2.219L34.47 205.8c-3.187-3.047-3.312-8.125-.25-11.31c3.094-3.188 8.156-3.281 11.31-.25l146.5 138.7l146.5-138.7c3.219-3.031 8.281-2.938 11.31 .25c3.062 3.188 2.937 8.266-.25 11.31l-151.1 144C195.1 351.3 193.1 352 191.1 352z"]
};
faAngleDown_2 = faAngleDown$1.faAngleDown = faAngleDown;
var faAngleUp$1 = {};
Object.defineProperty(faAngleUp$1, "__esModule", {
  value: true
});
var faAngleUp_2 = faAngleUp$1.faAngleUp = void 0;
const faAngleUp = {
  prefix: "fat",
  iconName: "faAngleUp",
  icon: [384, 512, [], "", "M192 160c1.1 0 3.969 .7344 5.531 2.219l151.1 144c3.187 3.047 3.312 8.125 .25 11.31c-3.094 3.188-8.156 3.281-11.31 .25L192 179.1L45.53 317.8c-3.219 3.031-8.281 2.938-11.31-.25c-3.062-3.188-2.937-8.266 .25-11.31l151.1-144C188 160.7 190 160 192 160z"]
};
faAngleUp_2 = faAngleUp$1.faAngleUp = faAngleUp;
const NumberInputField = styled(InputBase.Field, {
  appearance: "textfield",
  "&::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  },
  "&::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  }
});
const StyledNumberInputButton = styled(IconButton, {
  "&:disabled": {
    backgroundColor: "$gray2"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  defaultVariants: {
    size: void 0
  }
});
const NumberInputContent = styled(Flex, {
  width: "100%"
});
const NumberInputButton = _ref23 => {
  let {
    icon: icon3,
    title,
    onClick,
    disabled: disabled2
  } = _ref23;
  return /* @__PURE__ */jsx(StyledNumberInputButton, {
    title,
    icon: icon3,
    disabled: disabled2,
    iconVariant: "dark",
    onClick,
    css: {
      width: "$2",
      height: "12px",
      padding: "$half"
    }
  });
};
const InputNumber = forwardRef((_ref24, forwardedRef) => {
  let {
    ref,
    errorMessage = "",
    successMessage = "",
    label,
    labelOptional,
    description,
    disabled: disabled2,
    onChange: onChange2,
    value,
    step = 1,
    min: min2,
    max: max2,
    rootProps,
    size = "small",
    ...props
  } = _ref24;
  var _a, _b;
  const canIncreaseValue = max2 === void 0 || value === void 0 ? true : max2 > value;
  const canDecreaseValue = min2 === void 0 || value === void 0 ? true : min2 < value;
  const composedRefs = useComposedRefs$1(forwardedRef, ref);
  const name = toHyphenCase(label);
  const inputElementId = `dds-number-input-element-${name}`;
  const inputLabelElementId = `dds-number-input-label-${name}`;
  const descriptionElementId = `dds-number-input-description-${name}`;
  const errorMessageElementId = `dds-number-input-error-message-${name}`;
  const successMessageElementId = `dds-number-input-success-message-${name}`;
  const describedById = (_b = (_a = errorMessage && errorMessageElementId) != null ? _a : successMessage && successMessageElementId) != null ? _b : description && descriptionElementId;
  const handleChange = updatedValue => {
    onChange2 && onChange2(updatedValue);
  };
  const decrementCount = () => {
    const inputValue = Number(value != null ? value : 0);
    handleChange(inputValue - Number(step));
  };
  const incrementCount = () => {
    const inputValue = Number(value != null ? value : 0);
    handleChange(inputValue + Number(step));
  };
  return /* @__PURE__ */jsx(InputBase.Root, {
    direction: "column",
    size,
    children: /* @__PURE__ */jsxs(NumberInputContent, {
      direction: "column",
      gap: "half",
      grow: "1",
      children: [/* @__PURE__ */jsx(InputBase.Label, {
        id: inputLabelElementId,
        htmlFor: inputElementId,
        label,
        showOptionalLabel: labelOptional
      }), /* @__PURE__ */jsxs(InputBase.Content, {
        alignItems: "center",
        isInvalid: !!errorMessage.length,
        isSuccessful: !!successMessage.length,
        isDisabled: disabled2,
        size,
        children: [/* @__PURE__ */jsx(NumberInputField, {
          ref: composedRefs,
          disabled: disabled2,
          onChange: evt => {
            var _a2;
            return handleChange((_a2 = evt == null ? void 0 : evt.target) == null ? void 0 : _a2.value);
          },
          type: "number",
          id: inputElementId,
          "aria-invalid": !!errorMessage.length,
          "aria-errormessage": errorMessageElementId,
          "aria-describedby": describedById,
          value,
          min: min2,
          max: max2,
          onWheel: e2 => e2.currentTarget.blur(),
          ...props,
          ...rootProps
        }), /* @__PURE__ */jsxs(Flex, {
          direction: "column",
          gap: "half",
          children: [/* @__PURE__ */jsx(NumberInputButton, {
            title: "increase value",
            icon: faAngleUp_2,
            onClick: incrementCount,
            disabled: disabled2 || !canIncreaseValue
          }), /* @__PURE__ */jsx(NumberInputButton, {
            title: "decrease value",
            icon: faAngleDown_2,
            onClick: decrementCount,
            disabled: disabled2 || !canDecreaseValue
          })]
        })]
      }), /* @__PURE__ */jsx(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage
      })]
    })
  });
});
InputNumber.displayName = "InputNumber";
const inputContentWithPartials = css$1({
  variants: {
    hasPrefix: {
      true: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    },
    hasSuffix: {
      true: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  }
});
const InputPartialContentContainer = styled(Flex, {
  variants: {
    fullWidth: FullWidthVariant
  }
});
const StyledPartialInputInfo = styled(Flex, {
  padding: "$1",
  backgroundColor: "$blue1",
  borderColor: "$blue3",
  borderWidth: "1px",
  borderStyle: "solid",
  height: "32px",
  whiteSpace: "nowrap",
  cursor: "default",
  boxSizing: "border-box",
  variants: {
    roundedBorder: {
      left: {
        borderTopLeftRadius: "$1",
        borderBottomLeftRadius: "$1",
        borderRightWidth: 0
      },
      right: {
        borderTopRightRadius: "$1",
        borderBottomRightRadius: "$1",
        borderLeftWidth: 0
      }
    }
  },
  defaultVariants: {
    roundedBorder: "left"
  }
});
const PartialInputInfo = _ref25 => {
  let {
    children,
    roundedBorder
  } = _ref25;
  return /* @__PURE__ */jsx(StyledPartialInputInfo, {
    roundedBorder,
    alignItems: "center",
    children: /* @__PURE__ */jsx(Text, {
      children
    })
  });
};
const InputPartial = forwardRef((_ref26, forwardedRef) => {
  let {
    ref,
    errorMessage = "",
    successMessage = "",
    label,
    labelOptional,
    description,
    disabled: disabled2,
    value,
    prefix,
    suffix,
    size = "medium",
    rootProps,
    ...props
  } = _ref26;
  var _a, _b;
  const composedRefs = useComposedRefs$1(forwardedRef, ref);
  const name = toHyphenCase(label);
  const inputElementId = `dds-partial-input-element-${name}`;
  const inputLabelElementId = `dds-partial-input-label-${name}`;
  const descriptionElementId = `dds-partial-input-description-${name}`;
  const errorMessageElementId = `dds-partial-input-error-message-${name}`;
  const successMessageElementId = `dds-partial-input-success-message-${name}`;
  const describedById = (_b = (_a = errorMessage && errorMessageElementId) != null ? _a : successMessage && successMessageElementId) != null ? _b : description && descriptionElementId;
  return /* @__PURE__ */jsx(InputBase.Root, {
    direction: "column",
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      css: {
        width: "inherit"
      },
      children: [/* @__PURE__ */jsx(InputBase.Label, {
        id: inputLabelElementId,
        htmlFor: inputElementId,
        label,
        showOptionalLabel: labelOptional
      }), /* @__PURE__ */jsxs(InputPartialContentContainer, {
        fullWidth: size === "full-width",
        gap: 0,
        children: [prefix && /* @__PURE__ */jsx(PartialInputInfo, {
          roundedBorder: "left",
          children: prefix
        }), /* @__PURE__ */jsx(InputBase.Content, {
          className: inputContentWithPartials({
            hasPrefix: !!prefix,
            hasSuffix: !!suffix
          }),
          alignItems: "center",
          isInvalid: !!errorMessage.length,
          isSuccessful: !!successMessage.length,
          isDisabled: disabled2,
          size,
          children: /* @__PURE__ */jsx(InputBase.Field, {
            ref: composedRefs,
            disabled: disabled2,
            id: inputElementId,
            "aria-invalid": !!errorMessage.length,
            "aria-errormessage": errorMessageElementId,
            "aria-describedby": describedById,
            value,
            ...props,
            ...rootProps
          })
        }), suffix && /* @__PURE__ */jsx(PartialInputInfo, {
          roundedBorder: "right",
          children: suffix
        })]
      }), /* @__PURE__ */jsx(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage
      })]
    })
  });
});
InputPartial.displayName = "InputPartial";
const InputText = forwardRef((_ref27, forwardedRef) => {
  let {
    ref,
    size,
    errorMessage = "",
    successMessage = "",
    label,
    description,
    disabled: disabled2,
    labelOptional,
    rootProps,
    ...props
  } = _ref27;
  var _a, _b;
  const composedRefs = useComposedRefs$1(forwardedRef, ref);
  const name = toHyphenCase(label);
  const inputElementId = `dds-text-input-element-${name}`;
  const inputLabelElementId = `dds-text-input-label-${name}`;
  const descriptionElementId = `dds-text-input-description-${name}`;
  const errorMessageElementId = `dds-text-input-error-message-${name}`;
  const successMessageElementId = `dds-text-input-success-message-${name}`;
  const describedById = (_b = (_a = errorMessage && errorMessageElementId) != null ? _a : successMessage && successMessageElementId) != null ? _b : description && descriptionElementId;
  return /* @__PURE__ */jsx(InputBase.Root, {
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      grow: "1",
      children: [/* @__PURE__ */jsx(InputBase.Label, {
        id: inputLabelElementId,
        htmlFor: inputElementId,
        label,
        showOptionalLabel: labelOptional
      }), /* @__PURE__ */jsx(InputBase.Content, {
        isInvalid: !!(errorMessage == null ? void 0 : errorMessage.length),
        isSuccessful: !!(successMessage == null ? void 0 : successMessage.length),
        isDisabled: disabled2,
        size,
        children: /* @__PURE__ */jsx(InputBase.Field, {
          ref: composedRefs,
          disabled: disabled2,
          type: "text",
          name,
          id: inputElementId,
          "aria-invalid": !!(errorMessage == null ? void 0 : errorMessage.length),
          "aria-errormessage": errorMessageElementId,
          "aria-describedby": describedById,
          ...props,
          ...rootProps
        })
      }), /* @__PURE__ */jsx(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage
      })]
    })
  });
});
InputText.displayName = "InputText";
const CheckboxGroupContext = createContext$1({});
const useCheckboxGroupContext = () => useContext(CheckboxGroupContext);
function composeRefs() {
  for (var _len8 = arguments.length, o2 = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    o2[_key8] = arguments[_key8];
  }
  return e2 => o2.forEach(o3 => function (o4, e3) {
    typeof o4 == "function" ? o4(e3) : o4 != null && (o4.current = e3);
  }(o3, e2));
}
function useComposedRefs() {
  for (var _len9 = arguments.length, e2 = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    e2[_key9] = arguments[_key9];
  }
  return React.useCallback(composeRefs(...e2), e2);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const Slot = /* @__PURE__ */React.forwardRef((e2, o2) => {
  const {
    children: a2,
    ...s2
  } = e2;
  return React.Children.toArray(a2).some(l) ? /* @__PURE__ */React.createElement(React.Fragment, null, React.Children.map(a2, e3 => l(e3) ? /* @__PURE__ */React.createElement(n, _extends({}, s2, {
    ref: o2
  }), e3.props.children) : e3)) : /* @__PURE__ */React.createElement(n, _extends({}, s2, {
    ref: o2
  }), a2);
});
Slot.displayName = "Slot";
const n = /* @__PURE__ */React.forwardRef((r2, n2) => {
  const {
    children: l2,
    ...a2
  } = r2;
  return React.isValidElement(l2) ? /* @__PURE__ */React.cloneElement(l2, {
    ...o(a2, l2.props),
    ref: composeRefs(n2, l2.ref)
  }) : React.Children.count(l2) > 1 ? React.Children.only(null) : null;
});
n.displayName = "SlotClone";
const Slottable = _ref28 => {
  let {
    children: e2
  } = _ref28;
  return /* @__PURE__ */React.createElement(React.Fragment, null, e2);
};
function l(e2) {
  return React.isValidElement(e2) && e2.type === Slottable;
}
function o(e2, t2) {
  const r2 = {
    ...t2
  };
  for (const n2 in t2) {
    const l2 = e2[n2],
      o2 = t2[n2];
    /^on[A-Z]/.test(n2) ? r2[n2] = function () {
      o2 == null || o2(...arguments), l2 == null || l2(...arguments);
    } : n2 === "style" ? r2[n2] = {
      ...l2,
      ...o2
    } : n2 === "className" && (r2[n2] = [l2, o2].filter(Boolean).join(" "));
  }
  return {
    ...e2,
    ...r2
  };
}
const Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o2, i2) => ({
  ...o2,
  [i2]: /* @__PURE__ */React.forwardRef((o3, m2) => {
    const {
        asChild: a2,
        ...s2
      } = o3,
      n2 = a2 ? Slot : i2;
    return React.useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []), /* @__PURE__ */React.createElement(n2, _extends({}, s2, {
      ref: m2
    }));
  })
}), {});
const useLayoutEffect = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? React.useLayoutEffect : () => {};
const Presence = u2 => {
  const {
      present: o2,
      children: i2
    } = u2,
    s2 = function (n2) {
      const [u3, o3] = React.useState(),
        i3 = React.useRef({}),
        s3 = React.useRef(n2),
        c3 = React.useRef("none"),
        a3 = n2 ? "mounted" : "unmounted",
        [d2, m2] = function (e2, n3) {
          return React.useReducer((e3, t2) => {
            const r2 = n3[e3][t2];
            return r2 != null ? r2 : e3;
          }, e2);
        }(a3, {
          mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
          },
          unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
          },
          unmounted: {
            MOUNT: "mounted"
          }
        });
      return React.useEffect(() => {
        const e2 = r(i3.current);
        c3.current = d2 === "mounted" ? e2 : "none";
      }, [d2]), useLayoutEffect(() => {
        const e2 = i3.current,
          t2 = s3.current;
        if (t2 !== n2) {
          const u4 = c3.current,
            o4 = r(e2);
          if (n2) m2("MOUNT");else if (o4 === "none" || (e2 == null ? void 0 : e2.display) === "none") m2("UNMOUNT");else {
            const e3 = u4 !== o4;
            m2(t2 && e3 ? "ANIMATION_OUT" : "UNMOUNT");
          }
          s3.current = n2;
        }
      }, [n2, m2]), useLayoutEffect(() => {
        if (u3) {
          const e2 = e3 => {
              const n4 = r(i3.current).includes(e3.animationName);
              e3.target === u3 && n4 && m2("ANIMATION_END");
            },
            n3 = e3 => {
              e3.target === u3 && (c3.current = r(i3.current));
            };
          return u3.addEventListener("animationstart", n3), u3.addEventListener("animationcancel", e2), u3.addEventListener("animationend", e2), () => {
            u3.removeEventListener("animationstart", n3), u3.removeEventListener("animationcancel", e2), u3.removeEventListener("animationend", e2);
          };
        }
        m2("ANIMATION_END");
      }, [u3, m2]), {
        isPresent: ["mounted", "unmountSuspended"].includes(d2),
        ref: React.useCallback(e2 => {
          e2 && (i3.current = getComputedStyle(e2)), o3(e2);
        }, [])
      };
    }(o2),
    c2 = typeof i2 == "function" ? i2({
      present: s2.isPresent
    }) : React.Children.only(i2),
    a2 = useComposedRefs(s2.ref, c2.ref);
  return typeof i2 == "function" || s2.isPresent ? /* @__PURE__ */React.cloneElement(c2, {
    ref: a2
  }) : null;
};
function r(e2) {
  return (e2 == null ? void 0 : e2.animationName) || "none";
}
Presence.displayName = "Presence";
function createContext(t2, n2) {
  const o2 = /* @__PURE__ */React.createContext(n2);
  function r2(t3) {
    const {
        children: n3,
        ...r3
      } = t3,
      c2 = React.useMemo(() => r3, Object.values(r3));
    return React.createElement(o2.Provider, {
      value: c2
    }, n3);
  }
  return r2.displayName = t2 + "Provider", [r2, function (r3) {
    const c2 = React.useContext(o2);
    if (c2) return c2;
    if (n2 !== void 0) return n2;
    throw new Error(`\`${r3}\` must be used within \`${t2}\``);
  }];
}
function createContextScope(n2) {
  let o2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let r2 = [];
  const c2 = () => {
    const t2 = r2.map(t3 => /* @__PURE__ */React.createContext(t3));
    return function (o3) {
      const r3 = (o3 == null ? void 0 : o3[n2]) || t2;
      return React.useMemo(() => ({
        [`__scope${n2}`]: {
          ...o3,
          [n2]: r3
        }
      }), [o3, r3]);
    };
  };
  return c2.scopeName = n2, [function (t2, o3) {
    const c3 = /* @__PURE__ */React.createContext(o3),
      u2 = r2.length;
    function s2(t3) {
      const {
          scope: o4,
          children: r3,
          ...s3
        } = t3,
        i2 = (o4 == null ? void 0 : o4[n2][u2]) || c3,
        a2 = React.useMemo(() => s3, Object.values(s3));
      return React.createElement(i2.Provider, {
        value: a2
      }, r3);
    }
    return r2 = [...r2, o3], s2.displayName = t2 + "Provider", [s2, function (r3, s3) {
      const i2 = (s3 == null ? void 0 : s3[n2][u2]) || c3,
        a2 = React.useContext(i2);
      if (a2) return a2;
      if (o3 !== void 0) return o3;
      throw new Error(`\`${r3}\` must be used within \`${t2}\``);
    }];
  }, t(c2, ...o2)];
}
function t() {
  for (var _len10 = arguments.length, t2 = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    t2[_key10] = arguments[_key10];
  }
  const n2 = t2[0];
  if (t2.length === 1) return n2;
  const o2 = () => {
    const o3 = t2.map(e2 => ({
      useScope: e2(),
      scopeName: e2.scopeName
    }));
    return function (t3) {
      const r2 = o3.reduce((e2, _ref29) => {
        let {
          useScope: n3,
          scopeName: o4
        } = _ref29;
        return {
          ...e2,
          ...n3(t3)[`__scope${o4}`]
        };
      }, {});
      return React.useMemo(() => ({
        [`__scope${n2.scopeName}`]: r2
      }), [r2]);
    };
  };
  return o2.scopeName = n2.scopeName, o2;
}
const [i, a] = createContext("Label", {
  id: void 0,
  controlRef: {
    current: null
  }
});
const useLabelContext = e2 => {
  const t2 = a("LabelConsumer"),
    {
      controlRef: r2
    } = t2;
  return React.useEffect(() => {
    e2 && (r2.current = e2);
  }, [e2, r2]), t2.id;
};
function useSize(r2) {
  const [i2, t2] = React.useState(void 0);
  return React.useEffect(() => {
    if (r2) {
      const e2 = new ResizeObserver(e3 => {
        if (!Array.isArray(e3)) return;
        if (!e3.length) return;
        const i3 = e3[0];
        let o2, n2;
        if ("borderBoxSize" in i3) {
          const e4 = i3.borderBoxSize,
            r3 = Array.isArray(e4) ? e4[0] : e4;
          o2 = r3.inlineSize, n2 = r3.blockSize;
        } else {
          const e4 = r2.getBoundingClientRect();
          o2 = e4.width, n2 = e4.height;
        }
        t2({
          width: o2,
          height: n2
        });
      });
      return e2.observe(r2, {
        box: "border-box"
      }), () => e2.unobserve(r2);
    }
    t2(void 0);
  }, [r2]), i2;
}
function usePrevious(r2) {
  const u2 = React.useRef({
    value: r2,
    previous: r2
  });
  return React.useMemo(() => (u2.current.value !== r2 && (u2.current.previous = u2.current.value, u2.current.value = r2), u2.current.previous), [r2]);
}
function useCallbackRef$1(r2) {
  const t2 = React.useRef(r2);
  return React.useEffect(() => {
    t2.current = r2;
  }), React.useMemo(() => function () {
    var r3;
    for (var _len11 = arguments.length, e2 = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      e2[_key11] = arguments[_key11];
    }
    return (r3 = t2.current) === null || r3 === void 0 ? void 0 : r3.call(t2, ...e2);
  }, []);
}
function useControllableState(_ref30) {
  let {
    prop: o2,
    defaultProp: r2,
    onChange: n2 = () => {}
  } = _ref30;
  const [a2, u2] = function (_ref31) {
      let {
        defaultProp: o3,
        onChange: r3
      } = _ref31;
      const n3 = React.useState(o3),
        [a3] = n3,
        u3 = React.useRef(a3),
        c3 = useCallbackRef$1(r3);
      return React.useEffect(() => {
        u3.current !== a3 && (c3(a3), u3.current = a3);
      }, [a3, u3, c3]), n3;
    }({
      defaultProp: r2,
      onChange: n2
    }),
    c2 = o2 !== void 0,
    f2 = c2 ? o2 : a2,
    l2 = useCallbackRef$1(n2);
  return [f2, React.useCallback(e2 => {
    if (c2) {
      const t2 = e2,
        r3 = typeof e2 == "function" ? t2(o2) : e2;
      r3 !== o2 && l2(r3);
    } else u2(e2);
  }, [c2, o2, u2, l2])];
}
function composeEventHandlers(e2, n2) {
  let {
    checkForDefaultPrevented: t2 = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (r2) {
    if (e2 == null || e2(r2), t2 === false || !r2.defaultPrevented) return n2 == null ? void 0 : n2(r2);
  };
}
const [u, p] = createContextScope("Checkbox");
const [m, b] = u("Checkbox");
const Checkbox$1 = /* @__PURE__ */React.forwardRef((t2, o2) => {
  const {
      __scopeCheckbox: a2,
      "aria-labelledby": i2,
      name: u2,
      checked: p2,
      defaultChecked: b2,
      required: k2,
      disabled: C2,
      value: y2 = "on",
      onCheckedChange: v2,
      ...E2
    } = t2,
    [w2, g2] = React.useState(null),
    I2 = useComposedRefs(o2, e2 => g2(e2)),
    R2 = useLabelContext(w2),
    D2 = i2 || R2,
    P2 = React.useRef(false),
    _ = !w2 || Boolean(w2.closest("form")),
    [q2 = false, K] = useControllableState({
      prop: p2,
      defaultProp: b2,
      onChange: v2
    });
  return React.createElement(m, {
    scope: a2,
    state: q2,
    disabled: C2
  }, /* @__PURE__ */React.createElement(Primitive.button, _extends({
    type: "button",
    role: "checkbox",
    "aria-checked": x(q2) ? "mixed" : q2,
    "aria-labelledby": D2,
    "aria-required": k2,
    "data-state": h(q2),
    "data-disabled": C2 ? "" : void 0,
    disabled: C2,
    value: y2
  }, E2, {
    ref: I2,
    onKeyDown: composeEventHandlers(t2.onKeyDown, e2 => {
      e2.key === "Enter" && e2.preventDefault();
    }),
    onClick: composeEventHandlers(t2.onClick, e2 => {
      K(e3 => !!x(e3) || !e3), _ && (P2.current = e2.isPropagationStopped(), P2.current || e2.stopPropagation());
    })
  })), _ && /* @__PURE__ */React.createElement(f, {
    control: w2,
    bubbles: !P2.current,
    name: u2,
    value: y2,
    checked: q2,
    required: k2,
    disabled: C2,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const CheckboxIndicator = /* @__PURE__ */React.forwardRef((r2, o2) => {
  const {
      __scopeCheckbox: a2,
      forceMount: n2,
      ...c2
    } = r2,
    i2 = b("CheckboxIndicator", a2);
  return React.createElement(Presence, {
    present: n2 || x(i2.state) || i2.state === true
  }, /* @__PURE__ */React.createElement(Primitive.span, _extends({
    "data-state": h(i2.state),
    "data-disabled": i2.disabled ? "" : void 0
  }, c2, {
    ref: o2,
    style: {
      pointerEvents: "none",
      ...r2.style
    }
  })));
});
const f = e2 => {
  const {
      control: t2,
      checked: r2,
      bubbles: n2 = true,
      ...c2
    } = e2,
    i2 = React.useRef(null),
    s2 = usePrevious(r2),
    u2 = useSize(t2);
  return React.useEffect(() => {
    const e3 = i2.current,
      t3 = window.HTMLInputElement.prototype,
      o2 = Object.getOwnPropertyDescriptor(t3, "checked").set;
    if (s2 !== r2 && o2) {
      const t4 = new Event("click", {
        bubbles: n2
      });
      e3.indeterminate = x(r2), o2.call(e3, !x(r2) && r2), e3.dispatchEvent(t4);
    }
  }, [s2, r2, n2]), /* @__PURE__ */React.createElement("input", _extends({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: !x(r2) && r2
  }, c2, {
    tabIndex: -1,
    ref: i2,
    style: {
      ...e2.style,
      ...u2,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function x(e2) {
  return e2 === "indeterminate";
}
function h(e2) {
  return x(e2) ? "indeterminate" : e2 ? "checked" : "unchecked";
}
const Root = Checkbox$1;
const Indicator = CheckboxIndicator;
var faCheck$1 = {};
Object.defineProperty(faCheck$1, "__esModule", {
  value: true
});
var faCheck_2 = faCheck$1.faCheck = void 0;
const faCheck = {
  prefix: "fal",
  iconName: "faCheck",
  icon: [512, 512, [], "", "M475.3 123.3l-272 272C200.2 398.4 196.1 400 192 400s-8.188-1.562-11.31-4.688l-144-144c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0L192 361.4l260.7-260.7c6.25-6.25 16.38-6.25 22.62 0S481.6 117.1 475.3 123.3z"]
};
faCheck_2 = faCheck$1.faCheck = faCheck;
var CheckboxClassNames = /* @__PURE__ */(CheckboxClassNames2 => {
  CheckboxClassNames2["CheckboxInCheckboxGroup"] = "dds--checkbox-group-item";
  CheckboxClassNames2["CheckboxHoverIndicator"] = "dds--checkbox-hover-indicator";
  return CheckboxClassNames2;
})(CheckboxClassNames || {});
const CheckboxRoot = styled(Flex, {
  variants: {
    fullWidth: FullWidthVariant
  }
});
const StyledIndicator$1 = styled(Indicator, {
  size: "$2",
  boxSizing: "border-box"
});
const StyledCheckboxRoot = styled(Root, {
  size: "$2",
  minWidth: "$2",
  background: "$white",
  border: "1px solid $blue3",
  borderRadius: "$1",
  padding: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  '&[data-state="checked"]': {
    background: "$blue8",
    borderColor: "$blue8",
    color: "$white"
  },
  "&:focus": {
    borderColor: "$blue5"
  },
  "&:hover": {
    borderColor: "$blue4"
  },
  [`& .${CheckboxClassNames.CheckboxHoverIndicator}`]: {
    display: "none",
    color: "$blue2"
  },
  [`&:not([data-state="checked"]):not(:disabled):hover .${CheckboxClassNames.CheckboxHoverIndicator}`]: {
    display: "block"
  },
  [`&:not(.${CheckboxClassNames.CheckboxInCheckboxGroup})[aria-invalid="true"]`]: {
    borderColor: "$red6"
  },
  "&:disabled": {
    background: "$gray2",
    borderColor: "$gray3",
    color: "$gray5",
    cursor: "not-allowed"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  variants: {
    success: {
      true: {
        [`&:not(.${CheckboxClassNames.CheckboxInCheckboxGroup})`]: {
          borderColor: "$green6"
        }
      }
    }
  }
});
const StyledLabel$1 = styled("label", {
  display: "flex",
  gap: "$half",
  alignItems: "center"
});
const CheckboxLabel = _ref32 => {
  let {
    id,
    label,
    htmlFor,
    showOptionalLabel
  } = _ref32;
  return /* @__PURE__ */jsxs(StyledLabel$1, {
    id,
    htmlFor,
    children: [/* @__PURE__ */jsx(Text, {
      children: label
    }), showOptionalLabel && /* @__PURE__ */jsx(Text, {
      variant: "metadata",
      children: "(optional)"
    })]
  });
};
const StyledCheckboxBase = forwardRef((_ref33, forwardedRef) => {
  let {
    checked,
    disabled: disabled2,
    onChange: onChange2 = () => {},
    success,
    error,
    descriptionElementId,
    label,
    labelElementId,
    optional,
    rootProps,
    ...props
  } = _ref33;
  return /* @__PURE__ */jsxs(StyledCheckboxRoot, {
    ref: forwardedRef,
    success: !!success,
    checked,
    disabled: disabled2,
    onCheckedChange: checked2 => {
      if (typeof checked2 === "boolean") {
        onChange2(checked2);
      }
    },
    required: !optional,
    role: "checkbox",
    "aria-checked": checked,
    "aria-invalid": !!error,
    "aria-describedby": descriptionElementId,
    "aria-label": label,
    "aria-disabled": disabled2,
    "aria-labelledby": labelElementId,
    ...props,
    ...rootProps,
    children: [/* @__PURE__ */jsx(Icon, {
      className: CheckboxClassNames.CheckboxHoverIndicator,
      size: "small",
      icon: faCheck_2
    }), /* @__PURE__ */jsx(StyledIndicator$1, {
      children: /* @__PURE__ */jsx(Icon, {
        size: "small",
        icon: faCheck_2
      })
    })]
  });
});
StyledCheckboxBase.displayName = "StyledCheckboxBase";
const CheckboxBase = {
  Root: CheckboxRoot,
  Label: CheckboxLabel,
  Checkbox: StyledCheckboxBase,
  Description: InputBase.Description,
  ErrorState: InputBase.ErrorState,
  SuccessState: InputBase.SuccessState
};
const Checkbox = forwardRef((_ref34, forwardedRef) => {
  let {
    ariaLabel,
    label,
    description,
    success = "",
    error = "",
    disabled: disabled2 = false,
    checked,
    labelOptional,
    onChange: onChange2 = () => {},
    rootProps
  } = _ref34;
  var _a, _b;
  const {
    isInCheckboxGroup,
    checkboxGroupError,
    checkboxGroupErrorId,
    checkboxGroupSuccess,
    checkboxGroupSuccessId,
    checkboxGroupDisabled
  } = useCheckboxGroupContext();
  const name = toHyphenCase(label || ariaLabel);
  const checkboxElementId = `dds-checkbox-element-${name}`;
  const checkboxLabelElementId = `dds-checkbox-label-${name}`;
  const errorMessageElementId = checkboxGroupErrorId != null ? checkboxGroupErrorId : `dds-checkbox-error-message-${name}`;
  const descriptionElementId = `dds-checkbox-description-${name}`;
  const describedById = (_b = (_a = checkboxGroupError && checkboxGroupErrorId) != null ? _a : checkboxGroupSuccess && checkboxGroupSuccessId) != null ? _b : description && descriptionElementId;
  const showOptionalLabel = isInCheckboxGroup ? false : labelOptional;
  return /* @__PURE__ */jsxs(CheckboxBase.Root, {
    gap: 1,
    children: [/* @__PURE__ */jsx(CheckboxBase.Checkbox, {
      ref: forwardedRef,
      className: isInCheckboxGroup ? CheckboxClassNames.CheckboxInCheckboxGroup : "",
      disabled: checkboxGroupDisabled != null ? checkboxGroupDisabled : disabled2,
      checked,
      error: checkboxGroupError != null ? checkboxGroupError : error,
      success: checkboxGroupSuccess != null ? checkboxGroupSuccess : success,
      onChange: onChange2,
      label: label || ariaLabel,
      labelElementId: label && checkboxLabelElementId,
      descriptionElementId: describedById,
      rootProps
    }), /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      css: {
        gap: "2px"
      },
      children: [label && /* @__PURE__ */jsx(CheckboxBase.Label, {
        id: checkboxLabelElementId,
        label,
        htmlFor: checkboxElementId,
        showOptionalLabel
      }), description && /* @__PURE__ */jsx(CheckboxBase.Description, {
        id: descriptionElementId,
        children: description
      }), !isInCheckboxGroup && /* @__PURE__ */jsx(CheckboxBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage: checkboxGroupError != null ? checkboxGroupError : error
      }), !isInCheckboxGroup && /* @__PURE__ */jsx(CheckboxBase.SuccessState, {
        successMessage: error ? "" : success
      })]
    })]
  });
});
Checkbox.displayName = "Checkbox";
const CheckboxGroup = forwardRef((_ref35, forwardedRef) => {
  let {
    label,
    labelOptional,
    disabled: disabled2,
    children,
    error = "",
    success = ""
  } = _ref35;
  const name = toHyphenCase(label);
  const checkboxGroupLabelId = `dds-checkbox-group-label-${name}`;
  const checkboxGroupErrorId = `dds-checkbox-group-error-${name}`;
  const checkboxGroupSuccessId = `dds-checkbox-group-success-${name}`;
  return /* @__PURE__ */jsx(Flex, {
    ref: forwardedRef,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: 1,
      children: [/* @__PURE__ */jsxs(Flex, {
        direction: "column",
        css: {
          gap: "2px"
        },
        children: [/* @__PURE__ */jsx(CheckboxBase.Label, {
          id: checkboxGroupLabelId,
          label,
          htmlFor: checkboxGroupLabelId,
          showOptionalLabel: labelOptional
        }), /* @__PURE__ */jsx(CheckboxBase.ErrorState, {
          id: checkboxGroupErrorId,
          errorMessage: error
        }), /* @__PURE__ */jsx(CheckboxBase.SuccessState, {
          successMessage: error ? "" : success
        })]
      }), /* @__PURE__ */jsx(CheckboxGroupContext.Provider, {
        value: {
          isInCheckboxGroup: true,
          checkboxGroupError: error,
          checkboxGroupErrorId,
          checkboxGroupSuccess: success,
          checkboxGroupSuccessId,
          checkboxGroupDisabled: disabled2
        },
        children
      })]
    })
  });
});
CheckboxGroup.displayName = "CheckboxGroup";
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler) {
  let {
    checkForDefaultPrevented = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}
function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
  const Context = /* @__PURE__ */createContext$1(defaultContext);
  function Provider(props) {
    const {
      children,
      ...context
    } = props;
    const value = useMemo(() => context, Object.values(context));
    return /* @__PURE__ */createElement$1(Context.Provider, {
      value
    }, children);
  }
  function useContext$1(consumerName) {
    const context = useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useContext$1];
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName) {
  let createContextScopeDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae11092(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */createContext$1(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider(props) {
      const {
        scope,
        children,
        ...context
      } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const value = useMemo(() => context, Object.values(context));
      return /* @__PURE__ */createElement$1(Context.Provider, {
        value
      }, children);
    }
    function useContext$1(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const context = useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [Provider, useContext$1];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map(defaultContext => {
      return /* @__PURE__ */createContext$1(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return useMemo(() => ({
        [`__scope${scopeName}`]: {
          ...scope,
          [scopeName]: contexts
        }
      }), [scope, contexts]);
    };
  };
  createScope.scopeName = scopeName;
  return [$c512c27ab02ef895$export$fd42f52fd3ae11092, $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)];
}
function $c512c27ab02ef895$var$composeContextScopes() {
  for (var _len12 = arguments.length, scopes = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    scopes[_key12] = arguments[_key12];
  }
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(createScope => ({
      useScope: createScope(),
      scopeName: createScope.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, _ref36) => {
        let {
          useScope,
          scopeName
        } = _ref36;
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return useMemo(() => ({
        [`__scope${baseScope.scopeName}`]: nextScopes1
      }), [nextScopes1]);
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function") ref(value);else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af() {
  for (var _len13 = arguments.length, refs = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    refs[_key13] = arguments[_key13];
  }
  return node => refs.forEach(ref => $6ed0406888f73fc4$var$setRef(ref, node));
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05() {
  for (var _len14 = arguments.length, refs = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    refs[_key14] = arguments[_key14];
  }
  return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = _ref37 => {
  let {
    children
  } = _ref37;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) overrideProps[propName] = function () {
      childPropValue === null || childPropValue === void 0 || childPropValue(...arguments);
      slotPropValue === null || slotPropValue === void 0 || slotPropValue(...arguments);
    };else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $8927f6f2acc4f386$var$NODES = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"];
const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node) => {
  const Node = /* @__PURE__ */forwardRef((props, forwardedRef) => {
    const {
      asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */createElement$1(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
  if (target) flushSync(() => target.dispatchEvent(event));
}
const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect$1 : () => {};
const $1746a345f3d73bb7$var$useReactId = React["useId".toString()] || (() => void 0);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
  const [id, setId] = React.useState($1746a345f3d73bb7$var$useReactId());
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (!deterministicId) setId(reactId => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}
const $b73a6c6685e72184$var$NAME = "Label";
const [$b73a6c6685e72184$var$LabelProvider, $b73a6c6685e72184$var$useLabelContextImpl] = $c512c27ab02ef895$export$fd42f52fd3ae1109($b73a6c6685e72184$var$NAME, {
  id: void 0,
  controlRef: {
    current: null
  }
});
const $b73a6c6685e72184$export$feddbbf47baabdb9 = element => {
  const context = $b73a6c6685e72184$var$useLabelContextImpl("LabelConsumer");
  const {
    controlRef
  } = context;
  useEffect(() => {
    if (element) controlRef.current = element;
  }, [element, controlRef]);
  return context.id;
};
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */new Map()
  });
  const CollectionProvider = props => {
    const {
      scope,
      children
    } = props;
    const ref = React__default.useRef(null);
    const itemMap = React__default.useRef( /* @__PURE__ */new Map()).current;
    return /* @__PURE__ */React__default.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children
    } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      ref: composedRefs
    }, children);
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children,
      ...itemData
    } = props;
    const ref = React__default.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React__default.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React__default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort((a2, b2) => orderedNodes.indexOf(a2.ref.current) - orderedNodes.indexOf(b2.ref.current));
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(() => function () {
    var _callbackRef$current;
    for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      args[_key15] = arguments[_key15];
    }
    return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
  }, []);
}
function $71cd76cc60e0454e$export$6f32135080cb4c3(_ref38) {
  let {
    prop: prop3,
    defaultProp,
    onChange: onChange2 = () => {}
  } = _ref38;
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop3 !== void 0;
  const value1 = isControlled ? prop3 : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange2);
  const setValue = useCallback(nextValue => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop3) : nextValue;
      if (value !== prop3) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [isControlled, prop3, setUncontrolledProp, handleChange]);
  return [value1, setValue];
}
function $71cd76cc60e0454e$var$useUncontrolledState(_ref39) {
  let {
    defaultProp,
    onChange: onChange2
  } = _ref39;
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange2);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}
const $f631663db3294ace$var$DirectionContext = /* @__PURE__ */createContext$1(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
  const globalDir = useContext($f631663db3294ace$var$DirectionContext);
  return localDir || globalDir || "ltr";
}
const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d7bdfb9eb0fdf311$var$GROUP_NAME, [$d7bdfb9eb0fdf311$var$createCollectionScope]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$Collection.Provider, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$Collection.Slot, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends({}, props, {
    ref: forwardedRef
  }))));
});
const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    orientation,
    loop = false,
    dir,
    currentTabStopId: currentTabStopIdProp,
    defaultCurrentTabStopId,
    onCurrentTabStopIdChange,
    onEntryFocus,
    ...groupProps
  } = props;
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = useState(false);
  const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEntryFocus);
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = useRef(false);
  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
      return () => node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
    scope: __scopeRovingFocusGroup,
    orientation,
    dir: direction,
    loop,
    currentTabStopId,
    onItemFocus: useCallback(tabStopId => setCurrentTabStopId(tabStopId), [setCurrentTabStopId]),
    onItemShiftTab: useCallback(() => setIsTabbingBackOut(true), [])
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
    tabIndex: isTabbingBackOut ? -1 : 0,
    "data-orientation": orientation
  }, groupProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...props.style
    },
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, () => {
      isClickFocusRef.current = true;
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, event => {
      const isKeyboardFocus = !isClickFocusRef.current;
      if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
        const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
        event.currentTarget.dispatchEvent(entryFocusEvent);
        if (!entryFocusEvent.defaultPrevented) {
          const items = getItems().filter(item => item.focusable);
          const activeItem = items.find(item => item.active);
          const currentItem = items.find(item => item.id === currentTabStopId);
          const candidateItems = [activeItem, currentItem, ...items].filter(Boolean);
          const candidateNodes = candidateItems.map(item => item.ref.current);
          $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
        }
      }
      isClickFocusRef.current = false;
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, () => setIsTabbingBackOut(false))
  })));
});
const $d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    focusable = true,
    active = false,
    ...itemProps
  } = props;
  const id = $1746a345f3d73bb7$export$f680877a34711e37();
  const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
  const isCurrentTabStop = context.currentTabStopId === id;
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id,
    focusable,
    active
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
    tabIndex: isCurrentTabStop ? 0 : -1,
    "data-orientation": context.orientation
  }, itemProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, event => {
      if (!focusable) event.preventDefault();else context.onItemFocus(id);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => context.onItemFocus(id)),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
      if (event.key === "Tab" && event.shiftKey) {
        context.onItemShiftTab();
        return;
      }
      if (event.target !== event.currentTarget) return;
      const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
      if (focusIntent !== void 0) {
        event.preventDefault();
        const items = getItems().filter(item => item.focusable);
        let candidateNodes = items.map(item => item.ref.current);
        if (focusIntent === "last") candidateNodes.reverse();else if (focusIntent === "prev" || focusIntent === "next") {
          if (focusIntent === "prev") candidateNodes.reverse();
          const currentIndex = candidateNodes.indexOf(event.currentTarget);
          candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(() => $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
      }
    })
  })));
});
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
  const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  const [size, setSize] = useState(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver(entries => {
        if (!Array.isArray(entries)) return;
        if (!entries.length) return;
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width,
          height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else setSize(void 0);
  }, [element]);
  return size;
}
function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
  const ref = useRef({
    value,
    previous: value
  });
  return useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [value]);
}
function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
  return useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}
const $921a889cee6df7e8$export$99c2b779aa4e8b8b = props => {
  const {
    present,
    children
  } = props;
  const presence = $921a889cee6df7e8$var$usePresence(present);
  const child = typeof children === "function" ? children({
    present: presence.isPresent
  }) : Children.only(children);
  const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? /* @__PURE__ */cloneElement(child, {
    ref
  }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence(present) {
  const [node1, setNode] = useState();
  const stylesRef = useRef({});
  const prevPresentRef = useRef(present);
  const prevAnimationNameRef = useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  useEffect(() => {
    const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const styles2 = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles2);
      if (present) send("MOUNT");else if (currentAnimationName === "none" || (styles2 === null || styles2 === void 0 ? void 0 : styles2.display) === "none") send("UNMOUNT");else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) send("ANIMATION_OUT");else send("UNMOUNT");
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (node1) {
      const handleAnimationEnd = event => {
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node1 && isCurrentAnimation) flushSync(() => send("ANIMATION_END"));
      };
      const handleAnimationStart = event => {
        if (event.target === node1) prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
      };
      node1.addEventListener("animationstart", handleAnimationStart);
      node1.addEventListener("animationcancel", handleAnimationEnd);
      node1.addEventListener("animationend", handleAnimationEnd);
      return () => {
        node1.removeEventListener("animationstart", handleAnimationStart);
        node1.removeEventListener("animationcancel", handleAnimationEnd);
        node1.removeEventListener("animationend", handleAnimationEnd);
      };
    } else send("ANIMATION_END");
  }, [node1, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: useCallback(node => {
      if (node) stylesRef.current = getComputedStyle(node);
      setNode(node);
    }, [])
  };
}
function $921a889cee6df7e8$var$getAnimationName(styles2) {
  return (styles2 === null || styles2 === void 0 ? void 0 : styles2.animationName) || "none";
}
const $ce77a8961b41be9e$var$RADIO_NAME = "Radio";
const [$ce77a8961b41be9e$var$createRadioContext, $ce77a8961b41be9e$export$67d2296460f1b002] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($ce77a8961b41be9e$var$RADIO_NAME);
const [$ce77a8961b41be9e$var$RadioProvider, $ce77a8961b41be9e$var$useRadioContext] = $ce77a8961b41be9e$var$createRadioContext($ce77a8961b41be9e$var$RADIO_NAME);
const $ce77a8961b41be9e$export$d7b12c4107be0d61 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadio,
    "aria-labelledby": ariaLabelledby,
    name,
    checked = false,
    required,
    disabled: disabled2,
    value = "on",
    onCheck,
    ...radioProps
  } = props;
  const [button, setButton] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node => setButton(node));
  const labelId = $b73a6c6685e72184$export$feddbbf47baabdb9(button);
  const labelledBy = ariaLabelledby || labelId;
  const hasConsumerStoppedPropagationRef = useRef(false);
  const isFormControl = button ? Boolean(button.closest("form")) : true;
  return /* @__PURE__ */createElement$1($ce77a8961b41be9e$var$RadioProvider, {
    scope: __scopeRadio,
    checked,
    disabled: disabled2
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
    type: "button",
    role: "radio",
    "aria-checked": checked,
    "aria-labelledby": labelledBy,
    "data-state": $ce77a8961b41be9e$var$getState(checked),
    "data-disabled": disabled2 ? "" : void 0,
    disabled: disabled2,
    value
  }, radioProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, event => {
      if (!checked) onCheck === null || onCheck === void 0 || onCheck();
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /* @__PURE__ */createElement$1($ce77a8961b41be9e$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name,
    value,
    checked,
    required,
    disabled: disabled2,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const $ce77a8961b41be9e$var$INDICATOR_NAME = "RadioIndicator";
const $ce77a8961b41be9e$export$d35a9ffa9a04f9e7 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadio,
    forceMount,
    ...indicatorProps
  } = props;
  const context = $ce77a8961b41be9e$var$useRadioContext($ce77a8961b41be9e$var$INDICATOR_NAME, __scopeRadio);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.checked
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
    "data-state": $ce77a8961b41be9e$var$getState(context.checked),
    "data-disabled": context.disabled ? "" : void 0
  }, indicatorProps, {
    ref: forwardedRef
  })));
});
const $ce77a8961b41be9e$var$BubbleInput = props => {
  const {
    control,
    checked,
    bubbles = true,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
  const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control);
  useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */createElement$1("input", _extends({
    type: "radio",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps, {
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      ...controlSize,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $ce77a8961b41be9e$var$getState(checked) {
  return checked ? "checked" : "unchecked";
}
const $f99a8c78507165f7$var$ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
const $f99a8c78507165f7$var$RADIO_GROUP_NAME = "RadioGroup";
const [$f99a8c78507165f7$var$createRadioGroupContet, $f99a8c78507165f7$export$c547093f11b76da2] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($f99a8c78507165f7$var$RADIO_GROUP_NAME, [$d7bdfb9eb0fdf311$export$c7109489551a4f4, $ce77a8961b41be9e$export$67d2296460f1b002]);
const $f99a8c78507165f7$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const $f99a8c78507165f7$var$useRadioScope = $ce77a8961b41be9e$export$67d2296460f1b002();
const [$f99a8c78507165f7$var$RadioGroupProvider, $f99a8c78507165f7$var$useRadioGroupContext] = $f99a8c78507165f7$var$createRadioGroupContet($f99a8c78507165f7$var$RADIO_GROUP_NAME);
const $f99a8c78507165f7$export$a98f0dcb43a68a25 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadioGroup,
    name,
    "aria-labelledby": ariaLabelledby,
    defaultValue,
    value: valueProp,
    required = false,
    orientation,
    dir,
    loop = true,
    onValueChange,
    ...groupProps
  } = props;
  const labelId = $b73a6c6685e72184$export$feddbbf47baabdb9();
  const labelledBy = ariaLabelledby || labelId;
  const rovingFocusGroupScope = $f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  return /* @__PURE__ */createElement$1($f99a8c78507165f7$var$RadioGroupProvider, {
    scope: __scopeRadioGroup,
    name,
    required,
    value,
    onValueChange: setValue
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation,
    dir: direction,
    loop
  }), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
    role: "radiogroup",
    "aria-required": required,
    "aria-orientation": orientation,
    "aria-labelledby": labelledBy,
    dir: direction
  }, groupProps, {
    ref: forwardedRef
  }))));
});
const $f99a8c78507165f7$var$ITEM_NAME = "RadioGroupItem";
const $f99a8c78507165f7$export$9f866c100ef519e4 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadioGroup,
    disabled: disabled2,
    ...itemProps
  } = props;
  const context = $f99a8c78507165f7$var$useRadioGroupContext($f99a8c78507165f7$var$ITEM_NAME, __scopeRadioGroup);
  const rovingFocusGroupScope = $f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
  const radioScope = $f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const checked = context.value === itemProps.value;
  const isArrowKeyPressedRef = useRef(false);
  useEffect(() => {
    const handleKeyDown = event => {
      if ($f99a8c78507165f7$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
    };
    const handleKeyUp = () => isArrowKeyPressedRef.current = false;
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled2,
    active: checked
  }), /* @__PURE__ */createElement$1($ce77a8961b41be9e$export$d7b12c4107be0d61, _extends({
    disabled: disabled2,
    required: context.required,
    checked
  }, radioScope, itemProps, {
    name: context.name,
    ref: composedRefs,
    onCheck: () => context.onValueChange(itemProps.value),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(event => {
      if (event.key === "Enter") event.preventDefault();
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onFocus, () => {
      var _ref$current;
      if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
    })
  })));
});
const $f99a8c78507165f7$export$5fb54c671a65c88 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadioGroup,
    ...indicatorProps
  } = props;
  const radioScope = $f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
  return /* @__PURE__ */createElement$1($ce77a8961b41be9e$export$d35a9ffa9a04f9e7, _extends({}, radioScope, indicatorProps, {
    ref: forwardedRef
  }));
});
const $f99a8c78507165f7$export$be92b6f5f03c0fe9 = $f99a8c78507165f7$export$a98f0dcb43a68a25;
const $f99a8c78507165f7$export$6d08773d2e66f8f2 = $f99a8c78507165f7$export$9f866c100ef519e4;
const $f99a8c78507165f7$export$adb584737d712b70 = $f99a8c78507165f7$export$5fb54c671a65c88;
const StyledLabel = styled("label", {
  display: "flex",
  gap: "$half",
  alignItems: "center"
});
const StyledRadioGroupRoot = styled($f99a8c78507165f7$export$be92b6f5f03c0fe9, {
  maxWidth: 250,
  variants: {
    fullWidth: {
      true: {
        width: "100%"
      }
    }
  }
});
const StyledRadioItem = styled($f99a8c78507165f7$export$6d08773d2e66f8f2, {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  size: "$2",
  borderRadius: "$round",
  border: "1px solid $blue3",
  background: "$white",
  "&:hover": {
    borderColor: "$blue4"
  },
  "&::after": {
    background: "transparent",
    size: "10px",
    borderRadius: "50%",
    position: "absolute",
    top: "calc(50% - 5px)",
    left: "calc(50% - 5px)"
  },
  "&:not(:disabled):hover:after": {
    background: "$blue2"
  },
  '&[aria-checked="false"]:hover:after': {
    content: '""'
  },
  '&[aria-checked="true"]:disabled:after': {
    content: '""',
    background: "$gray5"
  },
  '&[aria-checked="true"]': {
    borderColor: "$blue8"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1
  },
  "&:disabled": {
    background: "$gray2",
    borderColor: "$gray3",
    cursor: "not-allowed"
  }
});
const StyledRadioIndicator = styled($f99a8c78507165f7$export$adb584737d712b70, {
  display: "block",
  size: "10px",
  minWidth: "10px",
  background: "$blue8",
  borderRadius: "$round",
  "&:focus": {
    borderColor: "$blue5"
  },
  "&:hover": {
    borderColor: "$blue4"
  },
  "&:disabled": {
    background: "$gray2",
    borderColor: "$gray3",
    color: "$gray5"
  }
});
const StyledRadioLabel = _ref40 => {
  let {
    id,
    label,
    htmlFor,
    optional
  } = _ref40;
  return /* @__PURE__ */jsxs(StyledLabel, {
    id,
    htmlFor,
    children: [/* @__PURE__ */jsx(Text, {
      children: label
    }), optional && /* @__PURE__ */jsx(Text, {
      variant: "metadata",
      children: "(optional)"
    })]
  });
};
const RadioItem$1 = forwardRef((_ref41, forwardedRef) => {
  let {
    value,
    disabled: disabled2,
    error,
    descriptionElementId,
    label,
    labelElementId,
    children,
    ...props
  } = _ref41;
  return /* @__PURE__ */jsx(StyledRadioItem, {
    ref: forwardedRef,
    disabled: disabled2,
    role: "radio",
    value,
    "aria-invalid": !!error,
    "aria-describedby": descriptionElementId,
    "aria-label": label,
    "aria-disabled": disabled2,
    "aria-labelledby": labelElementId,
    ...props,
    children
  });
});
RadioItem$1.displayName = "RadioItem";
const RadioGroupBase = {
  Root: StyledRadioGroupRoot,
  Label: StyledRadioLabel,
  RadioItem: RadioItem$1,
  RadioIndicator: StyledRadioIndicator,
  Description: InputBase.Description,
  ErrorState: InputBase.ErrorState,
  SuccessState: InputBase.SuccessState
};
const RadioGroupContext = createContext$1({
  radioGroupError: "",
  radioGroupErrorId: "",
  radioGroupSuccess: "",
  radioGroupSuccessId: "",
  radioGroupDisabled: false
});
const useRadioGroupContext = () => useContext(RadioGroupContext);
const RadioItem = forwardRef((_ref42, forwardedRef) => {
  let {
    value,
    label,
    description,
    disabled: disabled2
  } = _ref42;
  var _a, _b;
  const {
    radioGroupError,
    radioGroupErrorId,
    radioGroupSuccess,
    radioGroupSuccessId,
    radioGroupDisabled
  } = useRadioGroupContext();
  const radioElementId = `dds-radio-element-${value}`;
  const radioLabelElementId = `dds-radio-label-${value}`;
  const descriptionElementId = `dds-radio-description-${value}`;
  const describedById = (_b = (_a = radioGroupError && radioGroupErrorId) != null ? _a : radioGroupSuccess && radioGroupSuccessId) != null ? _b : description && descriptionElementId;
  return /* @__PURE__ */jsxs(Flex, {
    children: [/* @__PURE__ */jsx(RadioGroupBase.RadioItem, {
      ref: forwardedRef,
      id: radioElementId,
      value,
      label: "Default",
      labelElementId: radioLabelElementId,
      descriptionElementId: describedById,
      error: radioGroupError,
      disabled: disabled2 != null ? disabled2 : radioGroupDisabled,
      children: /* @__PURE__ */jsx(RadioGroupBase.RadioIndicator, {})
    }), /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: 0,
      css: {
        gap: "2px"
      },
      children: [/* @__PURE__ */jsx(RadioGroupBase.Label, {
        id: radioLabelElementId,
        htmlFor: radioElementId,
        label
      }), description && /* @__PURE__ */jsx(RadioGroupBase.Description, {
        id: descriptionElementId,
        children: description
      })]
    })]
  });
});
RadioItem.displayName = "RadioItem";
const RadioGroup = forwardRef((_ref43, forwardedRef) => {
  let {
    label,
    value,
    onValueChange,
    disabled: disabled2 = false,
    labelOptional,
    children,
    error = "",
    success = "",
    ...props
  } = _ref43;
  const name = toHyphenCase(label);
  const radioGroupId = `dds-radio-group-${name}`;
  const radioGroupLabelId = `dds-radio-group-label-${name}`;
  const radioGroupErrorId = `dds-radio-group-error-${name}`;
  const radioGroupSuccessId = `dds-radio-group-success-${name}`;
  return /* @__PURE__ */jsx(RadioGroupBase.Root, {
    ref: forwardedRef,
    id: radioGroupId,
    name,
    value,
    onValueChange,
    role: "radiogroup",
    "aria-labelledby": radioGroupLabelId,
    ...props,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: 1,
      children: [/* @__PURE__ */jsxs(Flex, {
        direction: "column",
        gap: "half",
        children: [/* @__PURE__ */jsx(RadioGroupBase.Label, {
          id: radioGroupLabelId,
          label,
          htmlFor: radioGroupLabelId,
          optional: labelOptional
        }), /* @__PURE__ */jsx(RadioGroupBase.ErrorState, {
          id: radioGroupErrorId,
          errorMessage: error
        }), /* @__PURE__ */jsx(RadioGroupBase.SuccessState, {
          successMessage: error ? "" : success
        })]
      }), /* @__PURE__ */jsx(RadioGroupContext.Provider, {
        value: {
          radioGroupError: error,
          radioGroupErrorId,
          radioGroupSuccess: success,
          radioGroupSuccessId,
          radioGroupDisabled: disabled2
        },
        children
      })]
    })
  });
});
RadioGroup.displayName = "RadioGroup";
const BaseLinkStyles = {
  width: "max-content",
  margin: 0,
  cursor: "pointer",
  paddingLeft: 0,
  paddingRight: 0,
  minWidth: "auto",
  whiteSpace: "nowrap",
  color: "inherit",
  textDecoration: "none",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  }
};
var LinkTypeVariantEnum = /* @__PURE__ */(LinkTypeVariantEnum2 => {
  LinkTypeVariantEnum2["SUBTLE"] = "subtle";
  LinkTypeVariantEnum2["INLINE"] = "inline";
  LinkTypeVariantEnum2["OBJECT"] = "object";
  return LinkTypeVariantEnum2;
})(LinkTypeVariantEnum || {});
var LinkSizeVariantEnum = /* @__PURE__ */(LinkSizeVariantEnum2 => {
  LinkSizeVariantEnum2["SMALL"] = "small";
  LinkSizeVariantEnum2["MEDIUM"] = "medium";
  LinkSizeVariantEnum2["LARGE"] = "large";
  return LinkSizeVariantEnum2;
})(LinkSizeVariantEnum || {});
const LinkSizeVariant = {
  small: {
    textStyles: "metadata"
  },
  medium: {
    textStyles: "body"
  },
  large: {
    textStyles: "h3"
  }
};
const LinkTypeVariant = {
  subtle: {
    color: "$gray9",
    "&:hover": {
      textDecoration: "underline",
      textDecorationColor: "$gray9"
    },
    "&:active": {
      color: "$gray10",
      textDecoration: "underline",
      textDecorationColor: "$gray10"
    }
  },
  inline: {
    color: "$blue8",
    fontWeight: "$semibold",
    "&:hover": {
      color: "$blue9",
      textDecoration: "underline",
      textDecorationColor: "$blue9"
    },
    "&:active": {
      color: "$blue10",
      textDecoration: "underline",
      textDecorationColor: "$blue10"
    }
  },
  object: {
    color: "$gray12",
    fontWeight: "$semibold",
    "&:hover": {
      color: "$gray12",
      textDecoration: "underline",
      textDecorationColor: "$gray12"
    },
    "&:active": {
      color: "$gray12",
      textDecoration: "underline",
      textDecorationColor: "$gray12"
    }
  }
};
const StyledLinkBase = styled("a", {
  ...BaseLinkStyles,
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  },
  variants: {
    size: LinkSizeVariant,
    type: LinkTypeVariant,
    ...TextTransformVariants
  },
  defaultVariants: {
    size: LinkSizeVariantEnum.MEDIUM,
    type: LinkTypeVariantEnum.SUBTLE
  }
});
const Link = forwardRef((_ref44, forwardedRef) => {
  let {
    size = "medium",
    variant = "subtle",
    css: css2,
    children,
    href,
    target,
    rel,
    external,
    ...props
  } = _ref44;
  return /* @__PURE__ */jsx(StyledLinkBase, {
    ref: forwardedRef,
    size,
    type: variant,
    css: css2,
    href,
    target: external ? "_blank" : target,
    role: "link",
    rel: external ? "noopener noreferrer" : rel,
    ...props,
    children
  });
});
Link.displayName = "Link";
const $6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
const [$6be4966fd9bbc698$var$createSwitchContext, $6be4966fd9bbc698$export$cf7f5f17f69cbd43] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6be4966fd9bbc698$var$SWITCH_NAME);
const [$6be4966fd9bbc698$var$SwitchProvider, $6be4966fd9bbc698$var$useSwitchContext] = $6be4966fd9bbc698$var$createSwitchContext($6be4966fd9bbc698$var$SWITCH_NAME);
const $6be4966fd9bbc698$export$b5d5cf8927ab7262 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSwitch,
    "aria-labelledby": ariaLabelledby,
    name,
    checked: checkedProp,
    defaultChecked,
    required,
    disabled: disabled2,
    value = "on",
    onCheckedChange,
    ...switchProps
  } = props;
  const [button, setButton] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node => setButton(node));
  const labelId = $b73a6c6685e72184$export$feddbbf47baabdb9(button);
  const labelledBy = ariaLabelledby || labelId;
  const hasConsumerStoppedPropagationRef = useRef(false);
  const isFormControl = button ? Boolean(button.closest("form")) : true;
  const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: checkedProp,
    defaultProp: defaultChecked,
    onChange: onCheckedChange
  });
  return /* @__PURE__ */createElement$1($6be4966fd9bbc698$var$SwitchProvider, {
    scope: __scopeSwitch,
    checked,
    disabled: disabled2
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
    type: "button",
    role: "switch",
    "aria-checked": checked,
    "aria-labelledby": labelledBy,
    "aria-required": required,
    "data-state": $6be4966fd9bbc698$var$getState(checked),
    "data-disabled": disabled2 ? "" : void 0,
    disabled: disabled2,
    value
  }, switchProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, event => {
      setChecked(prevChecked => !prevChecked);
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /* @__PURE__ */createElement$1($6be4966fd9bbc698$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name,
    value,
    checked,
    required,
    disabled: disabled2,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const $6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
const $6be4966fd9bbc698$export$4d07bf653ea69106 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSwitch,
    ...thumbProps
  } = props;
  const context = $6be4966fd9bbc698$var$useSwitchContext($6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({
    "data-state": $6be4966fd9bbc698$var$getState(context.checked),
    "data-disabled": context.disabled ? "" : void 0
  }, thumbProps, {
    ref: forwardedRef
  }));
});
const $6be4966fd9bbc698$var$BubbleInput = props => {
  const {
    control,
    checked,
    bubbles = true,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
  const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control);
  useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */createElement$1("input", _extends({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps, {
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      ...controlSize,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $6be4966fd9bbc698$var$getState(checked) {
  return checked ? "checked" : "unchecked";
}
const $6be4966fd9bbc698$export$be92b6f5f03c0fe9 = $6be4966fd9bbc698$export$b5d5cf8927ab7262;
const $6be4966fd9bbc698$export$6521433ed15a34db = $6be4966fd9bbc698$export$4d07bf653ea69106;
var SwitchSizeVariantEnum = /* @__PURE__ */(SwitchSizeVariantEnum2 => {
  SwitchSizeVariantEnum2["SMALL"] = "small";
  SwitchSizeVariantEnum2["DEFAULT"] = "default";
  return SwitchSizeVariantEnum2;
})(SwitchSizeVariantEnum || {});
const SwitchContainerSizeVariant = {
  small: {
    width: "$4",
    height: "20px"
  },
  default: {
    width: "44px",
    height: "$3"
  }
};
const SwitchThumbSizeVariant = {
  small: {
    width: "$2",
    height: "$2",
    '&[data-state="checked"]': {
      transform: "translateX(14px)"
    }
  },
  default: {
    width: "20px",
    height: "20px",
    '&[data-state="checked"]': {
      transform: "translateX(22px)"
    }
  }
};
const StyledToggle = styled($6be4966fd9bbc698$export$be92b6f5f03c0fe9, {
  all: "unset",
  backgroundColor: "$gray3",
  borderRadius: "9999px",
  position: "relative",
  cursor: "pointer",
  "&:focus-visible": {
    outline: "solid 1px $blue6"
  },
  "&:disabled": {
    cursor: "not-allowed"
  },
  [`&:not([data-state="checked"]):not(:disabled):hover`]: {
    backgroundColor: "$gray4"
  },
  [`&:not([data-state="checked"]):disabled`]: {
    backgroundColor: "$gray2"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$blue8"
  },
  '&[data-state="checked"]:not(:disabled):hover': {
    backgroundColor: "$blue9"
  },
  '&[data-state="checked"]:disabled': {
    backgroundColor: "$blue3"
  },
  variants: {
    size: SwitchContainerSizeVariant
  },
  defaultVariants: {
    size: SwitchSizeVariantEnum.DEFAULT
  }
});
const StyledThumb = styled($6be4966fd9bbc698$export$6521433ed15a34db, {
  display: "block",
  backgroundColor: "white",
  borderRadius: "9999px",
  transition: "transform 100ms",
  transform: "translateX(2px)",
  willChange: "transform",
  variants: {
    size: SwitchThumbSizeVariant
  },
  defaultVariants: {
    size: SwitchSizeVariantEnum.DEFAULT
  }
});
const Toggle = forwardRef((_ref45, forwardedRef) => {
  let {
    size,
    onChange: onChange2,
    name,
    rootProps,
    ...props
  } = _ref45;
  return /* @__PURE__ */jsx(StyledToggle, {
    ref: forwardedRef,
    size,
    onCheckedChange: onChange2,
    "aria-label": name,
    name,
    ...props,
    ...rootProps,
    children: /* @__PURE__ */jsx(StyledThumb, {
      size
    })
  });
});
Toggle.displayName = "Toggle";
var faClone$1 = {};
Object.defineProperty(faClone$1, "__esModule", {
  value: true
});
var faClone_2 = faClone$1.faClone = void 0;
const faClone = {
  prefix: "fal",
  iconName: "faClone",
  icon: [512, 512, [], "", "M336 384c-8.836 0-16 7.162-16 16V448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V224c0-17.67 14.33-32 32-32h48C120.8 192 128 184.8 128 176C128 167.2 120.8 160 112 160H64C28.65 160 0 188.7 0 224v224c0 35.35 28.65 64 64 64h224c35.35 0 64-28.65 64-64v-48C352 391.2 344.8 384 336 384zM448 0H224C188.7 0 160 28.65 160 64v224c0 35.35 28.65 64 64 64h224c35.35 0 64-28.65 64-64V64C512 28.65 483.3 0 448 0zM480 288c0 17.64-14.36 32-32 32H224c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h224c17.64 0 32 14.36 32 32V288z"]
};
faClone_2 = faClone$1.faClone = faClone;
const TextareaContainer = styled(Box, {
  width: "inherit",
  position: "relative"
});
const CopyTextButton = styled(IconButton, {
  position: "absolute",
  right: "$half",
  top: "$half"
});
const StyledTextarea = styled(TextareaAutosize, {
  border: "1px solid $blue3",
  borderRadius: "$1",
  padding: "6px $4 6px $1",
  minHeight: "100px",
  resize: "none",
  width: "100%",
  fontFamily: "$primary",
  boxSizing: "border-box",
  textStyles: "body",
  color: "$body",
  "&::placeholder": {
    color: "$gray8"
  },
  "&:hover": {
    borderColor: "$blue4"
  },
  "&:disabled": {
    backgroundColor: "$gray2",
    borderColor: "$gray3",
    cursor: "not-allowed",
    "&:hover": {
      borderColor: "$gray3"
    }
  },
  "&:active": {
    borderColor: "$blue5"
  },
  "&:focus": {
    borderColor: "$blue6"
  },
  "&:focus-visible": {
    borderColor: "$blue6",
    outline: "none"
  }
});
const Textarea = forwardRef((_ref46, forwardedRef) => {
  let {
    errorMessage = "",
    successMessage = "",
    label,
    description,
    disabled: disabled2,
    optional,
    value,
    rootProps,
    allowCopy,
    size = "medium",
    ...props
  } = _ref46;
  var _a;
  const name = toHyphenCase(label);
  const [inputElementId] = useState(() => `dds-textarea-element-${name}`);
  const [descriptionElementId] = useState(() => `dds-textarea-description-${name}`);
  const [errorMessageElementId] = useState(() => `dds-textarea-error-message-${name}`);
  const textareaRef = useRef(null);
  const composedRefs = useComposedRefs$1(forwardedRef, textareaRef);
  const describedByElementId = (_a = errorMessage && errorMessageElementId) != null ? _a : description && descriptionElementId;
  const onCopyIconClick = () => {
    if (!window || !value) {
      return;
    }
    window.navigator.clipboard.writeText(value.toString());
  };
  return /* @__PURE__ */jsx(InputBase.Root, {
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      fullWidth: true,
      children: [/* @__PURE__ */jsx(InputBase.Label, {
        htmlFor: inputElementId,
        label,
        showOptionalLabel: optional
      }), /* @__PURE__ */jsxs(TextareaContainer, {
        children: [/* @__PURE__ */jsx(StyledTextarea, {
          ref: composedRefs,
          disabled: disabled2,
          id: inputElementId,
          "aria-invalid": !!(errorMessage == null ? void 0 : errorMessage.length),
          "aria-errormessage": errorMessageElementId,
          "aria-describedby": describedByElementId,
          maxRows: 10,
          value,
          ...props,
          ...rootProps
        }), allowCopy && /* @__PURE__ */jsx(CopyTextButton, {
          title: "copy text to clipboard",
          icon: faClone_2,
          iconVariant: "dark",
          size: "small",
          disabled: disabled2,
          onClick: onCopyIconClick
        })]
      }), /* @__PURE__ */jsx(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx(InputBase.SuccessState, {
        successMessage: errorMessage ? "" : successMessage
      })]
    })
  });
});
Textarea.displayName = "Textarea";
const PaperElevationVariant = {
  1: {
    boxShadow: "$none"
  },
  2: {
    boxShadow: "$1"
  },
  3: {
    boxShadow: "$2"
  },
  4: {
    boxShadow: "$3"
  }
};
const StyledPaperBase = styled("div", {
  background: "$white",
  variants: {
    elevation: PaperElevationVariant
  },
  default: {
    elevation: 2
  }
});
const Paper = forwardRef((_ref47, forwardedRef) => {
  let {
    elevation,
    children,
    css: css2,
    rootProps,
    ...props
  } = _ref47;
  return /* @__PURE__ */jsx(StyledPaperBase, {
    ref: forwardedRef,
    elevation,
    css: css2,
    ...props,
    ...rootProps,
    children
  });
});
Paper.displayName = "Paper";
const CardStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "$2",
  borderRadius: "$1",
  paddingX: "$3",
  paddingY: "$3"
};
const CardHeaderStyles = {};
const CardContentStyles = {};
const StyledBase$1 = styled(StyledPaperBase, {
  ...CardStyles,
  defaultVariants: {
    elevation: 2
  }
});
const CardComponent = forwardRef((_ref48, forwardedRef) => {
  let {
    children,
    css: css2,
    rootProps,
    ...props
  } = _ref48;
  return /* @__PURE__ */jsx(StyledBase$1, {
    ref: forwardedRef,
    css: css2,
    ...props,
    ...rootProps,
    children
  });
});
CardComponent.displayName = "Card";
const CardHeader = styled("div", CardHeaderStyles);
const CardContent = styled("div", CardContentStyles);
const Card = {
  ...CardComponent,
  Header: CardHeader,
  Content: CardContent
};
const SimpleGridGapVariant = {
  half: {
    gap: "$half"
  },
  0: {
    gap: "$0"
  },
  1: {
    gap: "$1"
  },
  2: {
    gap: "$2"
  },
  3: {
    gap: "$3"
  },
  4: {
    gap: "$4"
  },
  5: {
    gap: "$5"
  },
  6: {
    gap: "$6"
  },
  7: {
    gap: "$7"
  },
  8: {
    gap: "$8"
  }
};
const SimpleGridColumnsVariant = {
  1: {
    gridTemplateColumns: "repeat(1, 1fr)"
  },
  2: {
    gridTemplateColumns: "repeat(2, 1fr)"
  },
  3: {
    gridTemplateColumns: "repeat(3, 1fr)"
  },
  4: {
    gridTemplateColumns: "repeat(4, 1fr)"
  },
  5: {
    gridTemplateColumns: "repeat(5, 1fr)"
  },
  6: {
    gridTemplateColumns: "repeat(6, 1fr)"
  },
  7: {
    gridTemplateColumns: "repeat(7, 1fr)"
  },
  8: {
    gridTemplateColumns: "repeat(8, 1fr)"
  }
};
var SimpleGridAlignItemsVariantEnum = /* @__PURE__ */(SimpleGridAlignItemsVariantEnum2 => {
  SimpleGridAlignItemsVariantEnum2["START"] = "start";
  SimpleGridAlignItemsVariantEnum2["CENTER"] = "center";
  SimpleGridAlignItemsVariantEnum2["END"] = "end";
  SimpleGridAlignItemsVariantEnum2["STRETCH"] = "stretch";
  SimpleGridAlignItemsVariantEnum2["BASELINE"] = "baseline";
  return SimpleGridAlignItemsVariantEnum2;
})(SimpleGridAlignItemsVariantEnum || {});
const SimpleGridAlignItemsVariant = {
  start: {
    alignItems: "start"
  },
  center: {
    alignItems: "center"
  },
  end: {
    alignItems: "end"
  },
  stretch: {
    alignItems: "stretch"
  },
  baseline: {
    alignItems: "baseline"
  }
};
var SimpleGridJustifyItemsVariantEnum = /* @__PURE__ */(SimpleGridJustifyItemsVariantEnum2 => {
  SimpleGridJustifyItemsVariantEnum2["START"] = "start";
  SimpleGridJustifyItemsVariantEnum2["CENTER"] = "center";
  SimpleGridJustifyItemsVariantEnum2["END"] = "end";
  SimpleGridJustifyItemsVariantEnum2["STRETCH"] = "stretch";
  return SimpleGridJustifyItemsVariantEnum2;
})(SimpleGridJustifyItemsVariantEnum || {});
const SimpleGridJustifyItemsVariant = {
  start: {
    justifyItems: "start"
  },
  center: {
    justifyItems: "center"
  },
  end: {
    justifyItems: "end"
  },
  stretch: {
    justifyItems: "stretch"
  }
};
const StyledBase = styled("div", {
  display: "grid",
  variants: {
    gap: SimpleGridGapVariant,
    columns: SimpleGridColumnsVariant,
    justifyItems: SimpleGridJustifyItemsVariant,
    alignItems: SimpleGridAlignItemsVariant,
    fullWidth: FullWidthVariant,
    fullHeight: FullHeightVariant
  }
});
const SimpleGrid = forwardRef((_ref49, forwardedRef) => {
  let {
    columns,
    gap,
    css: css2,
    as,
    children,
    alignItems,
    justifyItems,
    ...props
  } = _ref49;
  return /* @__PURE__ */jsx(StyledBase, {
    ref: forwardedRef,
    gap,
    columns,
    justifyItems,
    alignItems,
    as,
    css: css2,
    ...props,
    children
  });
});
SimpleGrid.displayName = "SimpleGrid";
var faInfo$1 = {};
Object.defineProperty(faInfo$1, "__esModule", {
  value: true
});
var faInfo_2 = faInfo$1.faInfo = void 0;
const faInfo = {
  prefix: "fal",
  iconName: "faInfo",
  icon: [192, 512, [], "", "M96 96c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99S64 46.33 64 64S78.33 96 96 96zM176 448h-64V176C112 167.2 104.8 160 96 160H48C39.16 160 32 167.2 32 176S39.16 192 48 192h32v256h-64C7.156 448 0 455.2 0 464S7.156 480 16 480h160c8.844 0 16-7.156 16-16S184.8 448 176 448z"]
};
faInfo_2 = faInfo$1.faInfo = faInfo;
var faMinus$1 = {};
Object.defineProperty(faMinus$1, "__esModule", {
  value: true
});
var faMinus_2 = faMinus$1.faMinus = void 0;
const faMinus = {
  prefix: "fal",
  iconName: "faMinus",
  icon: [448, 512, [], "", "M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z"]
};
faMinus_2 = faMinus$1.faMinus = faMinus;
var faTriangleExclamation$1 = {};
Object.defineProperty(faTriangleExclamation$1, "__esModule", {
  value: true
});
var faTriangleExclamation_2 = faTriangleExclamation$1.faTriangleExclamation = void 0;
const faTriangleExclamation = {
  prefix: "fal",
  iconName: "faTriangleExclamation",
  icon: [512, 512, [], "", "M256 360c-13.25 0-23.1 10.74-23.1 24c0 13.25 10.75 24 23.1 24c13.25 0 23.1-10.75 23.1-24C280 370.7 269.3 360 256 360zM256 320c8.843 0 15.1-7.156 15.1-16V160c0-8.844-7.155-16-15.1-16S240 151.2 240 160v144C240 312.8 247.2 320 256 320zM504.3 397.3L304.5 59.38C294.4 42.27 276.2 32.03 256 32C235.8 32 217.7 42.22 207.5 59.36l-199.9 338c-10.05 16.97-10.2 37.34-.4218 54.5C17.29 469.5 35.55 480 56.1 480h399.9c20.51 0 38.75-10.53 48.81-28.17C514.6 434.7 514.4 414.3 504.3 397.3zM476.1 435.1C472.7 443.5 464.8 448 455.1 448H56.1c-8.906 0-16.78-4.484-21.08-12c-4.078-7.156-4.015-15.3 .1562-22.36L235.1 75.66C239.4 68.36 247.2 64 256 64c0 0-.0156 0 0 0c8.765 .0156 16.56 4.359 20.86 11.64l199.9 338C480.1 420.7 481.1 428.8 476.1 435.1z"]
};
faTriangleExclamation_2 = faTriangleExclamation$1.faTriangleExclamation = faTriangleExclamation;
var faXmark$1 = {};
Object.defineProperty(faXmark$1, "__esModule", {
  value: true
});
var faXmark_2 = faXmark$1.faXmark = void 0;
const faXmark = {
  prefix: "fal",
  iconName: "faXmark",
  icon: [320, 512, [], "", "M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"]
};
faXmark_2 = faXmark$1.faXmark = faXmark;
const StatusIconContainerTypeVariant = {
  info: {
    backgroundColor: "$blue6"
  },
  success: {
    backgroundColor: "$green6"
  },
  error: {
    backgroundColor: "$red6"
  },
  warning: {
    paddingTop: "2px",
    paddingBottom: "$half",
    backgroundColor: "$yellow4"
  },
  archived: {
    backgroundColor: "$gray6"
  }
};
const StyledStatusIcon = styled(Flex, {
  size: "$2",
  minWidth: "$2",
  minHeight: "$2",
  borderRadius: "$round",
  variants: {
    variant: StatusIconContainerTypeVariant
  }
});
const StatusIconFillColorMap = {
  info: "light",
  success: "light",
  error: "light",
  warning: "dark",
  archived: "light"
};
const StatusIconMap = {
  info: faInfo_2,
  success: faCheck_2,
  error: faXmark_2,
  warning: faTriangleExclamation_2,
  archived: faMinus_2
};
const StatusIcon = forwardRef((_ref50, forwardedRef) => {
  let {
    variant = "info",
    ...props
  } = _ref50;
  return /* @__PURE__ */jsx(StyledStatusIcon, {
    variant,
    justifyContent: "center",
    alignItems: "center",
    ref: forwardedRef,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */jsx(Icon, {
      size: "extra-small",
      variant: StatusIconFillColorMap[variant],
      icon: StatusIconMap[variant]
    })
  });
});
StatusIcon.displayName = "StatusIcon";
var faExclamation$1 = {};
Object.defineProperty(faExclamation$1, "__esModule", {
  value: true
});
var faExclamation_2 = faExclamation$1.faExclamation = void 0;
const faExclamation = {
  prefix: "fas",
  iconName: "faExclamation",
  icon: [128, 512, [], "", "M64 352c17.69 0 32-14.32 32-31.1V64.01c0-17.67-14.31-32.01-32-32.01S32 46.34 32 64.01v255.1C32 337.7 46.31 352 64 352zM64 400c-22.09 0-40 17.91-40 40s17.91 39.1 40 39.1s40-17.9 40-39.1S86.09 400 64 400z"]
};
faExclamation_2 = faExclamation$1.faExclamation = faExclamation;
var StatusIndicatorColorVariantEnum = /* @__PURE__ */(StatusIndicatorColorVariantEnum2 => {
  StatusIndicatorColorVariantEnum2["INFO"] = "info";
  StatusIndicatorColorVariantEnum2["SUCCESS"] = "success";
  StatusIndicatorColorVariantEnum2["ERROR"] = "error";
  StatusIndicatorColorVariantEnum2["WARNING"] = "warning";
  StatusIndicatorColorVariantEnum2["ARCHIVED"] = "archive";
  StatusIndicatorColorVariantEnum2["AWAY"] = "away";
  StatusIndicatorColorVariantEnum2["CHAT_LIMIT"] = "chat-limit";
  return StatusIndicatorColorVariantEnum2;
})(StatusIndicatorColorVariantEnum || {});
const StatusIndicatorColorVariant = {
  info: {
    backgroundColor: "$blue6"
  },
  success: {
    backgroundColor: "$green6"
  },
  error: {
    backgroundColor: "$red6"
  },
  warning: {
    backgroundColor: "$yellow4"
  },
  archive: {
    backgroundColor: "$gray6"
  },
  away: {
    backgroundColor: "$white"
  },
  "chat-limit": {
    position: "relative",
    backgroundColor: "$yellow5"
  }
};
var StatusIndicatorSizeVariantEnum = /* @__PURE__ */(StatusIndicatorSizeVariantEnum2 => {
  StatusIndicatorSizeVariantEnum2["X_SMALL"] = "x-small";
  StatusIndicatorSizeVariantEnum2["SMALL"] = "small";
  StatusIndicatorSizeVariantEnum2["MEDIUM"] = "medium";
  StatusIndicatorSizeVariantEnum2["LARGE"] = "large";
  StatusIndicatorSizeVariantEnum2["X_LARGE"] = "x-large";
  return StatusIndicatorSizeVariantEnum2;
})(StatusIndicatorSizeVariantEnum || {});
const StatusIndicatorSizeVariant = {
  "x-small": {
    size: "$1"
  },
  small: {
    size: "10px"
  },
  medium: {
    size: "12px"
  },
  large: {
    size: "20px"
  },
  "x-large": {
    size: "30px"
  }
};
const ChatLimitBorderCompoundVariant = [{
  size: "x-small",
  variant: "away",
  css: {
    border: "1.5px solid $colors$gray10"
  }
}, {
  size: "small",
  variant: "away",
  css: {
    border: "2px solid $colors$gray10"
  }
}, {
  size: "medium",
  variant: "away",
  css: {
    border: "3px solid $colors$gray10"
  }
}, {
  size: "large",
  variant: "away",
  css: {
    border: "5px solid $colors$gray10"
  }
}, {
  size: "x-large",
  variant: "away",
  css: {
    border: "7px solid $colors$gray10"
  }
}];
const StyledIndicator = styled("span", {
  width: "$1",
  height: "$1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$round",
  variants: {
    variant: StatusIndicatorColorVariant,
    size: StatusIndicatorSizeVariant
  },
  defaultVariants: {
    variant: StatusIndicatorColorVariantEnum.INFO,
    size: StatusIndicatorSizeVariantEnum.MEDIUM
  },
  compoundVariants: [...ChatLimitBorderCompoundVariant]
});
const IndicatorIconStyles = {
  height: "70%",
  width: "100%",
  display: "block"
};
const StatusIndicatorVariantIcons = {
  "chat-limit": faExclamation_2
};
const StatusIndicator = _ref51 => {
  let {
    size,
    variant = "info",
    rootProps,
    ...props
  } = _ref51;
  const indicatorIcon = StatusIndicatorVariantIcons[variant];
  return /* @__PURE__ */jsx(StyledIndicator, {
    variant,
    size,
    "aria-hidden": true,
    ...rootProps,
    ...props,
    children: indicatorIcon && /* @__PURE__ */jsx(Icon, {
      icon: indicatorIcon,
      variant: "light",
      css: {
        ...IndicatorIconStyles
      }
    })
  });
};
function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp) {
  const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === "Escape") onEscapeKeyDown(event);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onEscapeKeyDown]);
}
const $5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /* @__PURE__ */createContext$1({
  layers: /* @__PURE__ */new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
  branches: /* @__PURE__ */new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    disableOutsidePointerEvents = false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss,
    ...layerProps
  } = props;
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext);
  const [node1, setNode] = useState(null);
  const [, force] = useState({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node => setNode(node));
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index2 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside(event => {
    const target = event.target;
    const isPointerDownOnBranch = [...context.branches].some(branch => branch.contains(target));
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  });
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside(event => {
    const target = event.target;
    const isFocusInBranch = [...context.branches].some(branch => branch.contains(target));
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  });
  $addc16e1bbe58fd0$export$3a72a57244d6e765(event => {
    const isHighestLayer = index2 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  });
  useEffect(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents = document.body.style.pointerEvents;
        document.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) document.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
    };
  }, [node1, disableOutsidePointerEvents, context]);
  useEffect(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate();
    };
  }, [node1, context]);
  useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
  }, []);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
const $5cb92bef7577960e$export$4d5eb2109db14228 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    const node = ref.current;
    if (node) {
      context.branches.add(node);
      return () => {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, props, {
    ref: composedRefs
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
  const isPointerInsideReactTreeRef = useRef(false);
  const handleClickRef = useRef(() => {});
  useEffect(() => {
    const handlePointerDown = event => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent = function () {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          document.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
          document.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      document.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("click", handleClickRef.current);
    };
  }, [handlePointerDownOutside]);
  return {
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
  const isFocusInsideReactTreeRef = useRef(false);
  useEffect(() => {
    const handleFocus = event => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    document.addEventListener("focusin", handleFocus);
    return () => document.removeEventListener("focusin", handleFocus);
  }, [handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, _ref52) {
  let {
    discrete
  } = _ref52;
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);else target.dispatchEvent(event);
}
const $5cb92bef7577960e$export$be92b6f5f03c0fe9 = $5cb92bef7577960e$export$177fb62ff3ec1f22;
const $5cb92bef7577960e$export$aecb2ddcb55c95be = $5cb92bef7577960e$export$4d5eb2109db14228;
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container1, setContainer] = useState(null);
  const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
  const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
  const lastFocusedElementRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node => setContainer(node));
  const focusScope = useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  useEffect(() => {
    if (trapped) {
      let handleFocusIn = function (event) {
          if (focusScope.paused || !container1) return;
          const target = event.target;
          if (container1.contains(target)) lastFocusedElementRef.current = target;else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
            select: true
          });
        },
        handleFocusOut = function (event) {
          if (focusScope.paused || !container1) return;
          if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
            select: true
          });
        };
      document.addEventListener("focusin", handleFocusIn);
      document.addEventListener("focusout", handleFocusOut);
      return () => {
        document.removeEventListener("focusin", handleFocusIn);
        document.removeEventListener("focusout", handleFocusOut);
      };
    }
  }, [trapped, container1, focusScope.paused]);
  useEffect(() => {
    if (container1) {
      $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
        container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container1.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
        }
      }
      return () => {
        container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
          container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container1.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
            select: true
          });
          container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container1, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = useCallback(event => {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container = event.currentTarget;
      const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
      const hasTabbableElementsInside = first && last;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(last, {
            select: true
          });
        }
      }
    }
  }, [loop, trapped, focusScope.paused]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
    tabIndex: -1
  }, scopeProps, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
function $d3863c46a17e8a28$var$focusFirst(candidates) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    $d3863c46a17e8a28$var$focus(candidate, {
      select
    });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function $d3863c46a17e8a28$var$getTabbableEdges(container) {
  const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
  const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
  const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
  return [first, last];
}
function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: node => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $d3863c46a17e8a28$var$findVisible(elements, container) {
  for (const element of elements) {
    if (!$d3863c46a17e8a28$var$isHidden(element, {
      upTo: container
    })) return element;
  }
}
function $d3863c46a17e8a28$var$isHidden(node, _ref53) {
  let {
    upTo
  } = _ref53;
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function $d3863c46a17e8a28$var$focus(element) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
  }
}
const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _stack$;
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) updatedArray.splice(index2, 1);
  return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
  return items.filter(item => item.tagName !== "A");
}
const $f1701beae083dbae$export$602eac185826482c = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _globalThis$document;
  const {
    container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body,
    ...portalProps
  } = props;
  return container ? /* @__PURE__ */$7SXl2$reactdom__default.createPortal( /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});
let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
  useEffect(() => {
    var _edgeGuards$, _edgeGuards$2;
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
    document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
    $3db38b7d1fb3fe6a$var$count++;
    return () => {
      if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach(node => node.remove());
      $3db38b7d1fb3fe6a$var$count--;
    };
  }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
  return element;
}
var __assign = function () {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s2, e2) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0) t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function") for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
    if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2])) t2[p2[i2]] = s2[p2[i2]];
  }
  return t2;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
    if (ar || !(i2 in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i2);
      ar[i2] = from[i2];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef(initialValue, callback) {
  var ref = useState(function () {
    return {
      value: initialValue,
      callback,
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
function useMergeRefs(refs, defaultValue) {
  return useCallbackRef(defaultValue || null, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef(ref, newValue);
    });
  });
}
function ItoI(a2) {
  return a2;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function () {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function (data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function () {
        buffer = buffer.filter(function (x2) {
          return x2 !== item;
        });
      };
    },
    assignSyncMedium: function (cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function (x2) {
          return cb(x2);
        },
        filter: function () {
          return buffer;
        }
      };
    },
    assignMedium: function (cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function () {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function () {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function (x2) {
          pendingQueue.push(x2);
          cycle();
        },
        filter: function (filter2) {
          pendingQueue = pendingQueue.filter(filter2);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({
    async: true,
    ssr: false
  }, options);
  return medium;
}
var SideCar$1 = function (_a) {
  var sideCar = _a.sideCar,
    rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React.createElement(Target, __assign({}, rest));
};
SideCar$1.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$1;
}
var effectCar = createSidecarMedium();
var nothing = function () {
  return;
};
var RemoveScroll = React.forwardRef(function (props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
      onScrollCapture: nothing,
      onWheelCapture: nothing,
      onTouchMoveCapture: nothing
    }),
    callbacks = _a[0],
    setCallbacks = _a[1];
  var forwardProps = props.forwardProps,
    children = props.children,
    className = props.className,
    removeScrollBar = props.removeScrollBar,
    enabled = props.enabled,
    shards = props.shards,
    sideCar = props.sideCar,
    noIsolation = props.noIsolation,
    inert = props.inert,
    allowPinchZoom = props.allowPinchZoom,
    _b = props.as,
    Container = _b === void 0 ? "div" : _b,
    rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React.createElement(React.Fragment, null, enabled && React.createElement(SideCar2, {
    sideCar: effectCar,
    removeScrollBar,
    shards,
    noIsolation,
    inert,
    setCallbacks,
    allowPinchZoom: !!allowPinchZoom,
    lockRef: ref
  }), forwardProps ? React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), {
    ref: containerRef
  })) : React.createElement(Container, __assign({}, containerProps, {
    className,
    ref: containerRef
  }), children));
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function () {
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document) return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css2) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css2;
  } else {
    tag.appendChild(document.createTextNode(css2));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function () {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function (style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function () {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function () {
  var sheet = stylesheetSingleton();
  return function (styles2, isDynamic) {
    React.useEffect(function () {
      sheet.add(styles2);
      return function () {
        sheet.remove();
      };
    }, [styles2 && isDynamic]);
  };
};
var styleSingleton = function () {
  var useStyle = styleHookSingleton();
  var Sheet = function (_a) {
    var styles2 = _a.styles,
      dynamic = _a.dynamic;
    useStyle(styles2, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function (x2) {
  return parseInt(x2 || "", 10) || 0;
};
var getOffset = function (gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style = styleSingleton();
var getStyles = function (_a, allowRelative, gapMode, important) {
  var left = _a.left,
    top = _a.top,
    right = _a.right,
    gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([allowRelative && "position: relative ".concat(important, ";"), gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "), gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var RemoveScrollBar = function (props) {
  var noRelative = props.noRelative,
    noImportant = props.noImportant,
    _a = props.gapMode,
    gapMode = _a === void 0 ? "margin" : _a;
  var gap = React.useMemo(function () {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React.createElement(Style, {
    styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
  });
};
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function () {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? {
  passive: false
} : false;
var elementCouldBeVScrolled = function (node) {
  var styles2 = window.getComputedStyle(node);
  return styles2.overflowY !== "hidden" && !(styles2.overflowY === styles2.overflowX && styles2.overflowY === "visible");
};
var elementCouldBeHScrolled = function (node) {
  var styles2 = window.getComputedStyle(node);
  return styles2.overflowX !== "hidden" && !(styles2.overflowY === styles2.overflowX && styles2.overflowX === "visible");
};
var locationCouldBeScrolled = function (axis, node) {
  var current = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current),
        s2 = _a[1],
        d2 = _a[2];
      if (s2 > d2) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables = function (_a) {
  var scrollTop = _a.scrollTop,
    scrollHeight = _a.scrollHeight,
    clientHeight = _a.clientHeight;
  return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables = function (_a) {
  var scrollLeft = _a.scrollLeft,
    scrollWidth = _a.scrollWidth,
    clientWidth = _a.clientWidth;
  return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled = function (axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target),
      position = _a[0],
      scroll_1 = _a[1],
      capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    target = target.parentNode;
  } while (!targetInLock && target !== document.body || targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function (event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function (ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function (x2, y2) {
  return x2[0] === y2[0] && x2[1] === y2[1];
};
var generateStyle = function (id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter++)[0];
  var Style2 = React.useState(function () {
    return styleSingleton();
  })[0];
  var lastProps = React.useRef(props);
  React.useEffect(function () {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function () {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function (el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function () {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function (el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function (event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React.useCallback(function (_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function (e2) {
      return e2.name === event.type && e2.target === event.target && deltaCompare(e2.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      event.preventDefault();
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function (node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        event.preventDefault();
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function (name, delta, target, should) {
    var event = {
      name,
      delta,
      target,
      should
    };
    shouldPreventQueue.current.push(event);
    setTimeout(function () {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e2) {
        return e2 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function (event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function (event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function (event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function () {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function () {
      lockStack = lockStack.filter(function (inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar,
    inert = props.inert;
  return React.createElement(React.Fragment, null, inert ? React.createElement(Style2, {
    styles: generateStyle(id)
  }) : null, removeScrollBar ? React.createElement(RemoveScrollBar, {
    gapMode: "margin"
  }) : null);
}
var SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React.forwardRef(function (props, ref) {
  return React.createElement(RemoveScroll, __assign({}, props, {
    ref,
    sideCar: SideCar
  }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var $67UHm$RemoveScroll = ReactRemoveScroll;
var getDefaultParent = function (originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */new WeakMap();
var uncontrolledNodes = /* @__PURE__ */new WeakMap();
var markerMap = {};
var lockCount = 0;
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
  var targets = Array.isArray(originalTarget) ? originalTarget : [originalTarget];
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */new Set();
  var elementsToStop = new Set(targets);
  var keep = function (el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function (parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function (node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        var attr = node.getAttribute(controlAttribute);
        var alreadyHidden = attr !== null && attr !== "false";
        var counterValue = (counterMap.get(node) || 0) + 1;
        var markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenNodes.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledNodes.set(node, true);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, "true");
        }
        if (!alreadyHidden) {
          node.setAttribute(controlAttribute, "true");
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function () {
    hiddenNodes.forEach(function (node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */new WeakMap();
      counterMap = /* @__PURE__ */new WeakMap();
      uncontrolledNodes = /* @__PURE__ */new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function (originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function () {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
const $5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$5d3850c4d0b4e6c7$var$createDialogContext, $5d3850c4d0b4e6c7$export$cc702773b8ea3e41] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$5d3850c4d0b4e6c7$var$DialogProvider, $5d3850c4d0b4e6c7$var$useDialogContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $5d3850c4d0b4e6c7$export$3ddf2d174ce01153 = props => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const triggerRef = useRef(null);
  const contentRef = useRef(null);
  const [open = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogProvider, {
    scope: __scopeDialog,
    triggerRef,
    contentRef,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    titleId: $1746a345f3d73bb7$export$f680877a34711e37(),
    descriptionId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen]),
    modal
  }, children);
};
const $5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...triggerProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
  const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.contentId,
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, triggerProps, {
    ref: composedTriggerRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
  }));
});
const $5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$5d3850c4d0b4e6c7$var$PortalProvider, $5d3850c4d0b4e6c7$var$usePortalContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, {
  forceMount: void 0
});
const $5d3850c4d0b4e6c7$export$dad7c95542bacce0 = props => {
  const {
    __scopeDialog,
    forceMount,
    children,
    container
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$PortalProvider, {
    scope: __scopeDialog,
    forceMount
  }, Children.map(children, child => /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c, {
    asChild: true,
    container
  }, child))));
};
const $5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $5d3850c4d0b4e6c7$export$bd1d06c79be19e17 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
  const {
    forceMount = portalContext.forceMount,
    ...overlayProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
  return context.modal ? /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogOverlayImpl, _extends({}, overlayProps, {
    ref: forwardedRef
  }))) : null;
});
const $5d3850c4d0b4e6c7$var$DialogOverlayImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...overlayProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($67UHm$RemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: true,
    shards: [context.contentRef]
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, overlayProps, {
    ref: forwardedRef,
    style: {
      pointerEvents: "auto",
      ...overlayProps.style
    }
  })));
});
const $5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $5d3850c4d0b4e6c7$export$b6d9565de1e068cf = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const {
    forceMount = portalContext.forceMount,
    ...contentProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, context.modal ? /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentModal, _extends({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentNonModal, _extends({}, contentProps, {
    ref: forwardedRef
  })));
});
const $5d3850c4d0b4e6c7$var$DialogContentModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.contentRef, contentRef);
  useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: true,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, event => {
      var _context$triggerRef$c;
      event.preventDefault();
      (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
    }),
    onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, event => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (isRightClick) event.preventDefault();
    }),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, event => event.preventDefault())
  }));
});
const $5d3850c4d0b4e6c7$var$DialogContentNonModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: event => {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented) {
        var _context$triggerRef$c2;
        if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
    },
    onInteractOutside: event => {
      var _props$onInteractOuts, _context$triggerRef$c3;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented) hasInteractedOutsideRef.current = true;
      const target = event.target;
      const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
      if (targetIsTrigger) event.preventDefault();
    }
  }));
});
const $5d3850c4d0b4e6c7$var$DialogContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    trapFocus,
    onOpenAutoFocus,
    onCloseAutoFocus,
    ...contentProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */createElement$1($5cb92bef7577960e$export$177fb62ff3ec1f22, _extends({
    role: "dialog",
    id: context.contentId,
    "aria-describedby": context.descriptionId,
    "aria-labelledby": context.titleId,
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, contentProps, {
    ref: composedRefs,
    onDismiss: () => context.onOpenChange(false)
  }))), false);
});
const $5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $5d3850c4d0b4e6c7$export$16f7638e4a34b909 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...titleProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.h2, _extends({
    id: context.titleId
  }, titleProps, {
    ref: forwardedRef
  }));
});
const $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...descriptionProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.p, _extends({
    id: context.descriptionId
  }, descriptionProps, {
    ref: forwardedRef
  }));
});
const $5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...closeProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, () => context.onOpenChange(false))
  }));
});
function $5d3850c4d0b4e6c7$var$getState(open) {
  return open ? "open" : "closed";
}
const $5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
$c512c27ab02ef895$export$fd42f52fd3ae1109($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
  contentName: $5d3850c4d0b4e6c7$var$CONTENT_NAME,
  titleName: $5d3850c4d0b4e6c7$var$TITLE_NAME,
  docsSlug: "dialog"
});
const $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9 = $5d3850c4d0b4e6c7$export$3ddf2d174ce01153;
const $5d3850c4d0b4e6c7$export$41fb9f06171c75f4 = $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88;
const $5d3850c4d0b4e6c7$export$602eac185826482c = $5d3850c4d0b4e6c7$export$dad7c95542bacce0;
const $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff = $5d3850c4d0b4e6c7$export$bd1d06c79be19e17;
const $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2 = $5d3850c4d0b4e6c7$export$b6d9565de1e068cf;
const $5d3850c4d0b4e6c7$export$f99233281efd08a0 = $5d3850c4d0b4e6c7$export$16f7638e4a34b909;
const $5d3850c4d0b4e6c7$export$393edc798c47379d = $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5;
const $5d3850c4d0b4e6c7$export$f39c2d165cd861fe = $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac;
const $ea1ef594cf570d83$export$439d29a4e110a164 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({}, props, {
    ref: forwardedRef,
    style: {
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;
const overlayShow = keyframes({
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 0.8
  }
});
const contentShow = keyframes({
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
});
const StyledModalBaseOverlay = styled($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, {
  backgroundColor: "$gray10",
  opacity: 0.8,
  position: "fixed",
  inset: 0,
  zIndex: "$modal",
  "@media (prefers-reduced-motion: no-preference)": {
    animation: `${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
  }
});
const StyledModalBaseContentContainer = styled($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2, {
  backgroundColor: "transparent",
  position: "fixed",
  inset: 0,
  zIndex: "$modal",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "$2",
  pointerEvents: "none !important",
  variants: {}
});
const StyledModalBaseContent = styled(Box, {
  background: "$white",
  position: "relative",
  pointerEvents: "auto",
  "@media (prefers-reduced-motion: no-preference)": {
    animation: `${contentShow} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
  }
});
const StyledModalBaseCloseIcon = styled($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, {
  position: "absolute",
  top: "$1",
  right: "$1"
});
const StyledModalBaseTitle = styled($5d3850c4d0b4e6c7$export$f99233281efd08a0, {
  textStyles: "h1",
  textColor: "h1"
});
const StyledModalBaseDescription = styled($5d3850c4d0b4e6c7$export$393edc798c47379d, {
  textStyles: "subtitle1",
  textColor: "subtitle1"
});
const ModalBaseCloseIcon = _ref54 => {
  let {
    onClose
  } = _ref54;
  return /* @__PURE__ */jsx(StyledModalBaseCloseIcon, {
    asChild: true,
    children: /* @__PURE__ */jsx(IconButton, {
      title: "Close modal",
      icon: faXmark_2,
      onClick: onClose
    })
  });
};
const ModalBaseContentContainer = _ref55 => {
  let {
    ariaTitle,
    ariaDescription,
    children,
    ...props
  } = _ref55;
  return /* @__PURE__ */jsxs(StyledModalBaseContentContainer, {
    ...props,
    children: [ariaTitle && /* @__PURE__ */jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
      children: /* @__PURE__ */jsx($5d3850c4d0b4e6c7$export$f99233281efd08a0, {
        children: ariaTitle
      })
    }), ariaDescription && /* @__PURE__ */jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
      children: /* @__PURE__ */jsx($5d3850c4d0b4e6c7$export$393edc798c47379d, {
        children: ariaDescription
      })
    }), children]
  });
};
const ModalBaseTrigger = _ref56 => {
  let {
    children
  } = _ref56;
  return /* @__PURE__ */jsx($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, {
    asChild: true,
    children
  });
};
const ModalBase = {
  Root: $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9,
  Portal: $5d3850c4d0b4e6c7$export$602eac185826482c,
  Overlay: StyledModalBaseOverlay,
  Title: StyledModalBaseTitle,
  Description: StyledModalBaseDescription,
  Trigger: ModalBaseTrigger,
  ContentContainer: ModalBaseContentContainer,
  Content: StyledModalBaseContent,
  CloseIcon: ModalBaseCloseIcon
};
const ModalSizeVariant = {
  small: {
    maxWidth: "450px",
    maxHeight: "80vh",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto calc(32px + $5)",
    gridTemplateAreas: `
      "dialog-title"
      "dialog-content"
      "dialog-actions"
    `,
    "@sm": {
      maxHeight: "75vh"
    },
    "@md": {
      maxHeight: "65vh"
    },
    "@lg": {
      maxHeight: "50vh"
    }
  },
  medium: {
    maxWidth: "626px",
    maxHeight: "80vh",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto calc(32px + $5)",
    gridTemplateAreas: `
      "dialog-title"
      "dialog-content"
      "dialog-actions"
    `,
    "@sm": {
      maxHeight: "75vh"
    },
    "@md": {
      maxHeight: "65vh"
    },
    "@lg": {
      maxHeight: "50vh"
    }
  },
  large: {
    maxWidth: "750px",
    maxHeight: "80vh",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto calc(32px + $5)",
    gridTemplateAreas: `
      "dialog-title"
      "dialog-content"
      "dialog-actions"
    `,
    "@sm": {
      maxHeight: "75vh"
    },
    "@md": {
      maxHeight: "65vh"
    },
    "@lg": {
      maxHeight: "50vh"
    }
  },
  "x-large": {
    maxWidth: "955px",
    maxHeight: "80vh",
    display: "grid",
    gridTemplateRows: "auto auto calc(32px + $5)",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateAreas: `
      "dialog-title xl-content"
      "dialog-content xl-content"
      "dialog-actions xl-content"
    `,
    "@sm": {
      maxHeight: "75vh"
    },
    "@md": {
      maxHeight: "65vh"
    }
  }
};
const ModalDialogAlertVariant = {
  info: {
    borderTop: "4px solid $gray12"
  },
  warning: {
    borderTop: "4px solid $yellow4"
  },
  error: {
    borderTop: "4px solid $red6"
  }
};
const StyledModalContent = styled(ModalBase.Content, {
  borderRadius: "$1",
  boxShadow: "$3",
  variants: {
    size: ModalSizeVariant,
    variant: ModalDialogAlertVariant
  }
});
const StyledModalXlContent = styled(Box, {
  gridArea: "xl-content"
});
const StyledModalDialogTitle = styled(Flex, {
  gridArea: "dialog-title",
  paddingTop: "$3",
  paddingBottom: "$2",
  paddingX: "$3"
});
const StyledModalDialogContent = styled(Box, {
  gridArea: "dialog-content",
  paddingX: "$3",
  overflow: "auto",
  WebkitOverflowScrolling: "touch",
  overflowScrolling: "touch",
  background: `
          linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
          linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
          linear-gradient(180deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center top,
          linear-gradient(0deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center bottom
        `,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 40px, 100% 40px, 100% 4px, 100% 4px",
  backgroundAttachment: "local, local, scroll, scroll"
});
const StyledModalDialogActions = styled(Flex, {
  gridArea: "dialog-actions",
  paddingX: "$3",
  paddingBottom: "$3",
  paddingTop: "$2"
});
const ModalContext = createContext$1({
  onClose: () => {},
  open: false
});
const ModalRoot = _ref57 => {
  let {
    children,
    open,
    onClose
  } = _ref57;
  return /* @__PURE__ */jsx(ModalBase.Root, {
    open,
    children: /* @__PURE__ */jsx(ModalContext.Provider, {
      value: {
        open,
        onClose
      },
      children
    })
  });
};
const ModalDialog = _ref58 => {
  let {
    children,
    size,
    variant
  } = _ref58;
  const {
    onClose
  } = useContext(ModalContext);
  return /* @__PURE__ */jsxs(ModalBase.Portal, {
    children: [/* @__PURE__ */jsx(ModalBase.Overlay, {}), /* @__PURE__ */jsx(ModalBase.ContentContainer, {
      onEscapeKeyDown: onClose,
      onPointerDownOutside: onClose,
      onInteractOutside: onClose,
      children: /* @__PURE__ */jsxs(StyledModalContent, {
        size,
        variant,
        children: [children, /* @__PURE__ */jsx(ModalBase.CloseIcon, {
          onClose
        })]
      })
    })]
  });
};
const ModalDialogTitle = _ref59 => {
  let {
    title,
    subtitle
  } = _ref59;
  return /* @__PURE__ */jsxs(StyledModalDialogTitle, {
    direction: "column",
    gap: 0,
    children: [/* @__PURE__ */jsx(ModalBase.Title, {
      children: title
    }), subtitle && /* @__PURE__ */jsx(ModalBase.Description, {
      children: subtitle
    })]
  });
};
const ModalDialogActions = _ref60 => {
  let {
    children,
    justifyContent = "flex-end",
    ...props
  } = _ref60;
  return /* @__PURE__ */jsx(StyledModalDialogActions, {
    justifyContent,
    ...props,
    children
  });
};
const Modal = {
  Root: ModalRoot,
  Trigger: ModalBase.Trigger,
  Dialog: ModalDialog,
  Title: ModalDialogTitle,
  Content: StyledModalDialogContent,
  Actions: ModalDialogActions,
  XLContent: StyledModalXlContent
};
const ButtonGroupAlignmentMap = {
  left: "flex-start",
  right: "flex-end"
};
const ButtonGroupOrientationMap = {
  horizontal: "row",
  vertical: "column"
};
const ButtonGroup = forwardRef((_ref61, forwardedRef) => {
  let {
    as,
    align = "right",
    orientation = "horizontal",
    gap = 1,
    fullWidth,
    children,
    ...props
  } = _ref61;
  return /* @__PURE__ */jsx(Flex, {
    as,
    ref: forwardedRef,
    gap,
    direction: ButtonGroupOrientationMap[orientation],
    justifyContent: ButtonGroupAlignmentMap[align],
    role: "group",
    fullWidth,
    ...props,
    children
  });
});
ButtonGroup.displayName = "ButtonGroup";
var bolt$1 = {};
Object.defineProperty(bolt$1, "__esModule", {
  value: true
});
var bolt_2 = bolt$1.bolt = void 0;
const bolt = {
  prefix: "ddsCustom",
  iconName: "bolt",
  icon: [16, 16, [], "", "M13.2291 0C13.2859 0 13.3509 0.00840927 13.4078 0.0168181C13.6353 0.0672714 13.7327 0.285902 13.619 0.462488C13.5946 0.496124 13.5703 0.52976 13.5378 0.563395L9.69511 5.08737C9.69511 5.08737 9.62199 5.16305 9.59762 5.2051C9.45951 5.40691 9.59762 5.65918 9.86572 5.66759C9.90634 5.66759 9.98758 5.66759 9.98758 5.66759H11.3118C11.3118 5.66759 11.393 5.66759 11.4337 5.66759C11.6936 5.69281 11.8236 5.93667 11.6855 6.13848C11.653 6.18053 11.5799 6.27303 11.5799 6.27303L8.7446 9.57772C8.7121 9.61976 8.67961 9.6534 8.64711 9.70385C8.52525 9.90566 8.66336 10.1327 8.92333 10.1495C8.99644 10.1495 9.88196 10.1495 9.94696 10.1495C10.0851 10.1411 10.215 10.2168 10.28 10.3429C10.3369 10.4606 10.2963 10.6036 10.1988 10.6793C10.1744 10.7045 10.1176 10.7466 10.1176 10.7466L3.56148 15.8676C3.56148 15.8676 3.48024 15.9432 3.43962 15.9685C3.37462 16.0105 3.29338 16.0105 3.22839 15.9685C3.17152 15.9348 3.14715 15.8676 3.1634 15.8003C3.17965 15.7582 3.22027 15.6742 3.22027 15.6742L5.0238 11.8229L5.07254 11.7136C5.1944 11.4613 5.07254 11.2427 4.80445 11.209C4.77195 11.209 4.69884 11.209 4.69884 11.209H3.43962C3.39087 11.209 3.334 11.209 3.28526 11.2006C3.06591 11.167 2.94405 10.9736 3.02529 10.7802C3.04154 10.7381 3.09028 10.6541 3.09028 10.6541L5.33251 6.76074C5.33251 6.76074 5.35688 6.7187 5.37313 6.69347C5.49499 6.46643 5.34876 6.23939 5.06442 6.23098C4.95068 6.23098 4.71509 6.23098 4.71509 6.23098C4.71509 6.23098 4.11391 6.23098 3.71583 6.23098H3.59397C3.40712 6.23098 3.26901 6.13007 3.23652 5.97031C3.22839 5.88622 3.25276 5.81054 3.29338 5.74327L3.9758 4.49875L6.21803 0.412035L6.2749 0.319538C6.38863 0.109316 6.58361 0 6.84358 0H13.2291Z"]
};
bolt_2 = bolt$1.bolt = bolt;
var FeatureBadgeVariantEnum = /* @__PURE__ */(FeatureBadgeVariantEnum2 => {
  FeatureBadgeVariantEnum2["BETA"] = "beta";
  FeatureBadgeVariantEnum2["NEW"] = "new";
  FeatureBadgeVariantEnum2["UPGRADE"] = "upgrade";
  return FeatureBadgeVariantEnum2;
})(FeatureBadgeVariantEnum || {});
const FeatureBadgeVariant = {
  beta: {
    backgroundColor: "$purple9"
  },
  new: {
    backgroundColor: "$indigo11"
  },
  upgrade: {
    backgroundColor: "$pink9"
  }
};
var FeatureBadgeSizeVariantEnum = /* @__PURE__ */(FeatureBadgeSizeVariantEnum2 => {
  FeatureBadgeSizeVariantEnum2["SMALL"] = "small";
  FeatureBadgeSizeVariantEnum2["MEDIUM"] = "medium";
  return FeatureBadgeSizeVariantEnum2;
})(FeatureBadgeSizeVariantEnum || {});
const FeatureBadgeSizeVariant = {
  small: {
    textStyles: "h4",
    height: "$2"
  },
  medium: {
    textStyles: "bodyBold",
    height: "20px"
  }
};
const StyledFeatureBadge = styled("span", {
  position: "relative",
  display: "inline-block",
  textStyles: "h4",
  color: "$white",
  textAlign: "center",
  paddingX: "$1",
  "& svg": {
    size: "$2",
    position: "absolute",
    top: "-3px"
  },
  "& svg:first-child": {
    left: "-4px",
    color: "$black"
  },
  "& svg:last-child": {
    left: "-6px",
    color: "$lime3"
  },
  variants: {
    variant: FeatureBadgeVariant,
    size: FeatureBadgeSizeVariant
  },
  defaultVariants: {
    variant: "beta",
    size: "small"
  }
});
const FeatureBadge = forwardRef((_ref62, forwardedRef) => {
  let {
    variant,
    size = "small",
    css: css2,
    className,
    bolt: bolt2
  } = _ref62;
  return /* @__PURE__ */jsxs(StyledFeatureBadge, {
    ref: forwardedRef,
    css: css2,
    className,
    variant,
    size,
    children: [variant.toUpperCase(), bolt2 && /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx(Icon, {
        name: "bolt",
        icon: bolt_2
      }), /* @__PURE__ */jsx(Icon, {
        name: "bolt",
        icon: bolt_2
      })]
    })]
  });
});
FeatureBadge.displayName = "FeatureBadge";
const NotificationBadgeDigitVariant = {
  true: {
    top: "calc(0px - $2 / 2)",
    right: "calc(0px - $2 / 2)",
    minWidth: "$2",
    width: "inherit",
    height: "$2",
    paddingX: "$half",
    borderRadius: "16px"
  }
};
const StyledNotificationBadge = styled(Box, {
  position: "absolute",
  size: "$1",
  top: "calc(0px - $1 / 2)",
  right: "calc(0px - $1 / 2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textStyles: "h4",
  lineHeight: 0,
  backgroundColor: "$red8",
  borderRadius: "$round",
  variants: {
    digits: NotificationBadgeDigitVariant
  }
});
const NotificationBadge = forwardRef((_ref63, forwardedRef) => {
  let {
    children,
    css: css2,
    className
  } = _ref63;
  if (children == null || children === "") {
    return /* @__PURE__ */jsx(StyledNotificationBadge, {
      ref: forwardedRef,
      css: css2,
      className
    });
  }
  const stringChild = typeof children === "string" ? children : children.toString();
  return /* @__PURE__ */jsx(StyledNotificationBadge, {
    ref: forwardedRef,
    css: css2,
    className,
    digits: true,
    children: stringChild.length > 2 ? `99+` : stringChild
  });
});
NotificationBadge.displayName = "NotificationBadge";
var StatusBadgeVariantEnum = /* @__PURE__ */(StatusBadgeVariantEnum2 => {
  StatusBadgeVariantEnum2["SUCCESS"] = "success";
  StatusBadgeVariantEnum2["WARNING"] = "warning";
  StatusBadgeVariantEnum2["ERROR"] = "error";
  StatusBadgeVariantEnum2["PENDING"] = "pending";
  return StatusBadgeVariantEnum2;
})(StatusBadgeVariantEnum || {});
const StatusBadgeVariant = {
  success: {
    color: "$green12",
    backgroundColor: "$green2",
    "& svg": {
      color: "$green7"
    }
  },
  warning: {
    color: "$yellow12",
    backgroundColor: "$yellow2",
    "& svg": {
      color: "$yellow7"
    }
  },
  error: {
    color: "$red12",
    backgroundColor: "$red2",
    "& svg": {
      color: "$red7"
    }
  },
  pending: {
    color: "$blue12",
    backgroundColor: "$blue2",
    "& svg": {
      color: "$blue7"
    }
  }
};
var StatusBadgeSizeVariantEnum = /* @__PURE__ */(StatusBadgeSizeVariantEnum2 => {
  StatusBadgeSizeVariantEnum2["SMALL"] = "small";
  StatusBadgeSizeVariantEnum2["MEDIUM"] = "medium";
  return StatusBadgeSizeVariantEnum2;
})(StatusBadgeSizeVariantEnum || {});
const StatusBadgeSizeVariant = {
  small: {
    textStyles: "metadata",
    "& svg": {
      size: "10px",
      paddingY: "3px"
    }
  },
  medium: {
    textStyles: "body",
    "& svg": {
      size: "12px",
      paddingY: "4px"
    }
  }
};
const StyledStatusBadge = styled("span", {
  display: "inline-flex",
  paddingX: "$half",
  borderRadius: "$1",
  "& svg": {
    marginRight: "$half"
  },
  variants: {
    variant: StatusBadgeVariant,
    size: StatusBadgeSizeVariant
  }
});
const DefaultTextMap = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  pending: "Pending"
};
const StatusBadge = forwardRef((_ref64, forwardedRef) => {
  let {
    variant,
    size = "small",
    children = DefaultTextMap[variant],
    css: css2,
    className,
    icon: icon3
  } = _ref64;
  return /* @__PURE__ */jsxs(StyledStatusBadge, {
    ref: forwardedRef,
    className,
    css: css2,
    variant,
    size,
    children: [icon3 && /* @__PURE__ */jsx(Icon, {
      icon: icon3
    }), children]
  });
});
StatusBadge.displayName = "StatusBadge";
var InfoBadgeVariantEnum = /* @__PURE__ */(InfoBadgeVariantEnum2 => {
  InfoBadgeVariantEnum2["PRIMARY"] = "primary";
  InfoBadgeVariantEnum2["SECONDARY"] = "secondary";
  InfoBadgeVariantEnum2["AI_INFO"] = "ai-info";
  return InfoBadgeVariantEnum2;
})(InfoBadgeVariantEnum || {});
const InfoBadgeVariant = {
  primary: {
    color: "$gray12",
    backgroundColor: "$gray3",
    "& svg": {
      color: "$gray7"
    }
  },
  secondary: {
    color: "$gray1",
    backgroundColor: "$gray10",
    "& svg": {
      color: "$gray3"
    }
  },
  "ai-info": {
    color: "$purple12",
    backgroundColor: "$purple2",
    "& svg": {
      color: "$purple7"
    }
  }
};
var InfoBadgeSizeVariantEnum = /* @__PURE__ */(InfoBadgeSizeVariantEnum2 => {
  InfoBadgeSizeVariantEnum2["SMALL"] = "small";
  InfoBadgeSizeVariantEnum2["MEDIUM"] = "medium";
  return InfoBadgeSizeVariantEnum2;
})(InfoBadgeSizeVariantEnum || {});
const InfoBadgeSizeVariant = {
  small: {
    textStyles: "metadata",
    height: "16px",
    "& svg": {
      size: "12px",
      paddingY: "2px"
    }
  },
  medium: {
    textStyles: "body",
    height: "20px",
    "& svg": {
      size: "14px",
      paddingY: "3px"
    }
  }
};
const StyledInfoBadge = styled("span", {
  display: "inline-flex",
  paddingX: "$half",
  borderRadius: "$1",
  "& svg": {
    marginRight: "$half"
  },
  variants: {
    variant: InfoBadgeVariant,
    size: InfoBadgeSizeVariant
  }
});
const InfoBadge = forwardRef((_ref65, forwardedRef) => {
  let {
    variant = "primary",
    size = "small",
    children,
    css: css2,
    className,
    icon: icon3
  } = _ref65;
  return /* @__PURE__ */jsxs(StyledInfoBadge, {
    ref: forwardedRef,
    variant,
    size,
    className,
    css: css2,
    children: [icon3 && /* @__PURE__ */jsx(Icon, {
      icon: icon3
    }), children]
  });
});
InfoBadge.displayName = "InfoBadge";
var HighlightTextColorVariantEnum = /* @__PURE__ */(HighlightTextColorVariantEnum2 => {
  HighlightTextColorVariantEnum2["PURPLE"] = "purple";
  HighlightTextColorVariantEnum2["BLUE"] = "blue";
  return HighlightTextColorVariantEnum2;
})(HighlightTextColorVariantEnum || {});
const HighlightTextColorVariant = {
  purple: {
    color: "$purple12",
    background: "$purple2",
    "& svg": {
      color: "$purple7"
    }
  },
  blue: {
    color: "$blue12",
    background: "$blue2",
    "& svg": {
      color: "$blue7"
    }
  }
};
const StyledHighlightText = styled("span", {
  paddingX: "$half",
  borderRadius: "$1",
  paddingY: "1.5px",
  "& svg": {
    marginRight: "$half",
    size: "12px"
  },
  variants: {
    color: HighlightTextColorVariant
  }
});
const HighlightText = forwardRef((_ref66, forwardedRef) => {
  let {
    children,
    color,
    css: css2,
    className,
    icon: icon3
  } = _ref66;
  return /* @__PURE__ */jsxs(StyledHighlightText, {
    ref: forwardedRef,
    css: css2,
    className,
    color,
    children: [icon3 && /* @__PURE__ */jsx(Icon, {
      icon: icon3
    }), children]
  });
});
HighlightText.displayName = "HighlightText";
const $cddcb0b647441e34$var$AVATAR_NAME = "Avatar";
const [$cddcb0b647441e34$var$createAvatarContext, $cddcb0b647441e34$export$90370d16b488820f] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cddcb0b647441e34$var$AVATAR_NAME);
const [$cddcb0b647441e34$var$AvatarProvider, $cddcb0b647441e34$var$useAvatarContext] = $cddcb0b647441e34$var$createAvatarContext($cddcb0b647441e34$var$AVATAR_NAME);
const $cddcb0b647441e34$export$e2255cf6045e8d47 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeAvatar,
    ...avatarProps
  } = props;
  const [imageLoadingStatus, setImageLoadingStatus] = useState("idle");
  return /* @__PURE__ */createElement$1($cddcb0b647441e34$var$AvatarProvider, {
    scope: __scopeAvatar,
    imageLoadingStatus,
    onImageLoadingStatusChange: setImageLoadingStatus
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({}, avatarProps, {
    ref: forwardedRef
  })));
});
const $cddcb0b647441e34$var$IMAGE_NAME = "AvatarImage";
const $cddcb0b647441e34$export$2cd8ae1985206fe8 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeAvatar,
    src,
    onLoadingStatusChange = () => {},
    ...imageProps
  } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$IMAGE_NAME, __scopeAvatar);
  const imageLoadingStatus = $cddcb0b647441e34$var$useImageLoadingStatus(src);
  const handleLoadingStatusChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(status => {
    onLoadingStatusChange(status);
    context.onImageLoadingStatusChange(status);
  });
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (imageLoadingStatus !== "idle") handleLoadingStatusChange(imageLoadingStatus);
  }, [imageLoadingStatus, handleLoadingStatusChange]);
  return imageLoadingStatus === "loaded" ? /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.img, _extends({}, imageProps, {
    ref: forwardedRef,
    src
  })) : null;
});
const $cddcb0b647441e34$var$FALLBACK_NAME = "AvatarFallback";
const $cddcb0b647441e34$export$69fffb6a9571fbfe = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeAvatar,
    delayMs,
    ...fallbackProps
  } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$FALLBACK_NAME, __scopeAvatar);
  const [canRender, setCanRender] = useState(delayMs === void 0);
  useEffect(() => {
    if (delayMs !== void 0) {
      const timerId = window.setTimeout(() => setCanRender(true), delayMs);
      return () => window.clearTimeout(timerId);
    }
  }, [delayMs]);
  return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({}, fallbackProps, {
    ref: forwardedRef
  })) : null;
});
function $cddcb0b647441e34$var$useImageLoadingStatus(src) {
  const [loadingStatus, setLoadingStatus] = useState("idle");
  useEffect(() => {
    if (!src) {
      setLoadingStatus("error");
      return;
    }
    let isMounted = true;
    const image = new window.Image();
    const updateStatus = status => () => {
      if (!isMounted) return;
      setLoadingStatus(status);
    };
    setLoadingStatus("loading");
    image.onload = updateStatus("loaded");
    image.onerror = updateStatus("error");
    image.src = src;
    return () => {
      isMounted = false;
    };
  }, [src]);
  return loadingStatus;
}
const $cddcb0b647441e34$export$be92b6f5f03c0fe9 = $cddcb0b647441e34$export$e2255cf6045e8d47;
const $cddcb0b647441e34$export$3e431a229df88919 = $cddcb0b647441e34$export$2cd8ae1985206fe8;
const $cddcb0b647441e34$export$fb8d7f40caaeea67 = $cddcb0b647441e34$export$69fffb6a9571fbfe;
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "x" : "y";
}
function getLengthFromAxis(axis) {
  return axis === "y" ? "height" : "width";
}
function computeCoordsFromPlacement(_ref2, placement, rtl) {
  let {
    reference,
    floating
  } = _ref2;
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  const commonAlign = reference[length] / 2 - floating[length] / 2;
  const side = getSide(placement);
  const isVertical = mainAxis === "x";
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < middleware.length; i2++) {
    const {
      name,
      fn
    } = middleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
      continue;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getSideObjectFromPadding(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}
async function detectOverflow(middlewareArguments, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = middlewareArguments;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = options;
  const paddingObject = getSideObjectFromPadding(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: elementContext === "floating" ? {
      ...rects.floating,
      x: x2,
      y: y2
    } : rects.reference,
    offsetParent: await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating)),
    strategy
  }) : rects[elementContext]);
  return {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
}
const min$1 = Math.min;
const max$1 = Math.max;
function within(min$1$1, value, max$1$1) {
  return max$1(min$1$1, min$1(value, max$1$1));
}
const arrow$1 = options => ({
  name: "arrow",
  options,
  async fn(middlewareArguments) {
    const {
      element,
      padding = 0
    } = options != null ? options : {};
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2
    } = middlewareArguments;
    if (element == null) {
      return {};
    }
    const paddingObject = getSideObjectFromPadding(padding);
    const coords = {
      x: x2,
      y: y2
    };
    const axis = getMainAxisFromPlacement(placement);
    const alignment = getAlignment(placement);
    const length = getLengthFromAxis(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const minProp = axis === "y" ? "top" : "left";
    const maxProp = axis === "y" ? "bottom" : "right";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    if (clientSize === 0) {
      clientSize = rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const min2 = paddingObject[minProp];
    const max2 = clientSize - arrowDimensions[length] - paddingObject[maxProp];
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = within(min2, center, max2);
    const alignmentPadding = alignment === "start" ? paddingObject[minProp] : paddingObject[maxProp];
    const shouldAddOffset = alignmentPadding > 0 && center !== offset2 && rects.reference[length] <= rects.floating[length];
    const alignmentOffset = shouldAddOffset ? center < min2 ? min2 - center : max2 - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2
      }
    };
  }
});
const hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, matched => hash$1[matched]);
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement(mainAlignmentSide)
  };
}
const hash = {
  start: "end",
  end: "start"
};
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, matched => hash[matched]);
}
const sides = ["top", "right", "bottom", "left"];
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(middlewareArguments) {
      var _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = middlewareArguments;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        flipAlignment = true,
        ...detectOverflowOptions
      } = options;
      const side = getSide(placement);
      const isBasePlacement = side === initialPlacement;
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const {
          main,
          cross
        } = getAlignmentSides(placement, rects, await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)));
        overflows.push(overflow[main], overflow[cross]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every(side2 => side2 <= 0)) {
        var _middlewareData$flip$, _middlewareData$flip2;
        const nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) != null ? _middlewareData$flip$ : 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = "bottom";
        switch (fallbackStrategy) {
          case "bestFit":
            {
              var _overflowsData$map$so;
              const placement2 = (_overflowsData$map$so = overflowsData.map(d2 => [d2, d2.overflows.filter(overflow2 => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
          case "initialPlacement":
            resetPlacement = initialPlacement;
            break;
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
const hide$1 = function (_temp) {
  let {
    strategy = "referenceHidden",
    ...detectOverflowOptions
  } = _temp === void 0 ? {} : _temp;
  return {
    name: "hide",
    async fn(middlewareArguments) {
      const {
        rects
      } = middlewareArguments;
      switch (strategy) {
        case "referenceHidden":
          {
            const overflow = await detectOverflow(middlewareArguments, {
              ...detectOverflowOptions,
              elementContext: "reference"
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case "escaped":
          {
            const overflow = await detectOverflow(middlewareArguments, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};
async function convertValueToCoords(middlewareArguments, value) {
  const {
    placement,
    platform: platform2,
    elements
  } = middlewareArguments;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getMainAxisFromPlacement(placement) === "x";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = typeof value === "function" ? value(middlewareArguments) : value;
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset = function (value) {
  if (value === void 0) {
    value = 0;
  }
  return {
    name: "offset",
    options: value,
    async fn(middlewareArguments) {
      const {
        x: x2,
        y: y2
      } = middlewareArguments;
      const diffCoords = await convertValueToCoords(middlewareArguments, value);
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: diffCoords
      };
    }
  };
};
function getCrossAxis(axis) {
  return axis === "x" ? "y" : "x";
}
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(middlewareArguments) {
      const {
        x: x2,
        y: y2,
        placement
      } = middlewareArguments;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref2 => {
            let {
              x: x3,
              y: y3
            } = _ref2;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = options;
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const mainAxis = getMainAxisFromPlacement(getSide(placement));
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = within(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = within(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...middlewareArguments,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2
        }
      };
    }
  };
};
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(middlewareArguments) {
      const {
        x: x2,
        y: y2,
        placement,
        rects,
        middlewareData
      } = middlewareArguments;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = options;
      const coords = {
        x: x2,
        y: y2
      };
      const mainAxis = getMainAxisFromPlacement(placement);
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = typeof offset2 === "function" ? offset2({
        ...rects,
        placement
      }) : offset2;
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2, _middlewareData$offse3, _middlewareData$offse4;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = ["top", "left"].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? (_middlewareData$offse = (_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) != null ? _middlewareData$offse : 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : (_middlewareData$offse3 = (_middlewareData$offse4 = middlewareData.offset) == null ? void 0 : _middlewareData$offse4[crossAxis]) != null ? _middlewareData$offse3 : 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
function isWindow(value) {
  return value && value.document && value.location && value.alert && value.setInterval;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (!isWindow(node)) {
    const ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeName(node) {
  return isWindow(node) ? "" : node ? (node.nodeName || "").toLowerCase() : "";
}
function getUAString() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(item => item.brand + "/" + item.version).join(" ");
  }
  return navigator.userAgent;
}
function isHTMLElement(value) {
  return value instanceof getWindow(value).HTMLElement;
}
function isElement(value) {
  return value instanceof getWindow(value).Element;
}
function isNode(value) {
  return value instanceof getWindow(value).Node;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const isFirefox = /firefox/i.test(getUAString());
  const css2 = getComputedStyle$1(element);
  return css2.transform !== "none" || css2.perspective !== "none" || css2.contain === "paint" || ["transform", "perspective"].includes(css2.willChange) || isFirefox && css2.willChange === "filter" || isFirefox && (css2.filter ? css2.filter !== "none" : false);
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
const min = Math.min;
const max = Math.max;
const round = Math.round;
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  let scaleX = 1;
  let scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  const win = isElement(element) ? getWindow(element) : window;
  const addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  const x2 = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scaleX;
  const y2 = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scaleY;
  const width = clientRect.width / scaleX;
  const height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2,
    x: x2,
    y: y2
  };
}
function getDocumentElement(node) {
  return ((isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function isScaled(element) {
  const rect = getBoundingClientRect(element);
  return round(rect.width) !== element.offsetWidth || round(rect.height) !== element.offsetHeight;
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const rect = getBoundingClientRect(element, isOffsetParentAnElement && isScaled(offsetParent), strategy === "fixed");
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  return node.assignedSlot || node.parentNode || (isShadowRoot(node) ? node.host : null) || getDocumentElement(node);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && !["html", "body"].includes(getNodeName(currentNode))) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  const window2 = getWindow(element);
  let offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static" && !isContainingBlock(offsetParent))) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getDimensions(element) {
  if (isHTMLElement(element)) {
    return {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
  }
  const rect = getBoundingClientRect(element);
  return {
    width: rect.width,
    height: rect.height
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref2) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref2;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    ...rect,
    x: rect.x - scroll.scrollLeft + offsets.x,
    y: rect.y - scroll.scrollTop + offsets.y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  const width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  const height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === "rtl") {
    x2 += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (["html", "body", "#document"].includes(getNodeName(parentNode))) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list) {
  var _node$ownerDocument;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow(scrollableAncestor);
  const target = isBody ? [win].concat(win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []) : scrollableAncestor;
  const updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(getOverflowAncestors(target));
}
function contains$1(parent, child) {
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    do {
      if (next && parent === next) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, false, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  return {
    top,
    left,
    x: left,
    y: top,
    right: left + element.clientWidth,
    bottom: top + element.clientHeight,
    width: element.clientWidth,
    height: element.clientHeight
  };
}
function getClientRectFromClippingAncestor(element, clippingParent, strategy) {
  if (clippingParent === "viewport") {
    return rectToClientRect(getViewportRect(element, strategy));
  }
  if (isElement(clippingParent)) {
    return getInnerBoundingClientRect(clippingParent, strategy);
  }
  return rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingAncestors(element) {
  const clippingAncestors = getOverflowAncestors(element);
  const canEscapeClipping = ["absolute", "fixed"].includes(getComputedStyle$1(element).position);
  const clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingAncestors.filter(clippingAncestors2 => isElement(clippingAncestors2) && contains$1(clippingAncestors2, clipperElement) && getNodeName(clippingAncestors2) !== "body");
}
function getClippingRect(_ref2) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref2;
  const mainClippingAncestors = boundary === "clippingAncestors" ? getClippingAncestors(element) : [].concat(boundary);
  const clippingAncestors = [...mainClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
const platform = {
  getClippingRect,
  convertOffsetParentRelativeRectToViewportRelativeRect,
  isElement,
  getDimensions,
  getOffsetParent,
  getDocumentElement,
  getElementRects: _ref2 => {
    let {
      reference,
      floating,
      strategy
    } = _ref2;
    return {
      reference: getRectRelativeToOffsetParent(reference, getOffsetParent(floating), strategy),
      floating: {
        ...getDimensions(floating),
        x: 0,
        y: 0
      }
    };
  },
  getClientRects: element => Array.from(element.getClientRects()),
  isRTL: element => getComputedStyle$1(element).direction === "rtl"
};
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll: _ancestorScroll = true,
    ancestorResize: _ancestorResize = true,
    elementResize = true,
    animationFrame = false
  } = options;
  const ancestorScroll = _ancestorScroll && !animationFrame;
  const ancestorResize = _ancestorResize && !animationFrame;
  const ancestors = ancestorScroll || ancestorResize ? [...(isElement(reference) ? getOverflowAncestors(reference) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  let observer = null;
  if (elementResize) {
    let initialUpdate = true;
    observer = new ResizeObserver(() => {
      if (!initialUpdate) {
        update();
      }
      initialUpdate = false;
    });
    isElement(reference) && !animationFrame && observer.observe(reference);
    observer.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _observer;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    (_observer = observer) == null ? void 0 : _observer.disconnect();
    observer = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const computePosition = (reference, floating, options) => computePosition$1(reference, floating, {
  platform,
  ...options
});
var index = typeof document !== "undefined" ? useLayoutEffect$1 : useEffect;
function deepEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (typeof a2 !== typeof b2) {
    return false;
  }
  if (typeof a2 === "function" && a2.toString() === b2.toString()) {
    return true;
  }
  let length, i2, keys4;
  if (a2 && b2 && typeof a2 == "object") {
    if (Array.isArray(a2)) {
      length = a2.length;
      if (length != b2.length) return false;
      for (i2 = length; i2-- !== 0;) {
        if (!deepEqual(a2[i2], b2[i2])) {
          return false;
        }
      }
      return true;
    }
    keys4 = Object.keys(a2);
    length = keys4.length;
    if (length !== Object.keys(b2).length) {
      return false;
    }
    for (i2 = length; i2-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b2, keys4[i2])) {
        return false;
      }
    }
    for (i2 = length; i2-- !== 0;) {
      const key = keys4[i2];
      if (key === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!deepEqual(a2[key], b2[key])) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(_temp) {
  let {
    middleware,
    placement = "bottom",
    strategy = "absolute",
    whileElementsMounted
  } = _temp === void 0 ? {} : _temp;
  const reference = React.useRef(null);
  const floating = React.useRef(null);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const cleanupRef = React.useRef(null);
  const [data, setData] = React.useState({
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {}
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware == null ? void 0 : latestMiddleware.map(_ref2 => {
    let {
      options
    } = _ref2;
    return options;
  }), middleware == null ? void 0 : middleware.map(_ref2 => {
    let {
      options
    } = _ref2;
    return options;
  }))) {
    setLatestMiddleware(middleware);
  }
  const update = React.useCallback(() => {
    if (!reference.current || !floating.current) {
      return;
    }
    computePosition(reference.current, floating.current, {
      middleware: latestMiddleware,
      placement,
      strategy
    }).then(data2 => {
      if (isMountedRef.current) {
        $7SXl2$reactdom.flushSync(() => {
          setData(data2);
        });
      }
    });
  }, [latestMiddleware, placement, strategy]);
  index(() => {
    if (isMountedRef.current) {
      update();
    }
  }, [update]);
  const isMountedRef = React.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const runElementMountCallback = React.useCallback(() => {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (reference.current && floating.current) {
      if (whileElementsMountedRef.current) {
        const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
        cleanupRef.current = cleanupFn;
      } else {
        update();
      }
    }
  }, [update, whileElementsMountedRef]);
  const setReference = React.useCallback(node => {
    reference.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const setFloating = React.useCallback(node => {
    floating.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const refs = React.useMemo(() => ({
    reference,
    floating
  }), []);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, setReference, setFloating]);
}
const arrow = options => {
  const {
    element,
    padding
  } = options;
  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return arrow$1({
            element: element.current,
            padding
          }).fn(args);
        }
        return {};
      } else if (element) {
        return arrow$1({
          element,
          padding
        }).fn(args);
      }
      return {};
    }
  };
};
const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    width = 10,
    height = 5,
    ...arrowProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.svg, _extends({}, arrowProps, {
    ref: forwardedRef,
    width,
    height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /* @__PURE__ */createElement$1("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;
const $cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = props => {
  const {
    __scopePopper,
    children
  } = props;
  const [anchor, setAnchor] = useState(null);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PopperProvider, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor
  }, children);
};
const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopper,
    virtualRef,
    ...anchorProps
  } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, anchorProps, {
    ref: composedRefs
  }));
});
const $cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const [$cf1ac5d9fe0e8206$var$PositionContextProvider, $cf1ac5d9fe0e8206$var$usePositionContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, {
  hasParent: false,
  positionUpdateFns: /* @__PURE__ */new Set()
});
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
  const {
    __scopePopper,
    side = "bottom",
    sideOffset = 0,
    align = "center",
    alignOffset = 0,
    arrowPadding = 0,
    collisionBoundary = [],
    collisionPadding: collisionPaddingProp = 0,
    sticky = "partial",
    hideWhenDetached = false,
    avoidCollisions = true,
    ...contentProps
  } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const [content, setContent] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node => setContent(node));
  const [arrow$12, setArrow] = useState(null);
  const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow$12);
  const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...collisionPaddingProp
  };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
    altBoundary: hasExplicitBoundaries
  };
  const {
    reference,
    floating,
    strategy,
    x: x2,
    y: y2,
    placement,
    middlewareData,
    update
  } = useFloating({
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: autoUpdate,
    middleware: [offset({
      mainAxis: sideOffset + arrowHeight,
      alignmentAxis: alignOffset
    }), avoidCollisions ? shift({
      mainAxis: true,
      crossAxis: false,
      limiter: sticky === "partial" ? limitShift() : void 0,
      ...detectOverflowOptions
    }) : void 0, arrow$12 ? arrow({
      element: arrow$12,
      padding: arrowPadding
    }) : void 0, avoidCollisions ? flip({
      ...detectOverflowOptions
    }) : void 0, $cf1ac5d9fe0e8206$var$transformOrigin({
      arrowWidth,
      arrowHeight
    }), hideWhenDetached ? hide$1({
      strategy: "referenceHidden"
    }) : void 0].filter($cf1ac5d9fe0e8206$var$isDefined)
  });
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    reference(context.anchor);
  }, [reference, context.anchor]);
  const isPlaced = x2 !== null && y2 !== null;
  const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
  const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  const [contentZIndex, setContentZIndex] = useState();
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  const {
    hasParent,
    positionUpdateFns
  } = $cf1ac5d9fe0e8206$var$usePositionContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const isRoot = !hasParent;
  useLayoutEffect$1(() => {
    if (!isRoot) {
      positionUpdateFns.add(update);
      return () => {
        positionUpdateFns.delete(update);
      };
    }
  }, [isRoot, positionUpdateFns, update]);
  useLayoutEffect$1(() => {
    if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach(fn => requestAnimationFrame(fn));
  }, [isRoot, isPlaced, positionUpdateFns]);
  const commonProps = {
    "data-side": placedSide,
    "data-align": placedAlign,
    ...contentProps,
    ref: composedRefs,
    style: {
      ...contentProps.style,
      animation: !isPlaced ? "none" : void 0,
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */createElement$1("div", {
    ref: floating,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: strategy,
      left: 0,
      top: 0,
      transform: isPlaced ? `translate3d(${Math.round(x2)}px, ${Math.round(y2)}px, 0)` : "translate3d(0, -200%, 0)",
      minWidth: "max-content",
      zIndex: contentZIndex,
      ["--radix-popper-transform-origin"]: [(_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x, (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y].join(" ")
    }
  }, /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PopperContentProvider, {
    scope: __scopePopper,
    placedSide,
    onArrowChange: setArrow,
    arrowX,
    arrowY,
    shouldHideArrow: cannotCenterArrow
  }, isRoot ? /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PositionContextProvider, {
    scope: __scopePopper,
    hasParent: true,
    positionUpdateFns
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, commonProps)) : /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, commonProps)));
});
const $cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /* @__PURE__ */forwardRef(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd02(props, forwardedRef) {
  const {
    __scopePopper,
    ...arrowProps
  } = props;
  const contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
  const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
  return /* @__PURE__ */createElement$1("span", {
    ref: contentContext.onArrowChange,
    style: {
      position: "absolute",
      left: contentContext.arrowX,
      top: contentContext.arrowY,
      [baseSide]: 0,
      transformOrigin: {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[contentContext.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: `rotate(180deg)`,
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[contentContext.placedSide],
      visibility: contentContext.shouldHideArrow ? "hidden" : void 0
    }
  }, /* @__PURE__ */createElement$1($7e8f5cd07187803e$export$be92b6f5f03c0fe9, _extends({}, arrowProps, {
    ref: forwardedRef,
    style: {
      ...arrowProps.style,
      display: "block"
    }
  })));
});
function $cf1ac5d9fe0e8206$var$isDefined(value) {
  return value !== void 0;
}
function $cf1ac5d9fe0e8206$var$isNotNull(value) {
  return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = options => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
    const {
      placement,
      rects,
      middlewareData
    } = data;
    const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const noArrowAlign = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[placedAlign];
    const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
    const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
    let x2 = "";
    let y2 = "";
    if (placedSide === "bottom") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x2 = `${-arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x2 = `${rects.floating.width + arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return {
      data: {
        x: x2,
        y: y2
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;
const [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = $c512c27ab02ef895$export$50c7b4e9d9f19c1("Tooltip", [$cf1ac5d9fe0e8206$export$722aac194ae923]);
const $a093c7e1ec25a057$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const $a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
const $a093c7e1ec25a057$export$f78649fb9ca566b8 = props => {
  const {
    __scopeTooltip,
    delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION,
    skipDelayDuration = 300,
    disableHoverableContent = false,
    children
  } = props;
  const [isOpenDelayed, setIsOpenDelayed] = useState(true);
  const isPointerInTransitRef = useRef(false);
  const skipDelayTimerRef = useRef(0);
  useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current;
    return () => window.clearTimeout(skipDelayTimer);
  }, []);
  return /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
    scope: __scopeTooltip,
    isOpenDelayed,
    delayDuration,
    onOpen: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      setIsOpenDelayed(false);
    }, []),
    onClose: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      skipDelayTimerRef.current = window.setTimeout(() => setIsOpenDelayed(true), skipDelayDuration);
    }, [skipDelayDuration]),
    isPointerInTransitRef,
    onPointerInTransitChange: useCallback(inTransit => {
      isPointerInTransitRef.current = inTransit;
    }, []),
    disableHoverableContent
  }, children);
};
const $a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
const $a093c7e1ec25a057$export$28c660c63b792dea = props => {
  const {
    __scopeTooltip,
    children,
    open: openProp,
    defaultOpen = false,
    onOpenChange,
    disableHoverableContent: disableHoverableContentProp,
    delayDuration: delayDurationProp
  } = props;
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const [trigger, setTrigger] = useState(null);
  const contentId = $1746a345f3d73bb7$export$f680877a34711e37();
  const openTimerRef = useRef(0);
  const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
  const wasOpenDelayedRef = useRef(false);
  const [open1 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: open => {
      if (open) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
      } else providerContext.onClose();
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
    }
  });
  const stateAttribute = useMemo(() => {
    return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [open1]);
  const handleOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [setOpen]);
  const handleClose = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    setOpen(false);
  }, [setOpen]);
  const handleDelayedOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
    }, delayDuration);
  }, [delayDuration, setOpen]);
  useEffect(() => {
    return () => window.clearTimeout(openTimerRef.current);
  }, []);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContextProvider, {
    scope: __scopeTooltip,
    contentId,
    open: open1,
    stateAttribute,
    trigger,
    onTriggerChange: setTrigger,
    onTriggerEnter: useCallback(() => {
      if (providerContext.isOpenDelayed) handleDelayedOpen();else handleOpen();
    }, [providerContext.isOpenDelayed, handleDelayedOpen, handleOpen]),
    onTriggerLeave: useCallback(() => {
      if (disableHoverableContent) handleClose();else window.clearTimeout(openTimerRef.current);
    }, [handleClose, disableHoverableContent]),
    onOpen: handleOpen,
    onClose: handleClose,
    disableHoverableContent
  }, children));
};
const $a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $a093c7e1ec25a057$export$8c610744efcf8a1d = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTooltip,
    ...triggerProps
  } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onTriggerChange);
  const isPointerDownRef = useRef(false);
  const hasPointerMoveOpenedRef = useRef(false);
  const handlePointerUp = useCallback(() => isPointerDownRef.current = false, []);
  useEffect(() => {
    return () => document.removeEventListener("pointerup", handlePointerUp);
  }, [handlePointerUp]);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends({
    asChild: true
  }, popperScope), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
    "aria-describedby": context.open ? context.contentId : void 0,
    "data-state": context.stateAttribute
  }, triggerProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, event => {
      if (event.pointerType === "touch") return;
      if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
        context.onTriggerEnter();
        hasPointerMoveOpenedRef.current = true;
      }
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, () => {
      context.onTriggerLeave();
      hasPointerMoveOpenedRef.current = false;
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, () => {
      isPointerDownRef.current = true;
      document.addEventListener("pointerup", handlePointerUp, {
        once: true
      });
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => {
      if (!isPointerDownRef.current) context.onOpen();
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, context.onClose),
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, event => {
      const isKeyboardClick = event.detail === 0;
      if (isKeyboardClick) context.onClose();
    })
  })));
});
const $a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
  forceMount: void 0
});
const $a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $a093c7e1ec25a057$export$e9003e2be37ec060 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const {
    forceMount = portalContext.forceMount,
    side = "top",
    ...contentProps
  } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, context.disableHoverableContent ? /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContentImpl, _extends({
    side
  }, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContentHoverable, _extends({
    side
  }, contentProps, {
    ref: forwardedRef
  })));
});
const $a093c7e1ec25a057$var$TooltipContentHoverable = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = useState(null);
  const {
    trigger,
    onClose
  } = context;
  const content = ref.current;
  const {
    onPointerInTransitChange
  } = providerContext;
  const handleRemoveGraceArea = useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [onPointerInTransitChange]);
  const handleCreateGraceArea = useCallback((event, hoverTarget) => {
    const currentTarget = event.currentTarget;
    const exitPoint = {
      x: event.clientX,
      y: event.clientY
    };
    const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
    const bleed = exitSide === "right" || exitSide === "bottom" ? -5 : 5;
    const isXAxis = exitSide === "right" || exitSide === "left";
    const startPoint = isXAxis ? {
      x: event.clientX + bleed,
      y: event.clientY
    } : {
      x: event.clientX,
      y: event.clientY + bleed
    };
    const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
    const graceArea = $a093c7e1ec25a057$var$getHull([startPoint, ...hoverTargetPoints]);
    setPointerGraceArea(graceArea);
    onPointerInTransitChange(true);
  }, [onPointerInTransitChange]);
  useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [handleRemoveGraceArea]);
  useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = event => handleCreateGraceArea(event, content);
      const handleContentLeave = event => handleCreateGraceArea(event, trigger);
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [trigger, content, handleCreateGraceArea, handleRemoveGraceArea]);
  useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = event => {
        const target = event.target;
        const pointerPosition = {
          x: event.clientX,
          y: event.clientY
        };
        const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
        const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) handleRemoveGraceArea();else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [trigger, content, pointerGraceArea, onClose, handleRemoveGraceArea]);
  return /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContentImpl, _extends({}, props, {
    ref: composedRefs
  }));
});
const [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
  isInside: false
});
const $a093c7e1ec25a057$var$TooltipContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTooltip,
    children,
    "aria-label": ariaLabel,
    onEscapeKeyDown,
    onPointerDownOutside,
    ...contentProps
  } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const {
    onClose
  } = context;
  useEffect(() => {
    document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    return () => document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
  }, [onClose]);
  useEffect(() => {
    if (context.trigger) {
      const handleScroll2 = event => {
        const target = event.target;
        if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
      };
      window.addEventListener("scroll", handleScroll2, {
        capture: true
      });
      return () => window.removeEventListener("scroll", handleScroll2, {
        capture: true
      });
    }
  }, [context.trigger, onClose]);
  return /* @__PURE__ */createElement$1($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents: false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside: event => event.preventDefault(),
    onDismiss: onClose
  }, /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends({
    "data-state": context.stateAttribute
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      ["--radix-tooltip-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }), /* @__PURE__ */createElement$1($5e63c961fc1ce211$export$d9f1ccf0bdb05d45, null, children), /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
    scope: __scopeTooltip,
    isInside: true
  }, /* @__PURE__ */createElement$1($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
    id: context.contentId,
    role: "tooltip"
  }, ariaLabel || children))));
});
const $a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $a093c7e1ec25a057$export$c27ee0ad710f7559 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTooltip,
    ...arrowProps
  } = props;
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip);
  return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
  const top = Math.abs(rect.top - point.y);
  const bottom = Math.abs(rect.bottom - point.y);
  const right = Math.abs(rect.right - point.x);
  const left = Math.abs(rect.left - point.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      return null;
  }
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
  const {
    top,
    right,
    bottom,
    left
  } = rect;
  return [{
    x: left,
    y: top
  }, {
    x: right,
    y: top
  }, {
    x: right,
    y: bottom
  }, {
    x: left,
    y: bottom
  }];
}
function $a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
  const {
    x: x2,
    y: y2
  } = point;
  let inside = false;
  for (let i2 = 0, j2 = polygon.length - 1; i2 < polygon.length; j2 = i2++) {
    const xi = polygon[i2].x;
    const yi = polygon[i2].y;
    const xj = polygon[j2].x;
    const yj = polygon[j2].y;
    const intersect = yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $a093c7e1ec25a057$var$getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a2, b2) => {
    if (a2.x < b2.x) return -1;else if (a2.x > b2.x) return 1;else if (a2.y < b2.y) return -1;else if (a2.y > b2.y) return 1;else return 0;
  });
  return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
}
function $a093c7e1ec25a057$var$getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  const upperHull = [];
  for (let i2 = 0; i2 < points.length; i2++) {
    const p2 = points[i2];
    while (upperHull.length >= 2) {
      const q2 = upperHull[upperHull.length - 1];
      const r2 = upperHull[upperHull.length - 2];
      if ((q2.x - r2.x) * (p2.y - r2.y) >= (q2.y - r2.y) * (p2.x - r2.x)) upperHull.pop();else break;
    }
    upperHull.push(p2);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i1 = points.length - 1; i1 >= 0; i1--) {
    const p2 = points[i1];
    while (lowerHull.length >= 2) {
      const q2 = lowerHull[lowerHull.length - 1];
      const r2 = lowerHull[lowerHull.length - 2];
      if ((q2.x - r2.x) * (p2.y - r2.y) >= (q2.y - r2.y) * (p2.x - r2.x)) lowerHull.pop();else break;
    }
    lowerHull.push(p2);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;else return upperHull.concat(lowerHull);
}
const $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
const $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
const $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
const $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
const $a093c7e1ec25a057$export$21b07c8f274aebd5 = $a093c7e1ec25a057$export$c27ee0ad710f7559;
var AvatarSizeVariantEnum = /* @__PURE__ */(AvatarSizeVariantEnum2 => {
  AvatarSizeVariantEnum2["X_SMALL"] = "x-small";
  AvatarSizeVariantEnum2["SMALL"] = "small";
  AvatarSizeVariantEnum2["MEDIUM"] = "medium";
  AvatarSizeVariantEnum2["LARGE"] = "large";
  AvatarSizeVariantEnum2["X_LARGE"] = "x-large";
  return AvatarSizeVariantEnum2;
})(AvatarSizeVariantEnum || {});
const AvatarSizeVariant = {
  "x-small": {
    size: "$3",
    fontSize: "0.714rem"
  },
  small: {
    size: "$4",
    fontSize: "$1"
  },
  medium: {
    size: "40px",
    fontSize: "$3"
  },
  large: {
    size: "$8",
    fontSize: "$5"
  },
  "x-large": {
    size: "96px",
    fontSize: "$6"
  }
};
const BaseAvatarRoot = styled($cddcb0b647441e34$export$be92b6f5f03c0fe9, {
  borderRadius: "$round",
  display: "flex",
  position: "relative",
  justifyContent: "center",
  alignItems: "center",
  userSelect: "none",
  cursor: "default",
  variants: {
    size: AvatarSizeVariant
  },
  defaultVariants: {
    size: AvatarSizeVariantEnum.MEDIUM
  }
});
const AvatarImage = styled($cddcb0b647441e34$export$3e431a229df88919, {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "inherit"
});
const AvatarIndicator = styled(Box, {
  borderRadius: "$round",
  borderStyle: "solid",
  borderColor: "$white",
  position: "absolute",
  bottom: "-4px",
  right: "-4px",
  variants: {
    size: {
      "x-small": {
        borderWidth: "1.5px"
      },
      small: {
        borderWidth: "2px"
      },
      medium: {
        borderWidth: "2px"
      },
      large: {
        borderWidth: "4px"
      },
      "x-large": {
        borderWidth: "6px"
      }
    }
  }
});
const AvatarTooltipContent = styled($a093c7e1ec25a057$export$7c6e2c02157bb7d2, {
  boxShadow: "$2",
  textStyles: "metadata",
  paddingX: "$1",
  paddingY: "$half",
  borderRadius: "$1",
  zIndex: "$tooltip"
});
const AvatarTooltipArrow = styled($a093c7e1ec25a057$export$21b07c8f274aebd5, {
  fill: "$white"
});
const AvatarTooltipTrigger = styled($a093c7e1ec25a057$export$41fb9f06171c75f4, {
  background: "transparent",
  border: "none",
  margin: 0,
  padding: 0,
  "&:focus-visible": {
    borderRadius: "50%",
    outline: "solid 2px $blue6"
  }
});
const TOOLTIP_WIDTH_PX = 10;
const TOOLTIP_HEIGHT_PX = 4;
const AvatarTooltip = _ref67 => {
  let {
    children,
    content
  } = _ref67;
  if (!content) {
    return /* @__PURE__ */jsx(Fragment, {
      children
    });
  }
  return /* @__PURE__ */jsx($a093c7e1ec25a057$export$2881499e37b75b9a, {
    children: /* @__PURE__ */jsxs($a093c7e1ec25a057$export$be92b6f5f03c0fe9, {
      children: [/* @__PURE__ */jsx(AvatarTooltipTrigger, {
        children
      }), /* @__PURE__ */jsxs(AvatarTooltipContent, {
        side: "bottom",
        children: [content, /* @__PURE__ */jsx(AvatarTooltipArrow, {
          width: TOOLTIP_WIDTH_PX,
          height: TOOLTIP_HEIGHT_PX
        })]
      })]
    })
  });
};
var faUser$1 = {};
Object.defineProperty(faUser$1, "__esModule", {
  value: true
});
var faUser_2 = faUser$1.faUser = void 0;
const faUser = {
  prefix: "fas",
  iconName: "faUser",
  icon: [448, 512, [], "", "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"]
};
faUser_2 = faUser$1.faUser = faUser;
const AVATAR_FALLBACK_DELAY$1 = 600;
const UserAvatarStatusIndicatorMap = {
  available: "success",
  away: "away",
  "chat-limit": "chat-limit"
};
const UserAvatarStatusTooltipMap = {
  available: "available",
  away: "away",
  "chat-limit": "at chat limit"
};
const UserAvatarColorVariant = {
  blue: {
    backgroundColor: "$blue1",
    border: "1px solid $blue6",
    color: "$blue9"
  },
  yellow: {
    backgroundColor: "$orange2",
    border: "1px solid $orange6",
    color: "$orange9"
  },
  teal: {
    backgroundColor: "$teal1",
    border: "1px solid $teal6",
    color: "$teal9"
  },
  purple: {
    backgroundColor: "$purple1",
    border: "1px solid $purple6",
    color: "$purple9"
  },
  pink: {
    backgroundColor: "$pink1",
    border: "1px solid $pink6",
    color: "$pink9"
  }
};
const UserAvatarUnknownVariant = {
  gray: {
    backgroundColor: "$gray2",
    border: "1px solid $gray6",
    color: "$gray9"
  }
};
const KnownUserAvatarRoot = styled(BaseAvatarRoot, {
  variants: {
    color: {
      ...UserAvatarColorVariant,
      ...UserAvatarUnknownVariant
    }
  }
});
const UnknownUserAvatarRoot = styled(BaseAvatarRoot, {
  backgroundColor: "$gray2",
  border: "1px solid $gray6",
  color: "$gray9"
});
const InitialsText = styled("span", {
  paddingTop: "2px"
});
const INVALID_INITIAL_REGEX = /[^\p{L}\p{Z}^$\n]/gu;
const BKDRHash = str => {
  const seed = 131;
  const seed2 = 137;
  let hash2 = 0;
  str += "x";
  const safeSeed = (Number.MAX_SAFE_INTEGER / seed2).toString();
  const MAX_SAFE_INTEGER = parseInt(safeSeed, 10);
  for (let i2 = 0; i2 < str.length; i2++) {
    if (hash2 > MAX_SAFE_INTEGER) {
      const stringHash = (hash2 / seed2).toString();
      hash2 = parseInt(stringHash, 10);
    }
    hash2 = hash2 + seed + str.charCodeAt(i2);
  }
  return hash2;
};
const getAvatarFallbackInitials = function () {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  const namesByWhitespace = name.replace(INVALID_INITIAL_REGEX, "").split(" ").slice(0, 3).filter(x2 => !!x2);
  const calculatedInitials = namesByWhitespace.map(n2 => n2.charAt(0)).join().replaceAll(",", "").toUpperCase();
  return calculatedInitials;
};
const getAvatarFallbackColor = name => {
  if (!name) {
    return void 0;
  }
  const nameHash = BKDRHash(name);
  const avatarColorKeys = Object.keys(UserAvatarColorVariant);
  return avatarColorKeys[nameHash % avatarColorKeys.length];
};
const UserAvatarFallback = _ref68 => {
  let {
    name,
    delayMs
  } = _ref68;
  return /* @__PURE__ */jsx($cddcb0b647441e34$export$fb8d7f40caaeea67, {
    delayMs,
    children: name ? /* @__PURE__ */jsx(InitialsText, {
      children: getAvatarFallbackInitials(name)
    }) : /* @__PURE__ */jsx(Icon, {
      variant: "gray",
      size: "inherit",
      icon: faUser_2,
      rootProps: {
        role: "img",
        "aria-label": "Site visitor avatar"
      }
    })
  });
};
const UserAvatar = forwardRef((_ref69, forwardedRef) => {
  let {
    size,
    imageUrl,
    name,
    status,
    rootProps,
    ...props
  } = _ref69;
  const avatarColor = !imageUrl && !!name ? getAvatarFallbackColor(name) : void 0;
  const avatarStatus = status ? UserAvatarStatusIndicatorMap[status] : void 0;
  const tooltipContentStatus = status ? `(${UserAvatarStatusTooltipMap[status]})` : "";
  const tooltipContent = name ? `${name} ${tooltipContentStatus}` : "Site Visitor";
  const AvatarRoot = name ? KnownUserAvatarRoot : UnknownUserAvatarRoot;
  const fallbackDelay = imageUrl ? AVATAR_FALLBACK_DELAY$1 : 0;
  return /* @__PURE__ */jsx(AvatarTooltip, {
    content: tooltipContent,
    children: /* @__PURE__ */jsxs(AvatarRoot, {
      size,
      color: avatarColor,
      ref: forwardedRef,
      ...props,
      ...rootProps,
      children: [/* @__PURE__ */jsx(AvatarImage, {
        src: imageUrl != null ? imageUrl : void 0,
        alt: `${name}'s avatar`
      }), /* @__PURE__ */jsx(UserAvatarFallback, {
        name: name != null ? name : void 0,
        delayMs: fallbackDelay
      }), status && /* @__PURE__ */jsx(AvatarIndicator, {
        size,
        children: /* @__PURE__ */jsx(StatusIndicator, {
          variant: avatarStatus,
          size
        })
      })]
    })
  });
});
UserAvatar.displayName = "UserAvatar";
var UserAvatarStatusEnum = /* @__PURE__ */(UserAvatarStatusEnum2 => {
  UserAvatarStatusEnum2["AVAILABLE"] = "available";
  UserAvatarStatusEnum2["AWAY"] = "away";
  UserAvatarStatusEnum2["CHAT_LIMIT"] = "chat-limit";
  return UserAvatarStatusEnum2;
})(UserAvatarStatusEnum || {});
var faBuildings$1 = {};
Object.defineProperty(faBuildings$1, "__esModule", {
  value: true
});
var faBuildings_2 = faBuildings$1.faBuildings = void 0;
const faBuildings = {
  prefix: "fas",
  iconName: "faBuildings",
  icon: [512, 512, [], "", "M464 0h-224C213.5 0 192 21.49 192 48v80.01L48 128c-26.51 0-48 21.49-48 48v304c0 17.67 14.33 32 32 32L480 512c17.67 0 32-14.33 32-32V48C512 21.49 490.5 0 464 0zM128 336c0 8.836-7.164 16-16 16h-32c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 16-16h32c8.836 0 16 7.162 16 16V336zM128 240c0 8.836-7.164 16-16 16h-32c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 16-16h32c8.836 0 16 7.162 16 16V240zM320 304c0 8.836-7.164 16-16 16h-32C263.2 320 256 312.8 256 304v-32C256 263.2 263.2 256 272 256h32C312.8 256 320 263.2 320 272V304zM320 208C320 216.8 312.8 224 304 224h-32C263.2 224 256 216.8 256 208v-32C256 167.2 263.2 160 272 160h32C312.8 160 320 167.2 320 176V208zM320 112C320 120.8 312.8 128 304 128h-32C263.2 128 256 120.8 256 112v-32C256 71.16 263.2 64 272 64h32C312.8 64 320 71.16 320 80V112zM448 304c0 8.836-7.164 16-16 16h-32C391.2 320 384 312.8 384 304v-32C384 263.2 391.2 256 400 256h32C440.8 256 448 263.2 448 272V304zM448 208C448 216.8 440.8 224 432 224h-32C391.2 224 384 216.8 384 208v-32C384 167.2 391.2 160 400 160h32C440.8 160 448 167.2 448 176V208zM448 112C448 120.8 440.8 128 432 128h-32C391.2 128 384 120.8 384 112v-32C384 71.16 391.2 64 400 64h32C440.8 64 448 71.16 448 80V112z"]
};
faBuildings_2 = faBuildings$1.faBuildings = faBuildings;
const AccountAvatarRootWithImage = styled(BaseAvatarRoot);
const FallbackAccountAvatarRoot = styled(BaseAvatarRoot, {
  backgroundColor: "$gray2",
  border: "1px solid $gray6",
  color: "$gray9"
});
const AVATAR_FALLBACK_DELAY = 600;
const AccountAvatar = forwardRef((_ref70, forwardedRef) => {
  let {
    size,
    imageUrl,
    name,
    rootProps,
    ...props
  } = _ref70;
  const AccountAvatarRoot = imageUrl ? AccountAvatarRootWithImage : FallbackAccountAvatarRoot;
  const fallbackDelay = imageUrl ? AVATAR_FALLBACK_DELAY : 0;
  return /* @__PURE__ */jsx(AvatarTooltip, {
    content: name,
    children: /* @__PURE__ */jsxs(AccountAvatarRoot, {
      size,
      ref: forwardedRef,
      ...props,
      ...rootProps,
      children: [/* @__PURE__ */jsx(AvatarImage, {
        src: imageUrl != null ? imageUrl : void 0,
        alt: `${name}'s avatar`
      }), /* @__PURE__ */jsx($cddcb0b647441e34$export$fb8d7f40caaeea67, {
        delayMs: fallbackDelay,
        children: /* @__PURE__ */jsx(Icon, {
          variant: "gray",
          size: "inherit",
          icon: faBuildings_2,
          rootProps: {
            role: "img",
            "aria-label": name ? `${name}'s avatar` : "unknown account avatar"
          }
        })
      })]
    })
  });
});
AccountAvatar.displayName = "AccountAvatar";
function _isPlaceholder(a2) {
  return a2 != null && typeof a2 === "object" && a2["@@functional/placeholder"] === true;
}
function _curry1(fn) {
  return function f1(a2) {
    if (arguments.length === 0 || _isPlaceholder(a2)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
function _curry2(fn) {
  return function f2(a2, b2) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a2) ? f2 : _curry1(function (_b) {
          return fn(a2, _b);
        });
      default:
        return _isPlaceholder(a2) && _isPlaceholder(b2) ? f2 : _isPlaceholder(a2) ? _curry1(function (_a) {
          return fn(_a, b2);
        }) : _isPlaceholder(b2) ? _curry1(function (_b) {
          return fn(a2, _b);
        }) : fn(a2, b2);
    }
  };
}
function _arity(n2, fn) {
  switch (n2) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
  };
}
var curryN = /* @__PURE__ */_curry2(function curryN2(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});
var curryN$1 = curryN;
function _curry3(fn) {
  return function f3(a2, b2, c2) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a2) ? f3 : _curry2(function (_b, _c) {
          return fn(a2, _b, _c);
        });
      case 2:
        return _isPlaceholder(a2) && _isPlaceholder(b2) ? f3 : _isPlaceholder(a2) ? _curry2(function (_a, _c) {
          return fn(_a, b2, _c);
        }) : _isPlaceholder(b2) ? _curry2(function (_b, _c) {
          return fn(a2, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a2, b2, _c);
        });
      default:
        return _isPlaceholder(a2) && _isPlaceholder(b2) && _isPlaceholder(c2) ? f3 : _isPlaceholder(a2) && _isPlaceholder(b2) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c2);
        }) : _isPlaceholder(a2) && _isPlaceholder(c2) ? _curry2(function (_a, _c) {
          return fn(_a, b2, _c);
        }) : _isPlaceholder(b2) && _isPlaceholder(c2) ? _curry2(function (_b, _c) {
          return fn(a2, _b, _c);
        }) : _isPlaceholder(a2) ? _curry1(function (_a) {
          return fn(_a, b2, c2);
        }) : _isPlaceholder(b2) ? _curry1(function (_b) {
          return fn(a2, _b, c2);
        }) : _isPlaceholder(c2) ? _curry1(function (_c) {
          return fn(a2, b2, _c);
        }) : fn(a2, b2, c2);
    }
  };
}
var _isArray = Array.isArray || function _isArray2(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};
function _isTransformer(obj) {
  return obj != null && typeof obj["@@transducer/step"] === "function";
}
function _dispatchable(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === "function") {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}
var _xfBase = {
  init: function () {
    return this.xf["@@transducer/init"]();
  },
  result: function (result) {
    return this.xf["@@transducer/result"](result);
  }
};
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}
function _isString(x2) {
  return Object.prototype.toString.call(x2) === "[object String]";
}
var _isArrayLike = /* @__PURE__ */_curry1(function isArrayLike(x2) {
  if (_isArray(x2)) {
    return true;
  }
  if (!x2) {
    return false;
  }
  if (typeof x2 !== "object") {
    return false;
  }
  if (_isString(x2)) {
    return false;
  }
  if (x2.nodeType === 1) {
    return !!x2.length;
  }
  if (x2.length === 0) {
    return true;
  }
  if (x2.length > 0) {
    return x2.hasOwnProperty(0) && x2.hasOwnProperty(x2.length - 1);
  }
  return false;
});
var _isArrayLike$1 = _isArrayLike;
var XWrap = /* @__PURE__ */function () {
  function XWrap2(fn) {
    this.f = fn;
  }
  XWrap2.prototype["@@transducer/init"] = function () {
    throw new Error("init not implemented on XWrap");
  };
  XWrap2.prototype["@@transducer/result"] = function (acc) {
    return acc;
  };
  XWrap2.prototype["@@transducer/step"] = function (acc, x2) {
    return this.f(acc, x2);
  };
  return XWrap2;
}();
function _xwrap(fn) {
  return new XWrap(fn);
}
var bind = /* @__PURE__ */_curry2(function bind2(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});
var bind$1 = bind;
function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf["@@transducer/step"](acc, list[idx]);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    idx += 1;
  }
  return xf["@@transducer/result"](acc);
}
function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf["@@transducer/step"](acc, step.value);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    step = iter.next();
  }
  return xf["@@transducer/result"](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
  return xf["@@transducer/result"](obj[methodName](bind$1(xf["@@transducer/step"], xf), acc));
}
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _reduce(fn, acc, list) {
  if (typeof fn === "function") {
    fn = _xwrap(fn);
  }
  if (_isArrayLike$1(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list["fantasy-land/reduce"] === "function") {
    return _methodReduce(fn, acc, list, "fantasy-land/reduce");
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === "function") {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === "function") {
    return _methodReduce(fn, acc, list, "reduce");
  }
  throw new TypeError("reduce: list must be array or iterable");
}
var XMap = /* @__PURE__ */function () {
  function XMap2(f2, xf) {
    this.xf = xf;
    this.f = f2;
  }
  XMap2.prototype["@@transducer/init"] = _xfBase.init;
  XMap2.prototype["@@transducer/result"] = _xfBase.result;
  XMap2.prototype["@@transducer/step"] = function (result, input) {
    return this.xf["@@transducer/step"](result, this.f(input));
  };
  return XMap2;
}();
var _xmap = /* @__PURE__ */_curry2(function _xmap2(f2, xf) {
  return new XMap(f2, xf);
});
var _xmap$1 = _xmap;
function _has(prop3, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop3);
}
var toString$2 = Object.prototype.toString;
var _isArguments = /* @__PURE__ */function () {
  return toString$2.call(arguments) === "[object Arguments]" ? function _isArguments2(x2) {
    return toString$2.call(x2) === "[object Arguments]";
  } : function _isArguments2(x2) {
    return _has("callee", x2);
  };
}();
var _isArguments$1 = _isArguments;
var hasEnumBug = ! /* @__PURE__ */{
  toString: null
}.propertyIsEnumerable("toString");
var nonEnumerableProps = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
var hasArgsEnumBug = /* @__PURE__ */function () {
  return arguments.propertyIsEnumerable("length");
}();
var contains = function contains2(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
var keys = typeof Object.keys === "function" && !hasArgsEnumBug ? /* @__PURE__ */_curry1(function keys2(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /* @__PURE__ */_curry1(function keys3(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop3, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments$1(obj);
  for (prop3 in obj) {
    if (_has(prop3, obj) && (!checkArgsLength || prop3 !== "length")) {
      ks[ks.length] = prop3;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop3 = nonEnumerableProps[nIdx];
      if (_has(prop3, obj) && !contains(ks, prop3)) {
        ks[ks.length] = prop3;
      }
      nIdx -= 1;
    }
  }
  return ks;
});
var keys$1 = keys;
var map = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["fantasy-land/map", "map"], _xmap$1, function map2(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case "[object Function]":
      return curryN$1(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case "[object Object]":
      return _reduce(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys$1(functor));
    default:
      return _map(fn, functor);
  }
}));
var map$1 = map;
var _isInteger = Number.isInteger || function _isInteger2(n2) {
  return n2 << 0 === n2;
};
var nth = /* @__PURE__ */_curry2(function nth2(offset2, list) {
  var idx = offset2 < 0 ? list.length + offset2 : offset2;
  return _isString(list) ? list.charAt(idx) : list[idx];
});
var nth$1 = nth;
var paths = /* @__PURE__ */_curry2(function paths2(pathsArray, obj) {
  return pathsArray.map(function (paths3) {
    var val = obj;
    var idx = 0;
    var p2;
    while (idx < paths3.length) {
      if (val == null) {
        return;
      }
      p2 = paths3[idx];
      val = _isInteger(p2) ? nth$1(p2, val) : val[p2];
      idx += 1;
    }
    return val;
  });
});
var paths$1 = paths;
var path = /* @__PURE__ */_curry2(function path2(pathAr, obj) {
  return paths$1([pathAr], obj)[0];
});
var path$1 = path;
var prop = /* @__PURE__ */_curry2(function prop2(p2, obj) {
  return path$1([p2], obj);
});
var prop$1 = prop;
var curry = /* @__PURE__ */_curry1(function curry2(fn) {
  return curryN$1(fn.length, fn);
});
var curry$1 = curry;
function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j2;
    var result = [];
    var idx = 0;
    var ilen = list.length;
    while (idx < ilen) {
      if (_isArrayLike$1(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j2 = 0;
        jlen = value.length;
        while (j2 < jlen) {
          result[result.length] = value[j2];
          j2 += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
}
function _forceReduced(x2) {
  return {
    "@@transducer/value": x2,
    "@@transducer/reduced": true
  };
}
var preservingReduced = function (xf) {
  return {
    "@@transducer/init": _xfBase.init,
    "@@transducer/result": function (result) {
      return xf["@@transducer/result"](result);
    },
    "@@transducer/step": function (result, input) {
      var ret = xf["@@transducer/step"](result, input);
      return ret["@@transducer/reduced"] ? _forceReduced(ret) : ret;
    }
  };
};
var _flatCat = function _xcat(xf) {
  var rxf = preservingReduced(xf);
  return {
    "@@transducer/init": _xfBase.init,
    "@@transducer/result": function (result) {
      return rxf["@@transducer/result"](result);
    },
    "@@transducer/step": function (result, input) {
      return !_isArrayLike$1(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
    }
  };
};
var _flatCat$1 = _flatCat;
var _xchain = /* @__PURE__ */_curry2(function _xchain2(f2, xf) {
  return map$1(f2, _flatCat$1(xf));
});
var _xchain$1 = _xchain;
var chain = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["fantasy-land/chain", "chain"], _xchain$1, function chain2(fn, monad) {
  if (typeof monad === "function") {
    return function (x2) {
      return fn(monad(x2))(x2);
    };
  }
  return _makeFlat(false)(map$1(fn, monad));
}));
var chain$1 = chain;
var type = /* @__PURE__ */_curry1(function type2(val) {
  return val === null ? "Null" : val === void 0 ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var type$1 = type;
function _checkForMethod(methodname, fn) {
  return function () {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return _isArray(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}
var slice = /* @__PURE__ */_curry3( /* @__PURE__ */_checkForMethod("slice", function slice2(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var slice$1 = slice;
function _identity(x2) {
  return x2;
}
var identity = /* @__PURE__ */_curry1(_identity);
var identity$1 = identity;
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
function _includesWith(pred, x2, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x2, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
function _functionName(f2) {
  var match = String(f2).match(/^function (\w*)/);
  return match == null ? "" : match[1];
}
function _objectIs(a2, b2) {
  if (a2 === b2) {
    return a2 !== 0 || 1 / a2 === 1 / b2;
  } else {
    return a2 !== a2 && b2 !== b2;
  }
}
var _objectIs$1 = typeof Object.is === "function" ? Object.is : _objectIs;
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a2 = _arrayFromIterator(aIterator);
  var b2 = _arrayFromIterator(bIterator);
  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }
  return !_includesWith(function (b3, aItem) {
    return !_includesWith(eq, aItem, b3);
  }, b2, a2);
}
function _equals(a2, b2, stackA, stackB) {
  if (_objectIs$1(a2, b2)) {
    return true;
  }
  var typeA = type$1(a2);
  if (typeA !== type$1(b2)) {
    return false;
  }
  if (a2 == null || b2 == null) {
    return false;
  }
  if (typeof a2["fantasy-land/equals"] === "function" || typeof b2["fantasy-land/equals"] === "function") {
    return typeof a2["fantasy-land/equals"] === "function" && a2["fantasy-land/equals"](b2) && typeof b2["fantasy-land/equals"] === "function" && b2["fantasy-land/equals"](a2);
  }
  if (typeof a2.equals === "function" || typeof b2.equals === "function") {
    return typeof a2.equals === "function" && a2.equals(b2) && typeof b2.equals === "function" && b2.equals(a2);
  }
  switch (typeA) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof a2.constructor === "function" && _functionName(a2.constructor) === "Promise") {
        return a2 === b2;
      }
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof a2 === typeof b2 && _objectIs$1(a2.valueOf(), b2.valueOf()))) {
        return false;
      }
      break;
    case "Date":
      if (!_objectIs$1(a2.valueOf(), b2.valueOf())) {
        return false;
      }
      break;
    case "Error":
      return a2.name === b2.name && a2.message === b2.message;
    case "RegExp":
      if (!(a2.source === b2.source && a2.global === b2.global && a2.ignoreCase === b2.ignoreCase && a2.multiline === b2.multiline && a2.sticky === b2.sticky && a2.unicode === b2.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a2) {
      return stackB[idx] === b2;
    }
    idx -= 1;
  }
  switch (typeA) {
    case "Map":
      if (a2.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a2.entries(), b2.entries(), stackA.concat([a2]), stackB.concat([b2]));
    case "Set":
      if (a2.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a2.values(), b2.values(), stackA.concat([a2]), stackB.concat([b2]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return false;
  }
  var keysA = keys$1(a2);
  if (keysA.length !== keys$1(b2).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a2]);
  var extendedStackB = stackB.concat([b2]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b2) && _equals(b2[key], a2[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}
var equals = /* @__PURE__ */_curry2(function equals2(a2, b2) {
  return _equals(a2, b2, [], []);
});
var equals$1 = equals;
function _indexOf(list, a2, idx) {
  var inf, item;
  if (typeof list.indexOf === "function") {
    switch (typeof a2) {
      case "number":
        if (a2 === 0) {
          inf = 1 / a2;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a2 !== a2) {
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === "number" && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        return list.indexOf(a2, idx);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return list.indexOf(a2, idx);
      case "object":
        if (a2 === null) {
          return list.indexOf(a2, idx);
        }
    }
  }
  while (idx < list.length) {
    if (equals$1(list[idx], a2)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}
function _includes(a2, list) {
  return _indexOf(list, a2, 0) >= 0;
}
function _quote(s2) {
  var escaped = s2.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}
var pad = function pad2(n2) {
  return (n2 < 10 ? "0" : "") + n2;
};
var _toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString2(d2) {
  return d2.toISOString();
} : function _toISOString3(d2) {
  return d2.getUTCFullYear() + "-" + pad(d2.getUTCMonth() + 1) + "-" + pad(d2.getUTCDate()) + "T" + pad(d2.getUTCHours()) + ":" + pad(d2.getUTCMinutes()) + ":" + pad(d2.getUTCSeconds()) + "." + (d2.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};
var _toISOString$1 = _toISOString;
function _complement(f2) {
  return function () {
    return !f2.apply(this, arguments);
  };
}
function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}
function _isObject(x2) {
  return Object.prototype.toString.call(x2) === "[object Object]";
}
var XFilter = /* @__PURE__ */function () {
  function XFilter2(f2, xf) {
    this.xf = xf;
    this.f = f2;
  }
  XFilter2.prototype["@@transducer/init"] = _xfBase.init;
  XFilter2.prototype["@@transducer/result"] = _xfBase.result;
  XFilter2.prototype["@@transducer/step"] = function (result, input) {
    return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
  };
  return XFilter2;
}();
var _xfilter = /* @__PURE__ */_curry2(function _xfilter2(f2, xf) {
  return new XFilter(f2, xf);
});
var _xfilter$1 = _xfilter;
var filter = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["filter"], _xfilter$1, function (pred, filterable) {
  return _isObject(filterable) ? _reduce(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, keys$1(filterable)) : _filter(pred, filterable);
}));
var filter$1 = filter;
var reject = /* @__PURE__ */_curry2(function reject2(pred, filterable) {
  return filter$1(_complement(pred), filterable);
});
var reject$1 = reject;
function _toString(x2, seen) {
  var recur = function recur2(y2) {
    var xs = seen.concat([x2]);
    return _includes(y2, xs) ? "<Circular>" : _toString(y2, xs);
  };
  var mapPairs = function (obj, keys4) {
    return _map(function (k2) {
      return _quote(k2) + ": " + recur(obj[k2]);
    }, keys4.slice().sort());
  };
  switch (Object.prototype.toString.call(x2)) {
    case "[object Arguments]":
      return "(function() { return arguments; }(" + _map(recur, x2).join(", ") + "))";
    case "[object Array]":
      return "[" + _map(recur, x2).concat(mapPairs(x2, reject$1(function (k2) {
        return /^\d+$/.test(k2);
      }, keys$1(x2)))).join(", ") + "]";
    case "[object Boolean]":
      return typeof x2 === "object" ? "new Boolean(" + recur(x2.valueOf()) + ")" : x2.toString();
    case "[object Date]":
      return "new Date(" + (isNaN(x2.valueOf()) ? recur(NaN) : _quote(_toISOString$1(x2))) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof x2 === "object" ? "new Number(" + recur(x2.valueOf()) + ")" : 1 / x2 === -Infinity ? "-0" : x2.toString(10);
    case "[object String]":
      return typeof x2 === "object" ? "new String(" + recur(x2.valueOf()) + ")" : _quote(x2);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof x2.toString === "function") {
        var repr = x2.toString();
        if (repr !== "[object Object]") {
          return repr;
        }
      }
      return "{" + mapPairs(x2, keys$1(x2)).join(", ") + "}";
  }
}
var toString = /* @__PURE__ */_curry1(function toString2(val) {
  return _toString(val, []);
});
var toString$1 = toString;
var _Set = /* @__PURE__ */function () {
  function _Set2() {
    this._nativeSet = typeof Set === "function" ? /* @__PURE__ */new Set() : null;
    this._items = {};
  }
  _Set2.prototype.add = function (item) {
    return !hasOrAdd(item, true, this);
  };
  _Set2.prototype.has = function (item) {
    return hasOrAdd(item, false, this);
  };
  return _Set2;
}();
function hasOrAdd(item, shouldAdd, set) {
  var type3 = typeof item;
  var prevSize, newSize;
  switch (type3) {
    case "string":
    case "number":
      if (item === 0 && 1 / item === -Infinity) {
        if (set._items["-0"]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items["-0"] = true;
          }
          return false;
        }
      }
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type3 in set._items)) {
          if (shouldAdd) {
            set._items[type3] = {};
            set._items[type3][item] = true;
          }
          return false;
        } else if (item in set._items[type3]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type3][item] = true;
          }
          return false;
        }
      }
    case "boolean":
      if (type3 in set._items) {
        var bIdx = item ? 1 : 0;
        if (set._items[type3][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type3][bIdx] = true;
          }
          return false;
        }
      } else {
        if (shouldAdd) {
          set._items[type3] = item ? [false, true] : [true, false];
        }
        return false;
      }
    case "function":
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type3 in set._items)) {
          if (shouldAdd) {
            set._items[type3] = [item];
          }
          return false;
        }
        if (!_includes(item, set._items[type3])) {
          if (shouldAdd) {
            set._items[type3].push(item);
          }
          return false;
        }
        return true;
      }
    case "undefined":
      if (set._items[type3]) {
        return true;
      } else {
        if (shouldAdd) {
          set._items[type3] = true;
        }
        return false;
      }
    case "object":
      if (item === null) {
        if (!set._items["null"]) {
          if (shouldAdd) {
            set._items["null"] = true;
          }
          return false;
        }
        return true;
      }
    default:
      type3 = Object.prototype.toString.call(item);
      if (!(type3 in set._items)) {
        if (shouldAdd) {
          set._items[type3] = [item];
        }
        return false;
      }
      if (!_includes(item, set._items[type3])) {
        if (shouldAdd) {
          set._items[type3].push(item);
        }
        return false;
      }
      return true;
  }
}
var _Set$1 = _Set;
var XDrop = /* @__PURE__ */function () {
  function XDrop2(n2, xf) {
    this.xf = xf;
    this.n = n2;
  }
  XDrop2.prototype["@@transducer/init"] = _xfBase.init;
  XDrop2.prototype["@@transducer/result"] = _xfBase.result;
  XDrop2.prototype["@@transducer/step"] = function (result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }
    return this.xf["@@transducer/step"](result, input);
  };
  return XDrop2;
}();
var _xdrop = /* @__PURE__ */_curry2(function _xdrop2(n2, xf) {
  return new XDrop(n2, xf);
});
var _xdrop$1 = _xdrop;
var drop = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["drop"], _xdrop$1, function drop2(n2, xs) {
  return slice$1(Math.max(0, n2), Infinity, xs);
}));
var drop$1 = drop;
var takeLast = /* @__PURE__ */_curry2(function takeLast2(n2, xs) {
  return drop$1(n2 >= 0 ? xs.length - n2 : 0, xs);
});
var takeLast$1 = takeLast;
var uniqBy = /* @__PURE__ */_curry2(function uniqBy2(fn, list) {
  var set = new _Set$1();
  var result = [];
  var idx = 0;
  var appliedItem, item;
  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});
var uniqBy$1 = uniqBy;
var uniq = /* @__PURE__ */uniqBy$1(identity$1);
var uniq$1 = uniq;
var memoizeWith = /* @__PURE__ */_curry2(function memoizeWith2(mFn, fn) {
  var cache = {};
  return _arity(fn.length, function () {
    var key = mFn.apply(this, arguments);
    if (!_has(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});
var memoizeWith$1 = memoizeWith;
var zipObj = /* @__PURE__ */_curry2(function zipObj2(keys4, values) {
  var idx = 0;
  var len = Math.min(keys4.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys4[idx]] = values[idx];
    idx += 1;
  }
  return out;
});
var zipObj$1 = zipObj;
const pause = async ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
const delay = async (fn, ms) => {
  await pause(ms);
  await fn();
};
curry$1(list => chain$1(zipObj$1, map$1(prop$1("id")))(list));
memoizeWith$1(toString$1, (selected, all) => uniq$1([...selected, ...all]));
const BannerThemeVariant = {
  beta: {
    backgroundColor: "$purple2",
    borderBottom: "2px solid $purple9"
  },
  new: {
    backgroundColor: "$indigo2",
    borderBottom: "2px solid $indigo8"
  },
  upgrade: {
    backgroundColor: "$pink2",
    borderBottom: "2px solid $pink8"
  },
  info: {
    backgroundColor: "$blue2",
    borderBottom: "2px solid $blue8"
  },
  warning: {
    backgroundColor: "$yellow2",
    borderBottom: "2px solid $yellow8"
  },
  danger: {
    backgroundColor: "$red2",
    borderBottom: "2px solid $red8"
  }
};
const slideOut$1 = keyframes({
  from: {
    transform: "translateY(0)",
    opacity: 1
  },
  to: {
    transform: "translateY(-100%)",
    opacity: 0
  }
});
const StyledBannerContainer = styled(Box, {
  display: "grid",
  paddingX: "$1",
  gridTemplateColumns: "1fr $4",
  rowGap: "$1",
  columnGap: "$1",
  minHeight: "40px",
  width: "100%",
  justifyContent: "space-evenly",
  alignItems: "center",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none"
  },
  '&[data-state="dismissed"]': {
    animationIterationCount: 1,
    animation: `${slideOut$1} 400ms ease-out`
  },
  variants: {
    variant: BannerThemeVariant
  }
});
const StyledBannerContent = styled(Flex, {
  paddingY: "10px"
});
const BannerContent = _ref71 => {
  let {
    children
  } = _ref71;
  return /* @__PURE__ */jsx(StyledBannerContent, {
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    children
  });
};
const BannerActions = _ref72 => {
  let {
    children
  } = _ref72;
  return /* @__PURE__ */jsx(ButtonGroup, {
    children
  });
};
const BannerRoot = forwardRef((_ref73, forwardedRef) => {
  let {
    variant = "info",
    onClose,
    rootProps,
    children,
    ...props
  } = _ref73;
  const [dataState, setDataState] = useState("visible");
  const onBannerDismiss = useCallback(evt => {
    setDataState("dismissed");
    onClose && delay(() => onClose(evt), 400);
  }, [onClose]);
  return /* @__PURE__ */jsxs(StyledBannerContainer, {
    variant,
    ref: forwardedRef,
    ...props,
    ...rootProps,
    "data-state": dataState,
    children: [/* @__PURE__ */jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      children
    }), /* @__PURE__ */jsx(Flex, {
      children: /* @__PURE__ */jsx(IconButton, {
        title: "dismiss banner",
        icon: faXmark_2,
        onClick: onBannerDismiss
      })
    })]
  });
});
const Banner = {
  Root: BannerRoot,
  Actions: BannerActions,
  Content: BannerContent
};
BannerRoot.displayName = "Banner";
const $054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$054eb8030ebde76e$var$Collection, $054eb8030ebde76e$var$useCollection, $054eb8030ebde76e$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2("Toast");
const [$054eb8030ebde76e$var$createToastContext, $054eb8030ebde76e$export$8a359da18fbc9073] = $c512c27ab02ef895$export$50c7b4e9d9f19c1("Toast", [$054eb8030ebde76e$var$createCollectionScope]);
const [$054eb8030ebde76e$var$ToastProviderProvider, $054eb8030ebde76e$var$useToastProviderContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$PROVIDER_NAME);
const $054eb8030ebde76e$export$f5d03d415824e0e = props => {
  const {
    __scopeToast,
    label = "Notification",
    duration = 5e3,
    swipeDirection = "right",
    swipeThreshold = 50,
    children
  } = props;
  const [viewport, setViewport] = useState(null);
  const [toastCount, setToastCount] = useState(0);
  const isFocusedToastEscapeKeyDownRef = useRef(false);
  const isClosePausedRef = useRef(false);
  return /* @__PURE__ */createElement$1($054eb8030ebde76e$var$Collection.Provider, {
    scope: __scopeToast
  }, /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastProviderProvider, {
    scope: __scopeToast,
    label,
    duration,
    swipeDirection,
    swipeThreshold,
    toastCount,
    viewport,
    onViewportChange: setViewport,
    onToastAdd: useCallback(() => setToastCount(prevCount => prevCount + 1), []),
    onToastRemove: useCallback(() => setToastCount(prevCount => prevCount - 1), []),
    isFocusedToastEscapeKeyDownRef,
    isClosePausedRef
  }, children));
};
$054eb8030ebde76e$export$f5d03d415824e0e.propTypes = {
  label(props) {
    if (props.label && typeof props.label === "string" && !props.label.trim()) {
      const error = `Invalid prop \`label\` supplied to \`${$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
      return new Error(error);
    }
    return null;
  }
};
const $054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = ["F8"];
const $054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $054eb8030ebde76e$export$6192c2425ecfd989 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    hotkey = $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY,
    label = "Notifications ({hotkey})",
    ...viewportProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
  const getItems = $054eb8030ebde76e$var$useCollection(__scopeToast);
  const wrapperRef = useRef(null);
  const headFocusProxyRef = useRef(null);
  const tailFocusProxyRef = useRef(null);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onViewportChange);
  const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
  const hasToasts = context.toastCount > 0;
  useEffect(() => {
    const handleKeyDown = event => {
      var _ref$current;
      const isHotkeyPressed = hotkey.every(key => event[key] || event.code === key);
      if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [hotkey]);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    const viewport = ref.current;
    if (wrapper && viewport) {
      const handlePause = () => {
        const pauseEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_PAUSE);
        viewport.dispatchEvent(pauseEvent);
        context.isClosePausedRef.current = true;
      };
      const handleResume = () => {
        const resumeEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_RESUME);
        viewport.dispatchEvent(resumeEvent);
        context.isClosePausedRef.current = false;
      };
      wrapper.addEventListener("focusin", handlePause);
      wrapper.addEventListener("focusout", handleResume);
      wrapper.addEventListener("pointerenter", handlePause);
      wrapper.addEventListener("pointerleave", handleResume);
      window.addEventListener("blur", handlePause);
      window.addEventListener("focus", handleResume);
      return () => {
        wrapper.removeEventListener("focusin", handlePause);
        wrapper.removeEventListener("focusout", handleResume);
        wrapper.removeEventListener("pointerenter", handlePause);
        wrapper.removeEventListener("pointerleave", handleResume);
        window.removeEventListener("blur", handlePause);
        window.removeEventListener("focus", handleResume);
      };
    }
  }, [context.isClosePausedRef]);
  const getSortedTabbableCandidates = useCallback(_ref74 => {
    let {
      tabbingDirection
    } = _ref74;
    const toastItems = getItems();
    const tabbableCandidates = toastItems.map(toastItem => {
      const toastNode = toastItem.ref.current;
      const toastTabbableCandidates = [toastNode, ...$054eb8030ebde76e$var$getTabbableCandidates(toastNode)];
      return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
    });
    return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
  }, [getItems]);
  useEffect(() => {
    const viewport = ref.current;
    if (viewport) {
      const handleKeyDown = event => {
        const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
        const isTabKey = event.key === "Tab" && !isMetaKey;
        if (isTabKey) {
          const focusedElement = document.activeElement;
          const isTabbingBackwards = event.shiftKey;
          const targetIsViewport = event.target === viewport;
          if (targetIsViewport && isTabbingBackwards) {
            var _headFocusProxyRef$cu;
            (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
            return;
          }
          const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
          const sortedCandidates = getSortedTabbableCandidates({
            tabbingDirection
          });
          const index2 = sortedCandidates.findIndex(candidate => candidate === focusedElement);
          if ($054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index2 + 1))) event.preventDefault();else {
            var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
            isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
          }
        }
      };
      viewport.addEventListener("keydown", handleKeyDown);
      return () => viewport.removeEventListener("keydown", handleKeyDown);
    }
  }, [getItems, getSortedTabbableCandidates]);
  return /* @__PURE__ */createElement$1($5cb92bef7577960e$export$aecb2ddcb55c95be, {
    ref: wrapperRef,
    role: "region",
    "aria-label": label.replace("{hotkey}", hotkeyLabel),
    tabIndex: -1,
    style: {
      pointerEvents: hasToasts ? void 0 : "none"
    }
  }, hasToasts && /* @__PURE__ */createElement$1($054eb8030ebde76e$var$FocusProxy, {
    ref: headFocusProxyRef,
    onFocusFromOutsideViewport: () => {
      const tabbableCandidates = getSortedTabbableCandidates({
        tabbingDirection: "forwards"
      });
      $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
    }
  }), /* @__PURE__ */createElement$1($054eb8030ebde76e$var$Collection.Slot, {
    scope: __scopeToast
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.ol, _extends({
    tabIndex: -1
  }, viewportProps, {
    ref: composedRefs
  }))), hasToasts && /* @__PURE__ */createElement$1($054eb8030ebde76e$var$FocusProxy, {
    ref: tailFocusProxyRef,
    onFocusFromOutsideViewport: () => {
      const tabbableCandidates = getSortedTabbableCandidates({
        tabbingDirection: "backwards"
      });
      $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
    }
  }));
});
const $054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $054eb8030ebde76e$var$FocusProxy = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    onFocusFromOutsideViewport,
    ...proxyProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
  return /* @__PURE__ */createElement$1($ea1ef594cf570d83$export$439d29a4e110a164, _extends({
    "aria-hidden": true,
    tabIndex: 0
  }, proxyProps, {
    ref: forwardedRef,
    style: {
      position: "fixed"
    },
    onFocus: event => {
      var _context$viewport;
      const prevFocusedElement = event.relatedTarget;
      const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
      if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
    }
  }));
});
const $054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $054eb8030ebde76e$export$8d8dc7d5f743331b = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    forceMount,
    open: openProp,
    defaultOpen,
    onOpenChange,
    ...toastProps
  } = props;
  const [open = true, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || open
  }, /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastImpl, _extends({
    open
  }, toastProps, {
    ref: forwardedRef,
    onClose: () => setOpen(false),
    onSwipeStart: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeStart, event => {
      event.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeMove, event => {
      const {
        x: x2,
        y: y2
      } = event.detail.delta;
      event.currentTarget.setAttribute("data-swipe", "move");
      event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x2}px`);
      event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y2}px`);
    }),
    onSwipeCancel: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeCancel, event => {
      event.currentTarget.setAttribute("data-swipe", "cancel");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeEnd, event => {
      const {
        x: x2,
        y: y2
      } = event.detail.delta;
      event.currentTarget.setAttribute("data-swipe", "end");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
      event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x2}px`);
      event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y2}px`);
      setOpen(false);
    })
  })));
});
const [$054eb8030ebde76e$var$ToastInteractiveProvider, $054eb8030ebde76e$var$useToastInteractiveContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$TOAST_NAME, {
  isInteractive: false,
  onClose() {}
});
const $054eb8030ebde76e$var$ToastImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    type: type3 = "foreground",
    duration: durationProp,
    open,
    onClose,
    onEscapeKeyDown,
    onSwipeStart,
    onSwipeMove,
    onSwipeCancel,
    onSwipeEnd,
    ...toastProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const pointerStartRef = useRef(null);
  const swipeDeltaRef = useRef(null);
  const duration1 = durationProp || context.duration;
  const closeTimerStartTimeRef = useRef(0);
  const closeTimerRemainingTimeRef = useRef(duration1);
  const closeTimerRef = useRef(0);
  const {
    onToastAdd,
    onToastRemove
  } = context;
  const handleClose = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(() => {
    var _ref$current2, _context$viewport2;
    const isFocusInToast = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.contains(document.activeElement);
    if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
    onClose();
  });
  const startTimer = useCallback(duration => {
    if (!duration || duration === Infinity) return;
    window.clearTimeout(closeTimerRef.current);
    closeTimerStartTimeRef.current = new Date().getTime();
    closeTimerRef.current = window.setTimeout(handleClose, duration);
  }, [handleClose]);
  useEffect(() => {
    const viewport = context.viewport;
    if (viewport) {
      const handleResume = () => {
        startTimer(closeTimerRemainingTimeRef.current);
      };
      const handlePause = () => {
        const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
        closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
        window.clearTimeout(closeTimerRef.current);
      };
      viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
      viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
      return () => {
        viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
        viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
      };
    }
  }, [context.viewport, duration1, startTimer]);
  useEffect(() => {
    if (open && !context.isClosePausedRef.current) startTimer(duration1);
  }, [open, duration1, context.isClosePausedRef, startTimer]);
  useEffect(() => {
    onToastAdd();
    return () => onToastRemove();
  }, [onToastAdd, onToastRemove]);
  if (!context.viewport) return null;
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastAnnounce, {
    __scopeToast,
    role: "status",
    "aria-live": type3 === "foreground" ? "assertive" : "polite",
    "aria-atomic": true
  }, props.children), /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastInteractiveProvider, {
    scope: __scopeToast,
    isInteractive: true,
    onClose: handleClose
  }, /* @__PURE__ */createPortal( /* @__PURE__ */createElement$1($054eb8030ebde76e$var$Collection.ItemSlot, {
    scope: __scopeToast
  }, /* @__PURE__ */createElement$1($5cb92bef7577960e$export$be92b6f5f03c0fe9, {
    asChild: true,
    onEscapeKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onEscapeKeyDown, () => {
      if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
      context.isFocusedToastEscapeKeyDownRef.current = false;
    })
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.li, _extends({
    tabIndex: 0,
    "data-state": open ? "open" : "closed",
    "data-swipe-direction": context.swipeDirection
  }, toastProps, {
    ref: composedRefs,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...props.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
      if (event.key !== "Escape") return;
      onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
      if (!event.nativeEvent.defaultPrevented) {
        context.isFocusedToastEscapeKeyDownRef.current = true;
        handleClose();
      }
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, event => {
      if (event.button !== 0) return;
      pointerStartRef.current = {
        x: event.clientX,
        y: event.clientY
      };
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, event => {
      if (!pointerStartRef.current) return;
      const x2 = event.clientX - pointerStartRef.current.x;
      const y2 = event.clientY - pointerStartRef.current.y;
      const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
      const isHorizontalSwipe = ["left", "right"].includes(context.swipeDirection);
      const clamp = ["left", "up"].includes(context.swipeDirection) ? Math.min : Math.max;
      const clampedX = isHorizontalSwipe ? clamp(0, x2) : 0;
      const clampedY = !isHorizontalSwipe ? clamp(0, y2) : 0;
      const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
      const delta = {
        x: clampedX,
        y: clampedY
      };
      const eventDetail = {
        originalEvent: event,
        delta
      };
      if (hasSwipeMoveStarted) {
        swipeDeltaRef.current = delta;
        $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
          discrete: false
        });
      } else if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
        swipeDeltaRef.current = delta;
        $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
          discrete: false
        });
        event.target.setPointerCapture(event.pointerId);
      } else if (Math.abs(x2) > moveStartBuffer || Math.abs(y2) > moveStartBuffer) pointerStartRef.current = null;
    }),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, event1 => {
      const delta = swipeDeltaRef.current;
      event1.target.releasePointerCapture(event1.pointerId);
      swipeDeltaRef.current = null;
      pointerStartRef.current = null;
      if (delta) {
        const toast = event1.currentTarget;
        const eventDetail = {
          originalEvent: event1,
          delta
        };
        if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
          discrete: true
        });else $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
          discrete: true
        });
        toast.addEventListener("click", event => event.preventDefault(), {
          once: true
        });
      }
    })
  })))), context.viewport)));
});
$054eb8030ebde76e$var$ToastImpl.propTypes = {
  type(props) {
    if (props.type && !["foreground", "background"].includes(props.type)) {
      const error = `Invalid prop \`type\` supplied to \`${$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
      return new Error(error);
    }
    return null;
  }
};
const $054eb8030ebde76e$var$ToastAnnounce = props => {
  const {
    __scopeToast,
    children,
    ...announceProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
  const [renderAnnounceText, setRenderAnnounceText] = useState(false);
  const [isAnnounced, setIsAnnounced] = useState(false);
  const [fragment, setFragment] = useState();
  const [rootFragmentNode, setRootFragmentNode] = useState(null);
  const announceTextContent = useMemo(() => {
    return rootFragmentNode ? $054eb8030ebde76e$var$getAnnounceTextContent(rootFragmentNode) : null;
  }, [rootFragmentNode]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    setFragment(new DocumentFragment());
  }, []);
  $054eb8030ebde76e$var$useNextFrame(() => setRenderAnnounceText(true));
  useEffect(() => {
    const timer = window.setTimeout(() => setIsAnnounced(true), 1e3);
    return () => window.clearTimeout(timer);
  }, []);
  return isAnnounced ? null : /* @__PURE__ */createElement$1(Fragment$1, null, fragment && /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c, {
    container: fragment,
    ref: setRootFragmentNode
  }, context.label, " ", children), /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c, {
    asChild: true
  }, /* @__PURE__ */createElement$1($ea1ef594cf570d83$export$439d29a4e110a164, announceProps, renderAnnounceText && announceTextContent)));
};
const $054eb8030ebde76e$export$16d42d7c29b95a4 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    ...titleProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, titleProps, {
    ref: forwardedRef
  }));
});
const $054eb8030ebde76e$export$ecddd96c53621d9a = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    ...descriptionProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, descriptionProps, {
    ref: forwardedRef
  }));
});
const $054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $054eb8030ebde76e$export$3019feecfda683d2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    altText,
    ...actionProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastInteractiveContext($054eb8030ebde76e$var$ACTION_NAME, props.__scopeToast);
  if (!altText) return null;
  return context.isInteractive ? /* @__PURE__ */createElement$1($054eb8030ebde76e$export$811e70f61c205839, _extends({}, actionProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1("span", null, altText);
});
$054eb8030ebde76e$export$3019feecfda683d2.propTypes = {
  altText(props) {
    if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$054eb8030ebde76e$var$ACTION_NAME}\``);
    return null;
  }
};
const $054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $054eb8030ebde76e$export$811e70f61c205839 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    ...closeProps
  } = props;
  const interactiveContext = $054eb8030ebde76e$var$useToastInteractiveContext($054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
  return interactiveContext.isInteractive ? /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.button, _extends({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, interactiveContext.onClose)
  })) : null;
});
function $054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, _ref75) {
  let {
    discrete
  } = _ref75;
  const currentTarget = detail.originalEvent.currentTarget;
  const event = new CustomEvent(name, {
    bubbles: true,
    cancelable: true,
    detail
  });
  if (handler) currentTarget.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(currentTarget, event);else currentTarget.dispatchEvent(event);
}
const $054eb8030ebde76e$var$isDeltaInDirection = function (delta, direction) {
  let threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const deltaX = Math.abs(delta.x);
  const deltaY = Math.abs(delta.y);
  const isDeltaX = deltaX > deltaY;
  if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;else return !isDeltaX && deltaY > threshold;
};
function $054eb8030ebde76e$var$useNextFrame() {
  let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  const fn = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    let raf1 = 0;
    let raf2 = 0;
    raf1 = window.requestAnimationFrame(() => raf2 = window.requestAnimationFrame(fn));
    return () => {
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
    };
  }, [fn]);
}
function $054eb8030ebde76e$var$getAnnounceTextContent(container) {
  const textContent = [];
  const childNodes = Array.from(container.childNodes);
  childNodes.forEach(node => {
    if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
    if ($054eb8030ebde76e$var$isHTMLElement(node)) {
      const isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
      if (!isHidden) textContent.push(...$054eb8030ebde76e$var$getAnnounceTextContent(node));
    }
  });
  return textContent;
}
function $054eb8030ebde76e$var$isHTMLElement(node) {
  return node.nodeType === node.ELEMENT_NODE;
}
function $054eb8030ebde76e$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: node => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $054eb8030ebde76e$var$focusFirst(candidates) {
  const previouslyFocusedElement = document.activeElement;
  return candidates.some(candidate => {
    if (candidate === previouslyFocusedElement) return true;
    candidate.focus();
    return document.activeElement !== previouslyFocusedElement;
  });
}
const $054eb8030ebde76e$export$2881499e37b75b9a = $054eb8030ebde76e$export$f5d03d415824e0e;
const $054eb8030ebde76e$export$d5c6c08dc2d3ca7 = $054eb8030ebde76e$export$6192c2425ecfd989;
const $054eb8030ebde76e$export$be92b6f5f03c0fe9 = $054eb8030ebde76e$export$8d8dc7d5f743331b;
const $054eb8030ebde76e$export$f99233281efd08a0 = $054eb8030ebde76e$export$16d42d7c29b95a4;
const $054eb8030ebde76e$export$393edc798c47379d = $054eb8030ebde76e$export$ecddd96c53621d9a;
const $054eb8030ebde76e$export$e19cd5f9376f8cee = $054eb8030ebde76e$export$3019feecfda683d2;
const $054eb8030ebde76e$export$f39c2d165cd861fe = $054eb8030ebde76e$export$811e70f61c205839;
const ToastVariant = {
  info: {
    backgroundColor: "$blue1",
    borderColor: "$blue6"
  },
  success: {
    backgroundColor: "$green1",
    borderColor: "$green6"
  },
  error: {
    backgroundColor: "$red1",
    borderColor: "$red6"
  },
  warning: {
    backgroundColor: "$yellow1",
    borderColor: "$yellow4"
  }
};
const VIEWPORT_PADDING = 25;
const hide = keyframes({
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
});
const slideIn = keyframes({
  from: {
    transform: `translateY(calc(${VIEWPORT_PADDING}px - 100vh))`
  },
  to: {
    transform: "translateY(0)"
  }
});
const swipeOut = keyframes({
  from: {
    transform: "translateX(var(--radix-toasf-swipe-end-x))"
  },
  to: {
    transform: `translateX(calc(100% + ${VIEWPORT_PADDING}px))`
  }
});
const StyledToastViewport = styled($054eb8030ebde76e$export$d5c6c08dc2d3ca7, {
  $$viewportWidth: "400px",
  position: "fixed",
  top: 0,
  left: "calc(50vw - ($$viewportWidth / 2))",
  display: "flex",
  flexDirection: "column-reverse",
  alignItems: "flex-start",
  padding: VIEWPORT_PADDING,
  gap: "$1",
  maxWidth: "$$viewportWidth",
  listStyle: "none",
  zIndex: "$modal",
  outline: "none"
});
const StyledToastRoot = styled($054eb8030ebde76e$export$be92b6f5f03c0fe9, {
  boxShadow: "$raised08",
  padding: "$1",
  display: "flex",
  alignItems: "center",
  gap: "$2",
  paddingX: "$2",
  border: "1px solid",
  borderLeft: "5px solid",
  borderRadius: "0px $1 $1 0px",
  "@media (prefers-reduced-motion: no-preference)": {
    '&[data-state="open"]': {
      animation: `${slideIn} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
    },
    '&[data-state="closed"]': {
      animation: `${hide} 100ms ease-in`
    },
    '&[data-swipe="move"]': {
      transform: "translateX(var(--radix-toast-swipe-move-x))"
    },
    '&[data-swipe="cancel"]': {
      transform: "translateX(0)",
      transition: "transform 200ms ease-out"
    },
    '&[data-swipe="end"]': {
      animation: `${swipeOut} 100ms ease-out`
    }
  }
}, {
  variants: {
    variant: ToastVariant
  },
  defaultVariants: {
    variant: "info"
  }
});
const StyledToastContent = styled(Flex, {
  marginY: "-1px"
});
const StyledToastAction = styled($054eb8030ebde76e$export$e19cd5f9376f8cee, {
  marginRight: "-$1",
  marginY: "-3px"
});
const ToastBase = {
  Provider: $054eb8030ebde76e$export$2881499e37b75b9a,
  Root: StyledToastRoot,
  Title: $054eb8030ebde76e$export$f99233281efd08a0,
  Description: $054eb8030ebde76e$export$393edc798c47379d,
  Action: StyledToastAction,
  Close: $054eb8030ebde76e$export$f39c2d165cd861fe,
  Viewport: StyledToastViewport
};
const ToastContext = createContext$1({
  setToasts: () => {}
});
const ToastTypeMap = {
  info: "background",
  success: "foreground",
  warning: "background",
  error: "foreground"
};
const Toast = _ref76 => {
  let {
    message,
    variant = "info",
    action,
    options
  } = _ref76;
  var _a, _b;
  const type3 = (_a = options == null ? void 0 : options.type) != null ? _a : ToastTypeMap[variant];
  return /* @__PURE__ */jsxs(ToastBase.Root, {
    variant,
    type: type3,
    duration: options == null ? void 0 : options.duration,
    children: [/* @__PURE__ */jsxs(StyledToastContent, {
      gap: 1,
      alignItems: "center",
      children: [/* @__PURE__ */jsx(StatusIcon, {
        variant
      }), /* @__PURE__ */jsx(StatusMessageText, {
        variant: "body",
        color: variant,
        children: message
      })]
    }), action && /* @__PURE__ */jsx(ToastBase.Action, {
      asChild: true,
      altText: (_b = action.alt) != null ? _b : action.label,
      children: /* @__PURE__ */jsx(Button, {
        onClick: action.onClick,
        variant: "secondary",
        size: "small",
        children: action.label
      })
    })]
  }, message);
};
const Toasts = _ref77 => {
  let {
    toasts
  } = _ref77;
  return /* @__PURE__ */jsxs(ToastBase.Provider, {
    swipeDirection: "right",
    children: [toasts.map(_ref78 => {
      let {
        id,
        ...toastProps
      } = _ref78;
      return /* @__PURE__ */jsx(Toast, {
        ...toastProps
      }, id);
    }), /* @__PURE__ */jsx(ToastBase.Viewport, {})]
  });
};
const ToastProvider = _ref79 => {
  let {
    children
  } = _ref79;
  const [toasts, setToasts] = useState([]);
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(ToastContext.Provider, {
      value: {
        setToasts
      },
      children
    }), /* @__PURE__ */jsx(Toasts, {
      toasts
    })]
  });
};
var ToastVariantEnum = /* @__PURE__ */(ToastVariantEnum2 => {
  ToastVariantEnum2["INFO"] = "info";
  ToastVariantEnum2["SUCCESS"] = "success";
  ToastVariantEnum2["ERROR"] = "error";
  ToastVariantEnum2["WARNING"] = "warning";
  return ToastVariantEnum2;
})(ToastVariantEnum || {});
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let i2 = 0; i2 < 256; ++i2) {
  byteToHex.push((i2 + 256).toString(16).slice(1));
}
function unsafeStringify(arr) {
  let offset2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return (byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]]).toLowerCase();
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};
function v4(options, buf, offset2) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset2 = offset2 || 0;
    for (let i2 = 0; i2 < 16; ++i2) {
      buf[offset2 + i2] = rnds[i2];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
const useToast = () => {
  const {
    setToasts
  } = useContext(ToastContext);
  if (!setToasts) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  const triggerToast = useCallback(args => {
    setToasts(curr => [...takeLast$1(2, curr), {
      id: v4(),
      ...args
    }]);
  }, [setToasts]);
  return triggerToast;
};
var InlineAlertThemeVariantEnum = /* @__PURE__ */(InlineAlertThemeVariantEnum2 => {
  InlineAlertThemeVariantEnum2["BETA"] = "beta";
  InlineAlertThemeVariantEnum2["NEW"] = "new";
  InlineAlertThemeVariantEnum2["UPGRADE"] = "upgrade";
  InlineAlertThemeVariantEnum2["INFO"] = "info";
  InlineAlertThemeVariantEnum2["WARNING"] = "warning";
  InlineAlertThemeVariantEnum2["ERROR"] = "error";
  return InlineAlertThemeVariantEnum2;
})(InlineAlertThemeVariantEnum || {});
const InlineAlertThemeVariant = {
  beta: {
    border: "1px solid $purple6",
    borderTop: "4px solid $purple6"
  },
  new: {
    border: "1px solid $indigo6",
    borderTop: "4px solid $indigo6"
  },
  upgrade: {
    border: "1px solid $pink6",
    borderTop: "4px solid $pink6"
  },
  info: {
    backgroundColor: "$blue1",
    border: "1px solid $blue6",
    borderTop: "4px solid $blue6"
  },
  warning: {
    backgroundColor: "$yellow1",
    border: "1px solid $yellow4",
    borderTop: "4px solid $yellow4"
  },
  error: {
    backgroundColor: "$red1",
    border: "1px solid $red6",
    borderTop: "4px solid $red6"
  }
};
const slideOut = keyframes({
  from: {
    transform: "translateY(0)",
    opacity: 1
  },
  to: {
    transform: "translateY(-100%)",
    opacity: 0
  }
});
const DescriptionText = styled(Text, {
  color: "$gray10"
});
const InlineAlertContent = styled(Flex, {
  paddingY: "$2"
});
const CloseButtonContainer = styled(Flex, {
  padding: "$half"
});
const InlineAlertActions = styled(Flex, {
  height: "100%",
  variants: {
    withPadding: {
      true: {
        paddingRight: "$2"
      }
    }
  }
});
const ScaledStatusIcon = styled(StatusIcon, {
  scale: 1.2
});
const StyledInlineAlertContainer = styled(Box, {
  display: "grid",
  paddingLeft: "$2",
  gridAutoFlow: "column",
  gap: "$3",
  minHeight: "$6",
  width: "100%",
  alignItems: "center",
  backgroundColor: "$white",
  borderTopRightRadius: "$1",
  borderTopLeftRadius: "$1",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none"
  },
  '&[data-state="dismissed"]': {
    animationIterationCount: 1,
    animation: `${slideOut} 400ms ease-out`
  },
  variants: {
    variant: InlineAlertThemeVariant
  }
});
const FeatureBadgeTitlePrefixes = ["new", "beta", "upgrade"];
const StatusIconTitlePrefixes = ["info", "warning", "error"];
const InlineAlertTitleWithFeatureBadge = _ref80 => {
  let {
    title,
    variant
  } = _ref80;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(FeatureBadge, {
      bolt: true,
      variant
    }), /* @__PURE__ */jsx(Header, {
      variant: "h3",
      children: title
    })]
  });
};
const InlineAlertTitleWithStatusIcon = _ref81 => {
  let {
    title,
    variant
  } = _ref81;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(ScaledStatusIcon, {
      variant
    }), /* @__PURE__ */jsx(Header, {
      variant: "h3",
      children: title
    })]
  });
};
const InlineAlertTitle = _ref82 => {
  let {
    title,
    variant
  } = _ref82;
  const typedVariant = variant;
  return /* @__PURE__ */jsxs(Flex, {
    alignItems: "center",
    children: [FeatureBadgeTitlePrefixes.includes(typedVariant) && /* @__PURE__ */jsx(InlineAlertTitleWithFeatureBadge, {
      title,
      variant
    }), StatusIconTitlePrefixes.includes(typedVariant) && /* @__PURE__ */jsx(InlineAlertTitleWithStatusIcon, {
      title,
      variant
    })]
  });
};
const InlineAlertDescription = _ref83 => {
  let {
    children
  } = _ref83;
  return /* @__PURE__ */jsx(DescriptionText, {
    children
  });
};
const InlineAlert = forwardRef((_ref84, forwardedRef) => {
  let {
    variant,
    title,
    dismissable,
    description,
    actionText,
    onActionClick,
    onClose,
    rootProps,
    ...props
  } = _ref84;
  const [dataState, setDataState] = useState("visible");
  const onAlertDismiss = useCallback(evt => {
    setDataState("dismissed");
    onClose && delay(() => onClose(evt), 400);
  }, [onClose]);
  return /* @__PURE__ */jsxs(StyledInlineAlertContainer, {
    "data-state": dataState,
    variant,
    ref: forwardedRef,
    ...props,
    ...rootProps,
    children: [/* @__PURE__ */jsxs(InlineAlertContent, {
      direction: "column",
      gap: "half",
      children: [/* @__PURE__ */jsx(InlineAlertTitle, {
        variant,
        title
      }), /* @__PURE__ */jsx(InlineAlertDescription, {
        children: description
      })]
    }), /* @__PURE__ */jsxs(InlineAlertActions, {
      alignItems: "stretch",
      justifyContent: "flex-end",
      gap: "half",
      withPadding: !!actionText && !dismissable,
      children: [actionText && /* @__PURE__ */jsx(Flex, {
        alignItems: "center",
        children: /* @__PURE__ */jsx(Button, {
          variant: "secondary",
          onClick: onActionClick,
          children: actionText
        })
      }), dismissable && /* @__PURE__ */jsx(CloseButtonContainer, {
        alignItems: "flex-start",
        children: /* @__PURE__ */jsx(IconButton, {
          title: "dismiss alert",
          icon: faXmark_2,
          onClick: onAlertDismiss
        })
      })]
    })]
  });
});
InlineAlert.displayName = "InlineAlert";
export { AccountAvatar, Banner, BannerRoot, Box, Button, ButtonBaseColorVariantEnum as ButtonColorVariantEnum, ButtonGroup, ButtonSizeVariant, ButtonSizeVariantEnum, Card, CardComponent, ChatLimitBorderCompoundVariant, Checkbox, CheckboxClassNames, CheckboxGroup, CircleLoader, FeatureBadge, FeatureBadgeSizeVariantEnum, FeatureBadgeVariantEnum, Flex, FlexAlignItemsVariant, FlexAlignItemsVariantEnum, FlexDirectionVariant, FlexDirectionVariantEnum, FlexGapVariant, FlexJustifyContentVariant, FlexJustifyContentVariantEnum, FlexWrapVariant, FlexWrapVariantEnum, Header, HeaderVariant, HeaderVariantEnum, HighlightText, HighlightTextColorVariantEnum, Icon, IconButton, ButtonBaseColorVariantEnum as IconButtonColorVariantEnum, IconButtonSizeVariant, IconButtonSizeVariantEnum, IconColorVariant, IconColorVariantEnum, IconSizeVariant, IconSizeVariantEnum, InfoBadge, InfoBadgeSizeVariantEnum, InfoBadgeVariantEnum, InlineAlert, InlineAlertDescription, InlineAlertThemeVariant, InlineAlertThemeVariantEnum, InputNumber, InputPartial, InputText, Link, LinkSizeVariant, LinkSizeVariantEnum, LinkTypeVariant, LinkTypeVariantEnum, LoaderStyleVariant, LoaderStyleVariantEnum, Modal, ModalBase, NotificationBadge, Paper, PaperElevationVariant, RadioGroup, RadioItem, ServerThemeProvider, SimpleGrid, SimpleGridAlignItemsVariant, SimpleGridAlignItemsVariantEnum, SimpleGridColumnsVariant, SimpleGridGapVariant, SimpleGridJustifyItemsVariant, SimpleGridJustifyItemsVariantEnum, StatusBadge, StatusBadgeSizeVariantEnum, StatusBadgeVariantEnum, StatusIcon, StatusIconFillColorMap, StatusIndicator, StatusIndicatorColorVariant, StatusIndicatorColorVariantEnum, StatusIndicatorSizeVariant, StatusIndicatorSizeVariantEnum, StatusMessage, StatusMessageLabelColorVariant, StatusMessageVariantTypeEnum, StyledPaperBase, Text, TextGutterBottomVariant, TextTruncateVariant, TextVariant, TextVariantEnum, Textarea, ThemeProvider, ToastProvider, ToastVariantEnum, Toggle, UserAvatar, UserAvatarFallback, UserAvatarStatusEnum, applyGlobalStyles, config$1 as config, css$1 as css, getCssText, keyframes, styled, theme, useToast };